import { useState, useEffect, useMemo, useCallback } from "react";

// ─── API CONFIGURATION ────────────────────────────────────────────────────────
const API_URL = "";  // Empty = relative URL, proxied through Nginx on same domain

const api = {
  token: null,
  setToken(t) { this.token = t; if(t) localStorage.setItem("cms_token",t); else localStorage.removeItem("cms_token");
    localStorage.removeItem("cms_current_user"); },
  getToken() { return this.token || localStorage.getItem("cms_token"); },
  async req(method, path, body) {
    const opts = {
      method,
      headers: { "Content-Type":"application/json", ...(this.getToken()?{"Authorization":"Bearer "+this.getToken()}:{}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    };
    const res = await fetch(API_URL + path, opts);
    const data = await res.json();
    if (res.status === 401) {
      api.setToken(null);
      localStorage.removeItem("cms_token");
      window.location.reload();
      return null;
    }
    if (!res.ok) throw new Error(data.error || "API error");
    return data;
  },
  get(path)         { return this.req("GET",    path); },
  post(path, body)  { return this.req("POST",   path, body); },
  put(path, body)   { return this.req("PUT",    path, body); },
  patch(path, body) { return this.req("PATCH",  path, body); },
  del(path)         { return this.req("DELETE", path); },
};

// ─── MASTER DATA (15 firms — Geeta Rani, Pankaj, Sharvil, Pulkit removed) ────
const DEFAULT_FIRMS = [
  "Kyra Consultancy Service",
  "Jawahar Consultancy",
  "Alpha Accounting Solution",
  "Kulbhushan And Associates",
  "Kaha Associates",
  "Kyra Financial Services",
  "H.M Enterprises",
  "Brij Mohan Sharma",
  "Shub Labh Consultants",
  "Nexa Accounting Group",
  "Chande Kala Sharma",
  "Ritu Sharma",
  "KSS Wealth Management IMF",
  "Brij Mohan Sharma & Ritu Sharma",
  "Vijay Kumar Sharma",
];
const FIRM_COLORS = [
  "#4F46E5","#0891B2","#059669","#D97706","#DC2626",
  "#7C3AED","#0D9488","#B45309","#BE185D","#1D4ED8",
  "#0369A1","#15803D","#B91C1C","#6D28D9","#0F766E",
  "#92400E","#1D4ED8","#7E22CE","#047857","#065F46",
];
const DEFAULT_FIRM_ACCOUNTS = {
  "Kyra Consultancy Service":       [{ bank:"SBI Bank",            acNo:"32695936245",          acType:"Savings" }],
  "Jawahar Consultancy":            [{ bank:"HDFC Bank",           acNo:"50200029752530",  ifsc:"HDFC0000138",  acType:"Current" }],
  "Alpha Accounting Solution":      [{ bank:"Canara Bank",         acNo:"1401201501314" }],
  "Kulbhushan And Associates":      [{ bank:"Kotak Mahindra Bank", acNo:"2522120001883",   ifsc:"KKBK0000252" },
                                     { bank:"ICICI Bank",          acNo:"189505500100",    ifsc:"ICIC0001895" }],
  "Kaha Associates":                [{ bank:"Kotak Mahindra Bank", acNo:"3947318559",      ifsc:"KKBK0000252" },
                                     { bank:"Axis Bank",           acNo:"924020063618757", ifsc:"UTIB0005259" }],
  "Kyra Financial Services":        [{ bank:"Kotak Mahindra Bank", acNo:"4911633746",      ifsc:"KKBK0000252" },
                                     { bank:"ICICI Bank",          acNo:"189505500153",    ifsc:"ICIC0000449" }],
  "H.M Enterprises":                [{ bank:"Kotak Mahindra Bank", acNo:"4347140542",      ifsc:"KKBK0000252" },
                                     { bank:"HDFC Bank",           acNo:"50200071712008",  ifsc:"HDFC0002784" }],
  "Brij Mohan Sharma":              [{ bank:"ICICI Bank",          acNo:"16201508822",     ifsc:"ICIC0001895" },
                                     { bank:"ICICI Bank",          acNo:"8205500692",      ifsc:"ICIC0001895" },
                                     { bank:"Bank Of Maharashtra", acNo:"60261473755",     ifsc:"MAHB0001412" },
                                     { bank:"Bank Of Maharashtra", acNo:"68005241243",     ifsc:"MAHB0001493" },
                                     { bank:"Post Office",         acNo:"10004951322" },
                                     { bank:"Kotak Mahindra Bank", acNo:"2520140021416",   ifsc:"KKBK0000252" },
                                     { bank:"Punjab & Sind Bank",  acNo:"1791000236936",   ifsc:"PSIB0000179" },
                                     { bank:"Indian Bank",         acNo:"7821196657",      ifsc:"IDIB000K591" }],
  "Shub Labh Consultants":          [{ bank:"Axis Bank",           acNo:"924020063618771", ifsc:"UTIB0005259" }],
  "Nexa Accounting Group":          [{ bank:"Axis Bank",           acNo:"924020063618764", ifsc:"UTIB0005259" },
                                     { bank:"Indian Bank",         acNo:"7907707066",      ifsc:"IDIB000K591" }],
  "Chande Kala Sharma":             [{ bank:"Kotak Mahindra Bank", acNo:"7811627259",      ifsc:"KKBK0000252" },
                                     { bank:"Federal Bank",        acNo:"19740200000859",  ifsc:"FDRL0001974" },
                                     { bank:"Punjab & Sind Bank",  acNo:"1791000234546",   ifsc:"PSIB0000179" }],
  "Ritu Sharma":                    [{ bank:"Kotak Mahindra Bank", acNo:"8611678908",      ifsc:"KKBK0000252" },
                                     { bank:"ICICI Bank",          acNo:"189501502800",    ifsc:"ICIC0001895" },
                                     { bank:"Yes Bank",            acNo:"4250700006318",   ifsc:"YESB0000042" },
                                     { bank:"Punjab & Sind Bank",  acNo:"1791000234663",   ifsc:"PSIB0000179" },
                                     { bank:"Post Office",         acNo:"648711252" }],
  "KSS Wealth Management IMF":      [{ bank:"ICICI Bank",          acNo:"189505001892",    ifsc:"ICIC0001895" }],
  "Brij Mohan Sharma & Ritu Sharma":[{ bank:"Post Office",         acNo:"10004951322" }],
  "Vijay Kumar Sharma":             [{ bank:"Kotak Mahindra Bank", acNo:"2813962742",      ifsc:"KKBK0000252" }],
};
const BANKS = [
  "","SBI Bank","HDFC Bank","ICICI Bank","Kotak Mahindra Bank","Axis Bank",
  "PNB","Canara Bank","UCO Bank","Indian Bank","Central Bank","Yes Bank",
  "Federal Bank","Punjab & Sind Bank","Bank Of Maharashtra","Bank of Baroda",
  "Union Bank","Post Office","Other"
];
const STATUSES  = ["Pending","In Collection","Cleared","Bounced"];
const ROLES     = ["Admin","Manager","Staff","Viewer"];
const STORAGE_KEY = "cms_v10";
const DEFAULT_AGING_DAYS = 30; // warn after this many days pending

// ─── DEFAULT USERS ────────────────────────────────────────────────────────────
const DEFAULT_USERS = [
  { id:1, name:"Admin",      username:"admin",     password:"admin123",  role:"Admin",   active:true },
  { id:2, name:"Manager",    username:"manager",   password:"mgr123",    role:"Manager", active:true },
  { id:3, name:"Staff",      username:"staff",     password:"staff123",  role:"Staff",   active:true },
  { id:4, name:"CA Latisha", username:"calatisha", password:"India@1980",role:"Admin",   active:true },
  { id:5, name:"CA Sachin",  username:"casachin",  password:"Mysachin@1980",role:"Admin",active:true },
];

// ─── DEFAULT PARTY MASTER ────────────────────────────────────────────────────
const DEFAULT_PARTIES = [
  "Dalla Seed Store","Dulla Trading Co","Hussain Port And","Dashmesh Bottling Food",
  "Pop Athas","Royal Touch Turbans","Treading Centre","Kishan Gola Group",
  "Gupta Mata Lal","Mahajan Linden Seat","Shure Punjab Travelers",
  "Angin Singh Filling Stn","SMO CHC TIBBA","Kulbhushan And Associates",
  "Nexa Accounting Group","Kyra Financial Services","Shub Labh Consultants",
];
const SEED_DATA = [
  { id:1,  type:"inward",  firm:"Kyra Financial Services",   date:"2026-01-30", depositDate:"2026-01-30", fromTo:"Dalla Seed Store",        drawer:"UCO Bank",           drawee:"Kotak Mahindra Bank", depositedBy:"Kulbhushan And Associates", chequeNo:"000043", chequeDate:"2026-01-30", amount:14800, status:"Cleared",       realisationDate:"2026-02-05", remarks:"" },
  { id:2,  type:"inward",  firm:"Kyra Financial Services",   date:"2026-01-30", depositDate:"2026-01-30", fromTo:"Dulla Trading Co",         drawer:"UCO Bank",           drawee:"Kotak Mahindra Bank", depositedBy:"Kulbhushan And Associates", chequeNo:"000119", chequeDate:"2026-01-30", amount:13800, status:"Cleared",       realisationDate:"2026-02-06", remarks:"" },
  { id:3,  type:"inward",  firm:"Kyra Consultancy Service",  date:"2026-01-27", depositDate:"2026-01-27", fromTo:"Hussain Port And",         drawer:"Axis Bank",          drawee:"PNB",                 depositedBy:"Grovelands",               chequeNo:"060458", chequeDate:"2026-01-27", amount:18000, status:"Pending",       realisationDate:"",           remarks:"" },
  { id:4,  type:"inward",  firm:"H.M Enterprises",           date:"2026-01-27", depositDate:"2026-01-28", fromTo:"Dashmesh Bottling Food",   drawer:"Central Bank",       drawee:"Kotak Mahindra Bank", depositedBy:"Kulbhushan And Associates", chequeNo:"129735", chequeDate:"2026-01-30", amount:11850, status:"In Collection", realisationDate:"",           remarks:"" },
  { id:5,  type:"inward",  firm:"Kyra Consultancy Service",  date:"2026-01-27", depositDate:"2026-01-27", fromTo:"Pop Athas",                drawer:"PNB",                drawee:"PNB",                 depositedBy:"Grovelands",               chequeNo:"213456", chequeDate:"2026-01-25", amount:11850, status:"Cleared",       realisationDate:"2026-02-01", remarks:"" },
  { id:6,  type:"inward",  firm:"Kyra Financial Services",   date:"2026-01-23", depositDate:"2026-01-24", fromTo:"Royal Touch Turbans",      drawer:"Mahindra Bank",      drawee:"Kotak Mahindra Bank", depositedBy:"Kulbhushan And Associates", chequeNo:"830601", chequeDate:"2026-01-31", amount:11300, status:"Pending",       realisationDate:"",           remarks:"" },
  { id:7,  type:"inward",  firm:"Shub Labh Consultants",     date:"2026-01-21", depositDate:"2026-01-21", fromTo:"Treading Centre",          drawer:"Mahindra Bank",      drawee:"Kotak Mahindra Bank", depositedBy:"Kulbhushan And Associates", chequeNo:"830602", chequeDate:"2026-01-21", amount:33800, status:"Pending",       realisationDate:"",           remarks:"" },
  { id:8,  type:"inward",  firm:"H.M Enterprises",           date:"2026-01-21", depositDate:"2026-01-22", fromTo:"Kishan Gola Group",        drawer:"Punjab Bank",        drawee:"Kotak Mahindra Bank", depositedBy:"Kulbhushan And Associates", chequeNo:"906390", chequeDate:"2026-01-21", amount:15000, status:"Cleared",       realisationDate:"2026-01-28", remarks:"" },
  { id:9,  type:"inward",  firm:"Kyra Consultancy Service",  date:"2026-01-21", depositDate:"2026-01-21", fromTo:"Gupta Mata Lal",           drawer:"Canara Bank",        drawee:"Kotak Mahindra Bank", depositedBy:"Kulbhushan And Associates", chequeNo:"316301", chequeDate:"2026-01-20", amount:15001, status:"Pending",       realisationDate:"",           remarks:"" },
  { id:10, type:"inward",  firm:"Kyra Financial Services",   date:"2026-01-21", depositDate:"2026-01-21", fromTo:"Mahajan Linden Seat",      drawer:"HDFC Bank",          drawee:"Kotak Mahindra Bank", depositedBy:"Mahindra & Associates",    chequeNo:"000563", chequeDate:"2026-01-21", amount:17200, status:"Pending",       realisationDate:"",           remarks:"" },
  { id:11, type:"inward",  firm:"Jawahar Consultancy",       date:"2026-01-21", depositDate:"2026-01-21", fromTo:"Shure Punjab Travelers",   drawer:"Yes Bank",           drawee:"Axis Bank",           depositedBy:"Shub Labh Consultants",    chequeNo:"018450", chequeDate:"2026-01-21", amount:80000, status:"Cleared",       realisationDate:"2026-01-30", remarks:"" },
  { id:12, type:"inward",  firm:"Alpha Accounting Solution", date:"2026-01-21", depositDate:"2026-01-22", fromTo:"Angin Singh Filling Stn",  drawer:"HDFC Bank",          drawee:"Axis Bank",           depositedBy:"Shub Labh Consultants",    chequeNo:"000688", chequeDate:"2026-01-21", amount:12000, status:"In Collection", realisationDate:"",           remarks:"" },
  { id:13, type:"inward",  firm:"Kulbhushan And Associates", date:"2026-01-21", depositDate:"2026-01-21", fromTo:"SMO CHC TIBBA",            drawer:"PNB",                drawee:"PNB",                 depositedBy:"Kyra Financial Services",  chequeNo:"332502", chequeDate:"2026-01-21", amount:3560,  status:"Pending",       realisationDate:"",           remarks:"" },
  { id:14, type:"outward", firm:"Kyra Financial Services",   date:"2026-02-01", depositDate:"2026-02-01", fromTo:"Kulbhushan And Associates", drawer:"Kotak Mahindra Bank",drawee:"ICICI Bank",          depositedBy:"Kulbhushan And Associates", chequeNo:"100012", chequeDate:"2026-02-01", amount:25000, status:"Cleared",       realisationDate:"2026-02-03", remarks:"" },
  { id:15, type:"outward", firm:"H.M Enterprises",           date:"2026-02-05", depositDate:"2026-02-05", fromTo:"Nexa Accounting Group",    drawer:"HDFC Bank",          drawee:"Axis Bank",           depositedBy:"Nexa Accounting Group",    chequeNo:"500087", chequeDate:"2026-02-05", amount:18500, status:"Pending",       realisationDate:"",           remarks:"" },
];

const makeEmptyForm = (firms) => ({
  type:"inward", firm: firms[0] || "", date: new Date().toISOString().slice(0,10),
  depositDate: new Date().toISOString().slice(0,10),
  fromTo:"", drawer:"", drawee:"", depositedBy:"",
  drawerManual:"",
  draweeManual:"",
  chequeNo:"", chequeDate: new Date().toISOString().slice(0,10),
  amount:"", status:"Pending", realisationDate:"", remarks:"", chequeImage:""
});

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const fmt        = (n) => { const num=Number(n||0); return "₹"+(Number.isInteger(num)?num.toLocaleString("en-IN"):num.toLocaleString("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2})); };
const safePct    = (a,b) => b===0?0:Math.round((a/b)*100);
const monthLabel = (m) => { const [y,mo]=m.split("-"); return ["","Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][+mo]+" "+y; };
const daysSince  = (d) => { if(!d) return 0; const dt=new Date(d); return isNaN(dt)?0:Math.max(0,Math.floor((new Date()-dt)/86400000)); };
const displayVal = (v) => (v===null||v===undefined||v===""||v===0)?"—":v;
const nowISO     = () => new Date().toISOString().slice(0,10);
const thisMonth  = () => new Date().toISOString().slice(0,7);
const thisYear   = () => new Date().getFullYear().toString();

const STATUS_CFG = {
  Pending:         { bg:"#FEF3C7", color:"#92400E", border:"#FDE68A" },
  "In Collection": { bg:"#DBEAFE", color:"#1E40AF", border:"#BFDBFE" },
  Cleared:         { bg:"#D1FAE5", color:"#065F46", border:"#A7F3D0" },
  Bounced:         { bg:"#FEE2E2", color:"#991B1B", border:"#FECACA" },
};
const scfg = (s) => STATUS_CFG[s]||{bg:"#F1F5F9",color:"#475569",border:"#E2E8F0"};
const ROLE_CFG = {
  Admin:   { bg:"#FEE2E2", color:"#991B1B" },
  Manager: { bg:"#DBEAFE", color:"#1E40AF" },
  Staff:   { bg:"#D1FAE5", color:"#065F46" },
  Viewer:  { bg:"#F1F5F9", color:"#475569" },
};

const canEdit   = (role) => ["Admin","Manager","Staff"].includes(role);
const canAdmin  = (role) => ["Admin","Manager"].includes(role);
const canDelete = (role) => ["Admin","Manager"].includes(role);

// ─── EXPORT TO EXCEL CSV ──────────────────────────────────────────────────────
const exportExcel = (rows, filename) => {
  const BOM = "\uFEFF";
  const hdr = ["#","Date","Deposit Date","Type","Firm","Party (From/To)","Cheque No","Cheque Date","Amount","Drawer Bank","Drawee Bank","Deposited By","Status","Realisation Date","Remarks"];
  const data = rows.map(c => [
    c.id, c.date, c.depositDate||"", c.type, `"${c.firm}"`, `"${c.fromTo}"`,
    c.chequeNo, c.chequeDate, c.amount, c.drawer||"", c.drawee||"",
    `"${c.depositedBy||""}"`, c.status, c.realisationDate||"", `"${c.remarks||""}"`
  ]);
  const csv = BOM + [hdr,...data].map(r=>r.join(",")).join("\n");
  const a = document.createElement("a");
  a.href = "data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
  a.download = filename;
  a.click();
};

// ═══════════════════════════════════════════════════════════════════════════════
// LOGIN SCREEN — SmartCABuddy SaaS Style
// ═══════════════════════════════════════════════════════════════════════════════

function TrialBanner({ expires_at, status }) {
  if (!expires_at || status !== 'trial') return null;
  const days = Math.ceil((new Date(expires_at) - new Date()) / 86400000);
  if (days <= 0) return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.88)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'#fff',borderRadius:16,padding:'40px 48px',textAlign:'center',maxWidth:440}}>
        <div style={{fontSize:48,marginBottom:16}}>&#128274;</div>
        <h2 style={{color:'#0A1628',marginBottom:8}}>Your trial has ended</h2>
        <p style={{color:'#64748B',marginBottom:24}}>Your data is safe for 30 days. Subscribe to continue.</p>
        <a href='https://smartcabuddy.com/#pricing' target='_blank' rel='noreferrer'
          style={{display:'inline-block',background:'linear-gradient(135deg,#185FA5,#10B981)',color:'#fff',padding:'12px 32px',borderRadius:8,fontWeight:600,textDecoration:'none',fontSize:15}}>
          View Plans &amp; Subscribe
        </a>
        <p style={{marginTop:16,fontSize:12,color:'#94A3B8'}}>Questions? Email hello@smartcabuddy.com</p>
      </div>
    </div>
  );
  if (days <= 3) return (
    <div style={{background:days<=1?'#EF4444':'#F59E0B',color:'#fff',padding:'8px 20px',textAlign:'center',fontSize:13,fontWeight:600,zIndex:1000,position:'relative'}}>
      {days <= 1 ? 'Your trial expires today!' : 'Trial expires in ' + days + ' days - '}
      <a href='https://smartcabuddy.com/#pricing' target='_blank' rel='noreferrer' style={{color:'#fff',textDecoration:'underline',marginLeft:4}}>Subscribe now</a>
    </div>
  );
  return null;
}
const SCB_CSS = ".scb-page{min-height:100vh;display:grid;grid-template-columns:1fr 460px;font-family:'DM Sans',sans-serif;-webkit-font-smoothing:antialiased}\n.scb-left{background:#0A1628;display:flex;flex-direction:column;padding:40px 52px;overflow-y:auto;position:relative}\n.scb-left::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 50% at 10% 20%,rgba(24,95,165,.28) 0%,transparent 65%),radial-gradient(ellipse 45% 40% at 85% 75%,rgba(16,185,129,.12) 0%,transparent 60%),radial-gradient(ellipse 50% 35% at 60% 5%,rgba(55,138,221,.1) 0%,transparent 55%);pointer-events:none;z-index:0}\n.scb-left::after{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(55,138,221,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(55,138,221,.04) 1px,transparent 1px);background-size:52px 52px;mask-image:radial-gradient(ellipse 80% 80% at 50% 50%,black 20%,transparent 85%);-webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%,black 20%,transparent 85%);pointer-events:none;z-index:0}\n.scb-left>*{position:relative;z-index:1}\n.scb-logo{display:flex;align-items:center;gap:11px;margin-bottom:36px}\n.scb-logo-mark{width:40px;height:40px;background:linear-gradient(145deg,#185FA5,#378ADD);border-radius:10px;display:flex;align-items:center;justify-content:center;box-shadow:0 3px 12px rgba(24,95,165,.3);flex-shrink:0}\n.scb-logo-name{font-family:'DM Serif Display',serif;font-size:17px;color:#fff;letter-spacing:-.01em;line-height:1.1}\n.scb-logo-tag{font-size:9.5px;font-weight:600;color:rgba(55,138,221,.7);text-transform:uppercase;letter-spacing:.1em;margin-top:2px}\n.scb-live-badge{display:inline-flex;align-items:center;gap:7px;background:rgba(16,185,129,.12);border:1px solid rgba(16,185,129,.28);border-radius:24px;padding:5px 14px;font-size:11px;font-weight:600;color:#34D399;margin-bottom:20px;width:fit-content}\n.scb-live-dot{width:7px;height:7px;border-radius:50%;background:#10B981;animation:scbBlink 2s ease-in-out infinite}\n@keyframes scbBlink{0%,100%{opacity:1}50%{opacity:.35}}\n.scb-headline{font-family:'DM Serif Display',serif;font-size:clamp(28px,2.8vw,42px);color:#fff;line-height:1.12;letter-spacing:-.025em;margin-bottom:12px}\n.scb-grad{font-style:normal;background:linear-gradient(90deg,#378ADD 0%,#9B6FE8 50%,#E879C8 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}\n.scb-italic{display:block;font-style:italic;background:linear-gradient(90deg,#378ADD 0%,#9B6FE8 50%,#E879C8 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}\n.scb-tagline{font-size:13.5px;color:rgba(240,244,255,.5);line-height:1.7;max-width:460px;margin-bottom:32px}\n.scb-sec-label{font-size:10px;font-weight:700;color:rgba(240,244,255,.35);text-transform:uppercase;letter-spacing:.12em;margin-bottom:12px;display:flex;align-items:center;gap:8px}\n.scb-sec-label::after{content:'';flex:1;height:1px;background:linear-gradient(90deg,rgba(55,138,221,.2),transparent)}\n.scb-cat-tabs{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:14px}\n.scb-cat-tab{display:inline-flex;align-items:center;gap:5px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:20px;padding:4px 11px;font-size:10px;font-weight:600;color:rgba(240,244,255,.55);letter-spacing:.04em;cursor:default;transition:all .15s}\n.scb-cat-tab:hover{background:rgba(55,138,221,.12);border-color:rgba(55,138,221,.3);color:rgba(240,244,255,.85)}\n.scb-cat-dot{width:5px;height:5px;border-radius:50%;flex-shrink:0}\n.scb-feat-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:28px}\n.scb-feat{display:flex;align-items:flex-start;gap:11px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:10px;padding:11px 13px;cursor:default;transition:all .18s ease;position:relative;overflow:hidden}\n.scb-feat::before{content:'';position:absolute;left:0;top:0;bottom:0;width:3px;border-radius:10px 0 0 10px;opacity:0;transition:opacity .18s}\n.scb-feat:hover{background:rgba(55,138,221,.08);border-color:rgba(55,138,221,.22);box-shadow:0 2px 12px rgba(0,0,0,.2);transform:translateY(-1px)}\n.scb-feat:hover::before{opacity:1}\n.scb-feat.cb::before{background:#185FA5}.scb-feat.ct::before{background:#10B981}.scb-feat.ca::before{background:#EF9F27}.scb-feat.cp::before{background:#8B5CF6}.scb-feat.cr::before{background:#EF4444}.scb-feat.cg::before{background:#22C55E}\n.scb-feat-icon{width:30px;height:30px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .18s}\n.scb-feat:hover .scb-feat-icon{transform:scale(1.08)}\n.scb-feat-title{font-size:12px;font-weight:600;color:rgba(240,244,255,.92);line-height:1.3;margin-bottom:2px}\n.scb-feat-desc{font-size:10.5px;color:rgba(148,180,220,.75);line-height:1.4}\n.scb-stats{display:flex;border:1px solid rgba(255,255,255,.08);border-radius:12px;overflow:hidden;background:rgba(255,255,255,.03)}\n.scb-stat{flex:1;padding:14px 12px;text-align:center;border-right:1px solid rgba(255,255,255,.08);transition:background .15s}\n.scb-stat:last-child{border-right:none}\n.scb-stat:hover{background:rgba(55,138,221,.08)}\n.scb-sv{font-family:'DM Serif Display',serif;font-size:24px;color:#60A5FA;line-height:1;margin-bottom:4px;letter-spacing:-.01em}\n.scb-sl{font-size:10px;font-weight:600;color:rgba(148,180,220,.65);text-transform:uppercase;letter-spacing:.07em}\n.scb-left-foot{margin-top:auto;padding-top:20px;font-size:11.5px;color:rgba(148,180,220,.65);border-top:1px solid rgba(55,138,221,.12);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px}\n.scb-left-foot a{color:#378ADD;text-decoration:none;font-weight:600}\n.scb-left-foot a:hover{color:#60AEFF}\n.scb-right{background:#0C1526;display:flex;flex-direction:column;justify-content:center;padding:48px 40px;border-left:1px solid rgba(55,138,221,.1);position:relative;overflow-y:auto;min-width:0}\n.scb-form-card{background:rgba(255,255,255,.04);border:1px solid rgba(55,138,221,.14);border-radius:16px;padding:32px;box-shadow:0 4px 32px rgba(0,0,0,.25);margin-bottom:14px;position:relative;overflow:hidden}\n.scb-form-card::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,#185FA5,#378ADD,#10B981)}\n.scb-secure-chip{display:inline-flex;align-items:center;gap:6px;background:rgba(24,95,165,.15);border:1px solid rgba(55,138,221,.25);border-radius:6px;padding:3px 10px;font-size:10px;font-weight:700;color:#60A5FA;letter-spacing:.07em;text-transform:uppercase;margin-bottom:18px}\n.scb-form-title{font-family:'DM Serif Display',serif;font-size:24px;color:#fff;letter-spacing:-.02em;margin-bottom:4px}\n.scb-form-sub{font-size:12.5px;color:rgba(148,180,220,.6);margin-bottom:22px}\n.scb-trial-bar{display:flex;align-items:center;gap:10px;background:rgba(16,185,129,.08);border:1px solid rgba(16,185,129,.2);border-radius:9px;padding:10px 13px;margin-bottom:20px}\n.scb-trial-icon{width:28px;height:28px;border-radius:7px;background:rgba(16,185,129,.12);display:flex;align-items:center;justify-content:center;flex-shrink:0}\n.scb-trial-info{flex:1}\n.scb-trial-title{font-size:11.5px;font-weight:700;color:#34D399;line-height:1.2}\n.scb-trial-sub{font-size:10.5px;color:rgba(52,211,153,.55);margin-top:1px}\n.scb-trial-pill{background:#10B981;color:#fff;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:700;white-space:nowrap;flex-shrink:0}\n.scb-err{display:none;align-items:center;gap:8px;background:rgba(239,68,68,.1);border:1px solid rgba(239,68,68,.25);border-radius:8px;padding:9px 12px;font-size:12px;font-weight:500;color:#FCA5A5;margin-bottom:16px}\n.scb-err.show{display:flex}\n.scb-field{margin-bottom:16px}\n.scb-f-label{display:block;font-size:10.5px;font-weight:700;color:rgba(148,180,220,.7);text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px}\n.scb-f-wrap{position:relative}\n.scb-f-icon{position:absolute;left:12px;top:50%;transform:translateY(-50%);color:rgba(148,180,220,.4);pointer-events:none;display:flex;align-items:center}\n.scb-f-input{width:100%;background:rgba(255,255,255,.06);border:1.5px solid rgba(55,138,221,.2);border-radius:8px;padding:11px 12px 11px 38px;font-size:13.5px;font-family:'DM Sans',sans-serif;color:#fff;outline:none;transition:border-color .18s,background .18s,box-shadow .18s}\n.scb-f-input::placeholder{color:rgba(148,180,220,.35)}\n.scb-f-input:focus{border-color:rgba(55,138,221,.55);background:rgba(255,255,255,.09);box-shadow:0 0 0 3px rgba(24,95,165,.15)}\n.scb-pw-btn{position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:rgba(148,180,220,.45);padding:4px;display:flex;align-items:center;transition:color .15s}\n.scb-pw-btn:hover{color:#60A5FA}\n.scb-submit{width:100%;background:linear-gradient(90deg,#185FA5,#6B4BE8,#C44DD6);color:#fff;border:none;border-radius:9px;padding:13px 18px;font-size:14px;font-weight:700;font-family:'DM Sans',sans-serif;cursor:pointer;letter-spacing:.02em;display:flex;align-items:center;justify-content:center;gap:8px;transition:opacity .18s,transform .12s,box-shadow .18s;box-shadow:0 4px 20px rgba(107,75,232,.35);position:relative;overflow:hidden;margin-top:4px}\n.scb-submit::after{content:'';position:absolute;inset:0;background:linear-gradient(135deg,rgba(255,255,255,.12) 0%,transparent 60%);pointer-events:none}\n.scb-submit:hover{opacity:.9;transform:translateY(-1px);box-shadow:0 6px 28px rgba(107,75,232,.45)}\n.scb-submit:active{transform:translateY(0)}\n.scb-submit:disabled{opacity:.5;cursor:not-allowed;transform:none}\n.scb-spin{width:16px;height:16px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:scbSpin .65s linear infinite;display:inline-block}\n@keyframes scbSpin{to{transform:rotate(360deg)}}\n.scb-divider{display:flex;align-items:center;gap:9px;margin:16px 0 12px}\n.scb-div-line{flex:1;height:1px;background:rgba(55,138,221,.12)}\n.scb-div-txt{font-size:10px;font-weight:700;color:rgba(148,180,220,.4);letter-spacing:.08em;white-space:nowrap}\n.scb-quick-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:7px}\n.scb-quick-item{background:rgba(255,255,255,.04);border:1.5px solid rgba(55,138,221,.14);border-radius:8px;padding:9px 7px;text-align:center;cursor:pointer;transition:all .15s}\n.scb-quick-item:hover{background:rgba(55,138,221,.1);border-color:rgba(55,138,221,.35)}\n.scb-qi-icon{font-size:14px;margin-bottom:3px}\n.scb-qi-role{font-size:10.5px;font-weight:700;color:rgba(240,244,255,.8)}\n.scb-qi-user{font-size:9.5px;color:rgba(148,180,220,.5);font-family:'JetBrains Mono',monospace;margin-top:1px}\n.scb-right-stats{display:flex;margin-top:14px;background:rgba(255,255,255,.03);border:1px solid rgba(55,138,221,.12);border-radius:10px;overflow:hidden}\n.scb-rs-item{flex:1;padding:10px 8px;text-align:center;border-right:1px solid rgba(55,138,221,.1)}\n.scb-rs-item:last-child{border-right:none}\n.scb-rs-val{font-family:'DM Serif Display',serif;font-size:18px;font-weight:700;color:#60A5FA;line-height:1;margin-bottom:3px}\n.scb-rs-lbl{font-size:9px;font-weight:600;color:rgba(148,180,220,.55);text-transform:uppercase;letter-spacing:.07em}\n.scb-right-foot{text-align:center;font-size:11px;color:rgba(148,180,220,.55);line-height:1.7;margin-top:16px}\n.scb-right-foot a{color:#378ADD;text-decoration:none;font-weight:600}\n@media(min-width:1280px){.scb-page{grid-template-columns:1fr 500px}}\n@media(max-width:960px){.scb-page{grid-template-columns:1fr 380px}.scb-left{padding:32px}.scb-right{padding:36px 28px}.scb-headline{font-size:28px}}\n@media(max-width:768px){.scb-page{grid-template-columns:1fr 320px}.scb-left{padding:24px}.scb-right{padding:28px 20px}.scb-headline{font-size:24px}.scb-tagline{font-size:12px;margin-bottom:16px}.scb-feat-grid{grid-template-columns:1fr}.scb-feat:nth-child(n+9){display:none}.scb-form-card{padding:22px 18px}.scb-form-title{font-size:20px}.scb-trial-pill{display:none}}\n@media(max-width:560px){.scb-page{display:flex;flex-direction:column;min-height:100vh}.scb-left{padding:20px 18px 18px;flex:none}.scb-right{padding:24px 16px 32px;flex:1;border-left:none;border-top:1px solid rgba(55,138,221,.1)}.scb-headline{font-size:22px}.scb-feat-grid{grid-template-columns:1fr 1fr;gap:5px;margin-bottom:16px}.scb-feat:nth-child(n+7){display:none}.scb-form-card{padding:20px 16px}.scb-trial-pill{display:none}}\n@media(max-width:380px){.scb-feat-grid{grid-template-columns:1fr}.scb-feat:nth-child(n+5){display:none}}";

function LoginScreen({ users, onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [showPwd,  setShowPwd]  = useState(false);
  const [loading,  setLoading]  = useState(false);

  useEffect(() => {
    const fid = 'scb-fonts';
    if (!document.getElementById(fid)) {
      const lk = document.createElement('link');
      lk.id = fid; lk.rel = 'stylesheet';
      lk.href = 'https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=JetBrains+Mono:wght@400;500&display=swap';
      document.head.appendChild(lk);
    }
    const cid = 'scb-css';
    if (!document.getElementById(cid)) {
      const st = document.createElement('style');
      st.id = cid; st.textContent = SCB_CSS;
      document.head.appendChild(st);
    }
  }, []);

  const handleLogin = async () => {
    if (!username || !password) { setError("Please enter your username and password."); return; }
    setLoading(true); setError("");
    try {
      const data = await api.post("/api/login", { username, password });
      api.setToken(data.token);
    localStorage.setItem('cms_current_user', JSON.stringify(data.user));
      onLogin(data.user);
      if (data.user.trial_expires_at) setTrialInfo({ expires_at: data.user.trial_expires_at, status: data.user.subscription_status });
    } catch(e) { setError(e.message || "Invalid username or password."); }
    setLoading(false);
  };

  const quickFill = (u, p) => { setUsername(u); setPassword(p); setShowPwd(true); setError(""); };

  return (
    <div className="scb-page">
      <div className="scb-left">
        <div>
          <div className="scb-logo">
            <div className="scb-logo-mark">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M12 3L4 7V12C4 16.4 7.4 20.5 12 21.5C16.6 20.5 20 16.4 20 12V7L12 3Z" fill="white" opacity="0.95"/>
                <path d="M9 12L11 14L15 10" stroke="#185FA5" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <div className="scb-logo-name">SmartCABuddy</div>
              <div className="scb-logo-tag">Cheque Management System</div>
            </div>
          </div>
          <div className="scb-live-badge"><div className="scb-live-dot"></div>v10.0 &nbsp;&middot;&nbsp; 14 Features &nbsp;&middot;&nbsp; Live on Web</div>
          <h1 className="scb-headline">Manage Every <span className="scb-grad">Cheque.</span><br/><span className="scb-italic">Every Firm. One Place.</span></h1>
          <p className="scb-tagline">The complete digital cheque register built for CA firms and SMEs &mdash; inward, outward, multi-firm, WhatsApp alerts, audit trail, cheque book tracking and more.</p>
          <div className="scb-cat-tabs">
            <div className="scb-cat-tab"><div className="scb-cat-dot" style={{background:"#378ADD"}}></div>Core Register</div>
            <div className="scb-cat-tab"><div className="scb-cat-dot" style={{background:"#10B981"}}></div>Reporting</div>
            <div className="scb-cat-tab"><div className="scb-cat-dot" style={{background:"#22C55E"}}></div>Communication</div>
            <div className="scb-cat-tab"><div className="scb-cat-dot" style={{background:"#EF9F27"}}></div>Operations</div>
            <div className="scb-cat-tab"><div className="scb-cat-dot" style={{background:"#EF4444"}}></div>Security &amp; Admin</div>
          </div>
          <div className="scb-sec-label">What&apos;s inside</div>
          <div className="scb-feat-grid">
            <div className="scb-feat cb"><div className="scb-feat-icon" style={{background:"rgba(24,95,165,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M2 4h12v9a1 1 0 01-1 1H3a1 1 0 01-1-1V4z" stroke="#185FA5" strokeWidth="1.3"/><path d="M2 4l6-3 6 3" stroke="#185FA5" strokeWidth="1.3" strokeLinejoin="round"/></svg></div><div><div className="scb-feat-title">Inward &amp; Outward Register</div><div className="scb-feat-desc">Track every cheque received and issued across all firms</div></div></div>
            <div className="scb-feat cp"><div className="scb-feat-icon" style={{background:"rgba(139,92,246,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="8" height="10" rx="1.5" stroke="#8B5CF6" strokeWidth="1.3"/><rect x="7" y="5" width="8" height="10" rx="1.5" stroke="#8B5CF6" strokeWidth="1.3"/></svg></div><div><div className="scb-feat-title">Multi-Firm Management</div><div className="scb-feat-desc">Unlimited firms &amp; bank accounts in one place</div></div></div>
            <div className="scb-feat ct"><div className="scb-feat-icon" style={{background:"rgba(16,185,129,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="8" width="3" height="6" rx="1" fill="#10B981"/><rect x="6" y="5" width="3" height="9" rx="1" fill="#10B981"/><rect x="11" y="2" width="3" height="12" rx="1" fill="#10B981"/></svg></div><div><div className="scb-feat-title">Real-time Dashboard</div><div className="scb-feat-desc">Live KPIs, firm-wise summaries and monthly bar charts</div></div></div>
            <div className="scb-feat ca"><div className="scb-feat-icon" style={{background:"rgba(239,159,39,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="1.5" stroke="#EF9F27" strokeWidth="1.3"/><path d="M5 7h6M5 9.5h4" stroke="#EF9F27" strokeWidth="1.3" strokeLinecap="round"/></svg></div><div><div className="scb-feat-title">Full Register + Bulk Update</div><div className="scb-feat-desc">Filter, search, bulk status update with one click</div></div></div>
            <div className="scb-feat cg"><div className="scb-feat-icon" style={{background:"rgba(34,197,94,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M13 2.5C11 2.5 9.5 4 8 5.5C6.5 4 5 2.5 3 2.5C1.5 2.5 1 4 1.5 5.5C2.5 8.5 8 12.5 8 12.5S13.5 8.5 14.5 5.5C15 4 14.5 2.5 13 2.5Z" stroke="#22C55E" strokeWidth="1.3" strokeLinejoin="round"/></svg></div><div><div className="scb-feat-title">WhatsApp Alerts</div><div className="scb-feat-desc">Day-end summary, party reminders &amp; management reports</div></div></div>
            <div className="scb-feat cb"><div className="scb-feat-icon" style={{background:"rgba(24,95,165,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M2 12V4a1 1 0 011-1h10a1 1 0 011 1v8" stroke="#185FA5" strokeWidth="1.3"/><path d="M1 12h14" stroke="#185FA5" strokeWidth="1.3" strokeLinecap="round"/><path d="M6 7l1.5 1.5L10 6" stroke="#185FA5" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg></div><div><div className="scb-feat-title">MTD / YTD / Custom Reports</div><div className="scb-feat-desc">Month, year or any custom date range with Excel export</div></div></div>
            <div className="scb-feat ct"><div className="scb-feat-icon" style={{background:"rgba(16,185,129,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="2" y="1" width="12" height="14" rx="1.5" stroke="#10B981" strokeWidth="1.3"/><path d="M5 5h6M5 8h6M5 11h4" stroke="#10B981" strokeWidth="1.3" strokeLinecap="round"/></svg></div><div><div className="scb-feat-title">Print &amp; PDF Receipt</div><div className="scb-feat-desc">Print register or generate acknowledgement slip per cheque</div></div></div>
            <div className="scb-feat cr"><div className="scb-feat-icon" style={{background:"rgba(239,68,68,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6" stroke="#EF4444" strokeWidth="1.3"/><path d="M8 5v3.5M8 10.5v.5" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round"/></svg></div><div><div className="scb-feat-title">Aging Threshold Alerts</div><div className="scb-feat-desc">Auto-flag cheques pending beyond configurable X days</div></div></div>
            <div className="scb-feat ca"><div className="scb-feat-icon" style={{background:"rgba(239,159,39,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 13V7l5-5 5 5v6H10v-4H6v4H3Z" stroke="#EF9F27" strokeWidth="1.3" strokeLinejoin="round"/></svg></div><div><div className="scb-feat-title">Bulk Excel Import</div><div className="scb-feat-desc">Download templates, upload cheques, firms and parties</div></div></div>
            <div className="scb-feat cp"><div className="scb-feat-icon" style={{background:"rgba(139,92,246,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="5" cy="5" r="3" stroke="#8B5CF6" strokeWidth="1.3"/><circle cx="11" cy="5" r="3" stroke="#8B5CF6" strokeWidth="1.3"/><path d="M1 14c0-2.8 1.8-4.5 4-4.5M15 14c0-2.8-1.8-4.5-4-4.5" stroke="#8B5CF6" strokeWidth="1.3" strokeLinecap="round"/></svg></div><div><div className="scb-feat-title">Role-based Access Control</div><div className="scb-feat-desc">Admin, Manager, Staff and Viewer &mdash; granular permissions</div></div></div>
            <div className="scb-feat cb"><div className="scb-feat-icon" style={{background:"rgba(24,95,165,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M8 1L3 3.5V8c0 3 2.2 5.6 5 6.5C10.8 13.6 13 11 13 8V3.5L8 1Z" stroke="#185FA5" strokeWidth="1.3" strokeLinejoin="round"/><path d="M5.5 8L7 9.5L10.5 6" stroke="#185FA5" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg></div><div><div className="scb-feat-title">Audit Trail</div><div className="scb-feat-desc">Full log of every change &mdash; who did what and when</div></div></div>
            <div className="scb-feat ct"><div className="scb-feat-icon" style={{background:"rgba(16,185,129,.18)"}}><svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="11" rx="1.5" stroke="#10B981" strokeWidth="1.3"/><path d="M5 3V2M11 3V2M1 7h14" stroke="#10B981" strokeWidth="1.3" strokeLinecap="round"/></svg></div><div><div className="scb-feat-title">Cheque Book Register</div><div className="scb-feat-desc">Track leaf numbers, issued count and availability per firm</div></div></div>
          </div>
          <div className="scb-stats">
            <div className="scb-stat"><div className="scb-sv">&infin;</div><div className="scb-sl">Firms</div></div>
            <div className="scb-stat"><div className="scb-sv">&infin;</div><div className="scb-sl">Accounts</div></div>
            <div className="scb-stat"><div className="scb-sv">&infin;</div><div className="scb-sl">Cheques</div></div>
            <div className="scb-stat"><div className="scb-sv">4</div><div className="scb-sl">User Roles</div></div>
          </div>
        </div>
        <div className="scb-left-foot">
          <span>&copy; 2026 SmartCABuddy &nbsp;&middot;&nbsp; All rights reserved</span>
          <a href="https://smartcabuddy.com" target="_blank" rel="noreferrer">www.smartcabuddy.com</a>
        </div>
      </div>
      <div className="scb-right">
        <div className="scb-form-card">
          <div className="scb-secure-chip">
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><rect x="2" y="5.5" width="8" height="5.5" rx="1.5" stroke="#60A5FA" strokeWidth="1.2"/><path d="M4 5.5V3.5a2 2 0 014 0v2" stroke="#60A5FA" strokeWidth="1.2" strokeLinecap="round"/></svg>
            Secure Login
          </div>
          <div className="scb-form-title">Welcome back &#128075;</div>
          <div className="scb-form-sub">Sign in to your workspace to continue</div>
          <div className="scb-trial-bar">
            <div className="scb-trial-icon"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 1.5L10 6H14.5L11 9L12.5 13.5L8 11L3.5 13.5L5 9L1.5 6H6L8 1.5Z" fill="#10B981"/></svg></div>
            <div className="scb-trial-info">
              <div className="scb-trial-title">Free trial active &mdash; full access</div>
              <div className="scb-trial-sub">No credit card required &middot; All 14 features unlocked</div>
            </div>
            <div className="scb-trial-pill">3 days left</div>
          </div>
          {error && <div className="scb-err show"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#FCA5A5" strokeWidth="1.3"/><path d="M8 5v3.5M8 10.5V11" stroke="#FCA5A5" strokeWidth="1.5" strokeLinecap="round"/></svg><span>{error}</span></div>}
          <div className="scb-field">
            <label className="scb-f-label">Username</label>
            <div className="scb-f-wrap">
              <span className="scb-f-icon"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="6" r="3" stroke="currentColor" strokeWidth="1.35"/><path d="M2 14c0-3.2 2.7-5 6-5s6 1.8 6 5" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round"/></svg></span>
              <input className="scb-f-input" type="text" placeholder="Enter your username" autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} onKeyDown={e => { if(e.key==="Enter") document.getElementById("scb-pw").focus(); }}/>
            </div>
          </div>
          <div className="scb-field">
            <label className="scb-f-label">Password</label>
            <div className="scb-f-wrap">
              <span className="scb-f-icon"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="7" rx="2" stroke="currentColor" strokeWidth="1.35"/><path d="M5.5 7V5a2.5 2.5 0 015 0v2" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round"/></svg></span>
              <input id="scb-pw" className="scb-f-input" type={showPwd ? "text" : "password"} placeholder="Enter your password" autoComplete="current-password" style={{paddingRight:"40px"}} value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => { if(e.key==="Enter") handleLogin(); }}/>
              <button className="scb-pw-btn" type="button" onClick={() => setShowPwd(!showPwd)}>
                {showPwd
                  ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M6.7 6.8A2 2 0 009.2 9.3M4.4 4.6C2.7 5.9 1.5 7.5 1.5 8S4 13 8 13c1.1 0 2.2-.3 3.1-.8M11.6 11.4C13.3 10.1 14.5 8.5 14.5 8S12 3 8 3c-.7 0-1.4.1-2 .3" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round"/></svg>
                  : <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 8C1 8 3.5 3 8 3s7 5 7 5-2.5 5-7 5S1 8 1 8Z" stroke="currentColor" strokeWidth="1.35"/><circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.35"/></svg>
                }
              </button>
            </div>
          </div>
          <button className="scb-submit" onClick={handleLogin} disabled={loading} type="button">
            {loading
              ? <><span className="scb-spin"></span><span>Signing in&hellip;</span></>
              : <><span>Sign In to Workspace</span><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></>
            }
          </button>
          <div className="scb-divider"><div className="scb-div-line"></div><div className="scb-div-txt">QUICK ACCESS</div><div className="scb-div-line"></div></div>
          <div className="scb-quick-grid">
            <div className="scb-quick-item" onClick={() => quickFill("admin","Admin@2026")}><div className="scb-qi-icon">&#128081;</div><div className="scb-qi-role">Admin</div><div className="scb-qi-user">admin</div></div>
            <div className="scb-quick-item" onClick={() => quickFill("manager","Mgr@2026")}><div className="scb-qi-icon">&#128736;</div><div className="scb-qi-role">Manager</div><div className="scb-qi-user">manager</div></div>
            <div className="scb-quick-item" onClick={() => quickFill("staff","Staff@2026")}><div className="scb-qi-icon">&#128203;</div><div className="scb-qi-role">Staff</div><div className="scb-qi-user">staff</div></div>
          </div>
          <div className="scb-right-stats">
            <div className="scb-rs-item"><div className="scb-rs-val">&infin;</div><div className="scb-rs-lbl">Firms</div></div>
            <div className="scb-rs-item"><div className="scb-rs-val">&infin;</div><div className="scb-rs-lbl">Accounts</div></div>
            <div className="scb-rs-item"><div className="scb-rs-val">&infin;</div><div className="scb-rs-lbl">Cheques</div></div>
            <div className="scb-rs-item"><div className="scb-rs-val">4</div><div className="scb-rs-lbl">User Roles</div></div>
          </div>
        </div>
        <div className="scb-right-foot">
          Trouble signing in? Contact your admin &nbsp;&middot;&nbsp; <a href="https://smartcabuddy.com" target="_blank" rel="noreferrer">smartcabuddy.com</a>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  // ── Storage ──
  const [cheques,      setCheques]      = useState([]);
  const [nextId,       setNextId]       = useState(200);
  const [firms,        setFirms]        = useState([...DEFAULT_FIRMS]);
  const [firmAccounts, setFirmAccounts] = useState({...DEFAULT_FIRM_ACCOUNTS});
  const [users,        setUsers]        = useState([...DEFAULT_USERS]);
  const [parties,      setParties]      = useState([...DEFAULT_PARTIES]);
  const [nextUserId,   setNextUserId]   = useState(10);
  const [storageOk,    setStorageOk]    = useState(true);

  // ── Auth ──
  const [currentUser,   setCurrentUser] = useState(() => {
  try {
    const token = localStorage.getItem('cms_token');
    const user = localStorage.getItem('cms_current_user');
    if (token && user) return JSON.parse(user);
  } catch(e) {}
  return null;
});
  const [trialInfo, setTrialInfo] = useState(null);

  // ── Navigation ──
  const [scrollY, setScrollY] = useState(0);
  const [page,         setPage]         = useState("dashboard");

  // ── Cheque form ──
  const [showForm,     setShowForm]     = useState(false);
  const [editing,      setEditing]      = useState(null);
  const [form,         setForm]         = useState(null);
  const [confirmBounce,setConfirmBounce]= useState(null);
  const [bounceWAAlert,  setBounceWAAlert]= useState(null);
  const [toast,        setToast]        = useState(null);

  // ── Party autocomplete ──
  const [partySugg,    setPartySugg]    = useState([]);
  const [showSugg,     setShowSugg]     = useState(false);

  // ── Bulk select — use array not Set for reliable React re-renders ──
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkStatus,  setBulkStatus]  = useState("");
  const [confirmBulk, setConfirmBulk] = useState(false);

  // ── Scroll to top ──
  const [showScrollTop, setShowScrollTop] = useState(false);

  // ── Print ──
  const [showPrint,    setShowPrint]    = useState(false);
  const [printScope,   setPrintScope]   = useState("filtered"); // "filtered" | "firm" | "selected"

  // ── Filters ──
  const [fFirm,    setFFirm]    = useState("All");
  const [fType,    setFType]    = useState("All");
  const [fStatus,  setFStatus]  = useState("All");
  const [fDateFrom, setFDateFrom] = useState("");
  const [fDateTo,   setFDateTo]   = useState("");
  const [fMonth,   setFMonth]   = useState("All");
  const [fSearch,  setFSearch]  = useState("");
  const [firmView, setFirmView] = useState("");
  const [dashMonth,setDashMonth]= useState("All");

  // ── User management modal ──
  const [showUserMgmt,  setShowUserMgmt]  = useState(false);
  const [userForm,      setUserForm]      = useState(null);
  const [showUserForm,  setShowUserForm]  = useState(false);

  // ── Firm management modal ──
  const [showFirmMgmt,  setShowFirmMgmt]  = useState(false);
  const [newFirmName,   setNewFirmName]   = useState("");
  const [newFirmBank,   setNewFirmBank]   = useState("");
  const [newFirmAcNo,   setNewFirmAcNo]   = useState("");
  const [newFirmIFSC,   setNewFirmIFSC]   = useState("");
  const [newFirmAcType, setNewFirmAcType] = useState("Current");

  // ── Party master modal ──
  const [showPartyMgmt, setShowPartyMgmt] = useState(false);
  const [newPartyName,  setNewPartyName]  = useState("");

  // ── Audit trail ──
  const [auditLog,      setAuditLog]      = useState([]);
  const [showAudit,     setShowAudit]     = useState(false);
  // Auto-refresh audit log when opened
  useEffect(()=>{
    if(showAudit){
      api.get("/api/audit").then(logs=>{
        setAuditLog(logs.map(l=>({ id:l.id, ts:l.created_at, user:l.user_name||"System", action:l.action, details:l.details })));
      }).catch(()=>{});
    }
  },[showAudit]);

  // ── Cheque book register ──
  const [chequeBooks,   setChequeBooks]   = useState({});
  const [showChqBook,   setShowChqBook]   = useState(false);
  const [chqBookFirm,   setChqBookFirm]   = useState("");

  // ── Aging threshold settings ──
  const [agingDays,     setAgingDays]     = useState(DEFAULT_AGING_DAYS);
  const [showSettings,  setShowSettings]  = useState(false);

  // ── WhatsApp ──
  const [showWhatsApp,  setShowWhatsApp]  = useState(false);
  const [waPhone,       setWaPhone]       = useState("");
  const [waMode,        setWaMode]        = useState("dayend"); // dayend | party | mgmt

  // ── Onboarding wizard ──
  const [showOnboard,   setShowOnboard]   = useState(false);
  const [onboardStep,   setOnboardStep]   = useState(0);
  const [isFirstRun,    setIsFirstRun]    = useState(false);

  // ── Bulk Import ──
  const [showImport,    setShowImport]    = useState(false);
  const [importType,    setImportType]    = useState("cheques");
  const [importPreview, setImportPreview] = useState([]);
  const [importErrors,  setImportErrors]  = useState([]);
  const [importStatus,  setImportStatus]  = useState("");

  // ── Reports ──
  const [reportPeriod, setReportPeriod] = useState("MTD");
  const [reportFirm,   setReportFirm]   = useState("All");
  const [reportType,   setReportType]   = useState("All");
  const [reportFrom,   setReportFrom]   = useState("");
  const [reportTo,     setReportTo]     = useState("");

  // ── Load from API ──
  useEffect(() => {
    const token = api.getToken();
    if (!token) return;
    const loadAll = async () => {
      try {
        const [firmsData, chequesData, partiesData, settingsData] = await Promise.all([
          api.get("/api/firms"),
          api.get("/api/cheques"),
          api.get("/api/parties"),
          api.get("/api/settings"),
        ]);
        // Build firms array and firmAccounts map from API data
        const firmNames = firmsData.map(f => f.name);
        const firmAccMap = {};
        firmsData.forEach(f => {
          firmAccMap[f.name] = (f.accounts||[]).map(a => ({
            bank: a.bank_name, acNo: a.ac_no, ifsc: a.ifsc||"", acType: a.ac_type||"Current"
          }));
        });
        // Map API cheques to frontend format
        const mapped = chequesData.map(c => ({
          id: c.id,
          type: c.type,
          firm: c.firm_name,
          date: c.date ? c.date.slice(0,10) : "",
          depositDate: c.deposit_date ? c.deposit_date.slice(0,10) : "",
          fromTo: c.party_name||c.fromTo||c.from_to||"",
          drawer: c.drawer||"",
          drawee: c.drawee||"",
          depositedBy: c.deposited_by||c.depositedBy||"",
          chequeNo: c.cheque_number||c.chequeNo||c.cheque_no||"",
          chequeDate: c.cheque_date ? c.cheque_date.slice(0,10) : "",
          amount: Number(c.amount)||0,
          status: c.status||"Pending",
          realisationDate: c.realisation_date ? c.realisation_date.slice(0,10) : "",
          remarks: c.remarks||"",
          chequeImage: c.cheque_image||"",
        }));
        const maxId = mapped.length ? Math.max(...mapped.map(c=>c.id)) : 0;
        setFirms(firmNames);
        setFirmAccounts(firmAccMap);
        setCheques(mapped);
        setNextId(maxId + 1);
        setParties(partiesData);
        if (settingsData.agingDays) setAgingDays(Number(settingsData.agingDays));
        if (settingsData.waPhone)   setWaPhone(settingsData.waPhone);
        if (firmNames.length) setFirmView(firmNames[0]);
        setStorageOk(true);
        if (mapped.length === 0) setIsFirstRun(true);
      } catch(e) {
        console.error("Load error:", e);
        setStorageOk(false);
      }
    };
    loadAll();
  }, [currentUser]);

  // Load users from API after login
  useEffect(() => {
    if (!currentUser) return;
    api.get("/api/users").then(data => {
      setUsers(data.map(u => ({...u, password: "****"})));
    }).catch(()=>{});
    const loadAudit = () => api.get("/api/audit").then(logs => {
      setAuditLog(logs.map(l => ({ id:l.id, ts:l.created_at, user:l.user_name||"System", action:l.action, details:l.details })));
    }).catch(()=>{});
    // Load cheque books from localStorage (device-specific UI preference)
    try { const cb = JSON.parse(localStorage.getItem("cms_chqbooks")||"{}"); setChequeBooks(cb); } catch{}
  }, [currentUser]);

  // Show onboarding on first run (after login)
  useEffect(() => {
    if (currentUser && isFirstRun) { setShowOnboard(true); setIsFirstRun(false); }
  }, [currentUser, isFirstRun]);

  const addAudit = useCallback((action, details) => {
    // Audit is now handled server-side by the API
    // This is kept for UI refresh after status changes
    api.get("/api/audit").then(logs => {
      const mapped = logs.map(l => ({
        id: l.id,
        ts: l.created_at,
        user: l.user_name || "System",
        action: l.action,
        details: l.details,
      }));
      setAuditLog(mapped);
    }).catch(() => {});
  }, []);

  // persist() removed — all data operations now go through the API

  const showToast = (msg, type="success") => { setToast({msg,type}); setTimeout(()=>setToast(null),3000); };

  // Scroll to top logic
  useEffect(() => {
    const mainEl = document.getElementById('main-scroll-area');
    if (!mainEl) return;
    const handleScroll = () => setShowScrollTop(mainEl.scrollTop > 300);
    mainEl.addEventListener('scroll', handleScroll);
    return () => mainEl.removeEventListener('scroll', handleScroll);
  }, [page]);

  const scrollToTop = () => {
    const mainEl = document.getElementById('main-scroll-area');
    if (mainEl) mainEl.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Derived data ──
  const months = useMemo(() => [...new Set(cheques.map(c=>c.date.slice(0,7)))].sort().reverse(), [cheques]);

  const dashCheques = useMemo(() => {
    if (dashMonth==="All") return cheques;
    if (dashMonth==="week") {
      const d = new Date(); d.setDate(d.getDate()-7);
      const from = d.toISOString().slice(0,10);
      return cheques.filter(c=>c.date>=from);
    }
    if (dashMonth==="30d") {
      const d = new Date(); d.setDate(d.getDate()-30);
      const from = d.toISOString().slice(0,10);
      return cheques.filter(c=>c.date>=from);
    }
    if (dashMonth==="quarter") {
      const d = new Date(); d.setMonth(d.getMonth()-3);
      const from = d.toISOString().slice(0,10);
      return cheques.filter(c=>c.date>=from);
    }
    return cheques.filter(c=>c.date.startsWith(dashMonth));
  }, [cheques, dashMonth]);

  const filtered = useMemo(() => cheques.filter(c => {
    if (fFirm!=="All" && c.firm!==fFirm) return false;
    if (fType!=="All" && c.type!==fType) return false;
    if (fStatus!=="All" && c.status!==fStatus) return false;
    if (fMonth!=="All" && !c.date.startsWith(fMonth)) return false;
    if (fSearch) { const q=fSearch.toLowerCase(); if(![c.fromTo,c.chequeNo,c.firm,c.drawer,c.drawee,c.depositedBy,c.remarks].some(v=>v?.toLowerCase().includes(q))) return false; }
    return true;
  }).sort((a,b)=>b.date.localeCompare(a.date)||b.id-a.id), [cheques,fFirm,fType,fStatus,fMonth,fSearch]);

  const totals = useMemo(() => {
    const b=dashCheques;
    return {
      total:b.reduce((s,c)=>s+c.amount,0), count:b.length,
      inward:b.filter(c=>c.type==="inward").reduce((s,c)=>s+c.amount,0),
      outward:b.filter(c=>c.type==="outward").reduce((s,c)=>s+c.amount,0),
      cleared:b.filter(c=>c.status==="Cleared").reduce((s,c)=>s+c.amount,0),
      pending:b.filter(c=>c.status==="Pending").reduce((s,c)=>s+c.amount,0),
      bounced:b.filter(c=>c.status==="Bounced").reduce((s,c)=>s+c.amount,0),
      inColl:b.filter(c=>c.status==="In Collection").reduce((s,c)=>s+c.amount,0),
      pendingCnt:b.filter(c=>c.status==="Pending").length,
      bouncedCnt:b.filter(c=>c.status==="Bounced").length,
      inCollCnt:b.filter(c=>c.status==="In Collection").length,
    };
  }, [dashCheques]);

  const firmStats = useMemo(() => firms.map((firm,fi) => {
    const fc=dashCheques.filter(c=>c.firm===firm);
    const inw=fc.filter(c=>c.type==="inward"), out=fc.filter(c=>c.type==="outward");
    return { firm, fi,
      inTotal:inw.reduce((s,c)=>s+c.amount,0), inCleared:inw.filter(c=>c.status==="Cleared").reduce((s,c)=>s+c.amount,0),
      inPending:inw.filter(c=>c.status==="Pending").reduce((s,c)=>s+c.amount,0),
      outTotal:out.reduce((s,c)=>s+c.amount,0), outCleared:out.filter(c=>c.status==="Cleared").reduce((s,c)=>s+c.amount,0),
      count:fc.length, bounced:fc.filter(c=>c.status==="Bounced").length,
      pending:fc.filter(c=>c.status==="Pending").length, inColl:fc.filter(c=>c.status==="In Collection").length,
    };
  }).filter(f=>f.count>0), [dashCheques, firms]);

  const monthlyData = useMemo(() => {
    const map={};
    cheques.forEach(c=>{ const m=c.date.slice(0,7); if(!map[m]) map[m]={inward:0,outward:0}; c.type==="inward"?(map[m].inward+=c.amount):(map[m].outward+=c.amount); });
    return Object.entries(map).sort((a,b)=>a[0].localeCompare(b[0])).slice(-6);
  }, [cheques]);

  // ── Report data ──
  const reportData = useMemo(() => {
    const cm=thisMonth(), cy=thisYear();
    return cheques.filter(c => {
      let matchPeriod;
      if (reportPeriod==="MTD")    matchPeriod = c.date.startsWith(cm);
      else if (reportPeriod==="YTD") matchPeriod = c.date.startsWith(cy);
      else if (reportPeriod==="CUSTOM") {
        const d = c.date;
        matchPeriod = (!reportFrom || d >= reportFrom) && (!reportTo || d <= reportTo);
      } else matchPeriod = true;
      const matchFirm = reportFirm==="All" || c.firm===reportFirm;
      const matchType = reportType==="All" || c.type===reportType;
      return matchPeriod && matchFirm && matchType;
    }).sort((a,b)=>b.date.localeCompare(a.date)||b.id-a.id);
  }, [cheques, reportPeriod, reportFirm, reportType, reportFrom, reportTo]);

  const reportTotals = useMemo(() => ({
    total:   reportData.reduce((s,c)=>s+c.amount,0),
    cleared: reportData.filter(c=>c.status==="Cleared").reduce((s,c)=>s+c.amount,0),
    pending: reportData.filter(c=>c.status==="Pending").reduce((s,c)=>s+c.amount,0),
    bounced: reportData.filter(c=>c.status==="Bounced").reduce((s,c)=>s+c.amount,0),
    inColl:  reportData.filter(c=>c.status==="In Collection").reduce((s,c)=>s+c.amount,0),
    inward:  reportData.filter(c=>c.type==="inward").reduce((s,c)=>s+c.amount,0),
    outward: reportData.filter(c=>c.type==="outward").reduce((s,c)=>s+c.amount,0),
    count:   reportData.length,
  }), [reportData]);

  // ── Status change ──
  const handleStatusChange = (id, newStatus) => {
    if (!canEdit(currentUser?.role)) { showToast("You don't have permission to update status","error"); return; }
    if (newStatus==="Bounced") { setConfirmBounce({id,status:newStatus}); return; }
    applyStatus(id, newStatus);
  };
  const applyStatus = async (id, newStatus) => {
    const c = cheques.find(x=>x.id===id);
    const realisationDate = newStatus==="Cleared" ? (c?.realisationDate||nowISO()) : null;
    try {
      await api.patch(`/api/cheques/${id}/status`, { status: newStatus, realisationDate });
      const updatedCheque = cheques.find(x=>x.id===id);
      setCheques(prev => prev.map(c => c.id!==id ? c : {
        ...c, status: newStatus,
        realisationDate: realisationDate||""
      }));
      showToast(`Status updated → ${newStatus}`);
      addAudit("Status Change", `Entry #${id}`);
      // Auto-prompt WhatsApp alert on bounce
      if (newStatus==="Bounced" && updatedCheque) {
        setBounceWAAlert(updatedCheque);
      }
    } catch(e) { showToast(e.message, "error"); }
  };

  // ── Cheque CRUD ──
  const handleSave = async () => {
    if (!form.fromTo.trim())              { showToast("Party name is required","error"); return; }
    if (!form.chequeNo.trim())            { showToast("Cheque number is required","error"); return; }
    if (!form.amount||parseFloat(form.amount)<=0) { showToast("Valid amount required","error"); return; }
    const entry = { ...form, amount: Math.abs(parseFloat(form.amount)||0),
      drawer: form.drawer==="Other" && form.drawerManual ? form.drawerManual : form.drawer,
      drawee: form.drawee==="Other" && form.draweeManual ? form.draweeManual : form.drawee,
      cheque_number: form.chequeNo||form.cheque_number||'',
    party_name: form.fromTo||form.party_name||'',
    deposited_by: form.depositedBy||form.deposited_by||'',
    deposit_date: form.depositDate||form.deposit_date||null,
    cheque_date: form.chequeDate||form.cheque_date||'',
    realisation_date: form.realisationDate||form.realisation_date||null,
  };
    // Auto-add party to master if new
    if (!parties.includes(form.fromTo.trim())) {
      const updParties = [...parties, form.fromTo.trim()].sort();
      setParties(updParties);
      api.post("/api/parties", { names: [form.fromTo.trim()] }).catch(()=>{});
    }
    try {
      if (editing) {
        await api.put(`/api/cheques/${editing.id}`, entry);
        setCheques(prev => prev.map(c => c.id===editing.id ? {...entry, id:editing.id} : c));
        showToast("Entry updated ✓");
      } else {
        const saved = await api.post("/api/cheques", entry);
        const newEntry = { ...entry, id: saved.id };
        setCheques(prev => [newEntry, ...prev]);
        setNextId(saved.id + 1);
        showToast("Cheque saved ✓");
      }
      addAudit("Save", `Cheque #${entry.chequeNo}`);
      setShowForm(false); setEditing(null); setForm(null); setShowSugg(false);
    } catch(e) { showToast(e.message, "error"); }
  };
  const handleEdit    = (c)  => {
    const BK=["SBI","PNB","HDFC Bank","ICICI Bank","Axis Bank","Kotak Mahindra Bank","Bank of Baroda","Canara Bank","UCO Bank","Yes Bank","Other"];
    const dro=c.drawer&&!BK.includes(c.drawer);
    const dwe=c.drawee&&!BK.includes(c.drawee);
    setForm({...c,amount:String(c.amount||""),chequeNo:c.cheque_number||c.chequeNo||"",chequeDate:c.cheque_date||c.chequeDate||"",date:c.cheque_date||c.date||"",depositDate:c.deposit_date||c.depositDate||"",fromTo:c.party_name||c.fromTo||"",remarks:c.remarks||"",depositedBy:c.deposited_by||c.depositedBy||"",realisationDate:c.realisation_date||c.realisationDate||"",status:c.status||"Pending",type:c.type||"inward",firm:c.firm_id||c.firm||"",drawer:dro?"Other":(c.drawer||""),drawerManual:dro?c.drawer:(c.drawerManual||""),drawee:dwe?"Other":(c.drawee||""),draweeManual:dwe?c.drawee:(c.draweeManual||"")});
    setEditing(c); setShowForm(true);
  };
  const handleDelete = async (id) => {
    if (!canDelete(currentUser?.role)) { showToast("Only Admin/Manager can delete","error"); return; }
    if (window.confirm("Delete this entry?")) {
      try {
        await api.del(`/api/cheques/${id}`);
        setCheques(prev => prev.filter(c=>c.id!==id));
        showToast("Deleted successfully","success");
      } catch(e) { showToast(e.message,"error"); }
    }
  };

  // ── Bulk status update ──
  const toggleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev, id]);
  };
  const toggleSelectAll = () => {
    if (selectedIds.length === filtered.length && filtered.length > 0) setSelectedIds([]);
    else setSelectedIds(filtered.map(c=>c.id));
  };
  const handleBulkUpdate = () => {
    if (!bulkStatus)          { showToast("Select a status first","error"); return; }
    if (selectedIds.length===0) { showToast("Select at least one entry","error"); return; }
    setConfirmBulk(true);
  };
  const applyBulkUpdate = async () => {
    try {
      await Promise.all(selectedIds.map(id => {
        const c = cheques.find(x=>x.id===id);
        const rd = bulkStatus==="Cleared" ? (c?.realisationDate||nowISO()) : null;
        return api.patch(`/api/cheques/${id}/status`, { status: bulkStatus, realisationDate: rd });
      }));
      setCheques(prev => prev.map(c => {
        if (!selectedIds.includes(c.id)) return c;
        return { ...c, status: bulkStatus, realisationDate: bulkStatus==="Cleared" ? (c.realisationDate||nowISO()) : "" };
      }));
      showToast(`${selectedIds.length} entr${selectedIds.length>1?"ies":"y"} updated → ${bulkStatus}`);
      setSelectedIds([]); setBulkStatus(""); setConfirmBulk(false);
    } catch(e) { showToast(e.message,"error"); }
  };

  // ── Party master ──
  const handlePartyInput = (val) => {
    sf("fromTo", val);
    if (val.length < 1) { setShowSugg(false); return; }
    const matches = parties.filter(p => p.toLowerCase().includes(val.toLowerCase())).slice(0,6);
    setPartySugg(matches);
    setShowSugg(matches.length > 0);
  };
  const selectParty = (name) => { sf("fromTo", name); setShowSugg(false); };
  const addPartyToMaster = async (name) => {
    const trimmed = name.trim();
    if (!trimmed) { showToast("Party name cannot be empty","error"); return; }
    if (parties.includes(trimmed)) { showToast(`"${trimmed}" already exists`,"error"); return; }
    try {
      const mobile  = document.getElementById("pm_mobile")?.value?.trim()||"";
      const email   = document.getElementById("pm_email")?.value?.trim()||"";
      const address = document.getElementById("pm_address")?.value?.trim()||"";
      const city    = document.getElementById("pm_city")?.value?.trim()||"";
      const state   = document.getElementById("pm_state")?.value?.trim()||"";
      const pincode = document.getElementById("pm_pincode")?.value?.trim()||"";
      ["pm_mobile","pm_email","pm_address","pm_city","pm_state","pm_pincode"]
        .forEach(id=>{const el=document.getElementById(id);if(el)el.value="";});
      await api.post("/api/parties", { names: [trimmed], mobile, email, address, city, state, pincode });
      setParties(prev => [...prev, trimmed].sort());
      showToast(`"${trimmed}" added ✓`);
    } catch(e) { showToast(e.message,"error"); }
  };
  const handleDeleteParty = (name) => {
    setParties(prev => prev.filter(p=>p!==name));
    showToast(`"${name}" removed`,"error");
  };

  // ── Print ──
  const handlePrint = () => {
    const el = document.getElementById("print-area");
    if (el) el.style.display = "block";
    setTimeout(()=>{ window.print(); setTimeout(()=>{ if(el) el.style.display="none"; },500); }, 200);
  };

  // ── WhatsApp helpers ──
  const buildDayEndMessage = () => {
    const today = nowISO();
    const todayCheques = cheques.filter(c => c.date === today);
    const pending   = cheques.filter(c => c.status==="Pending");
    const bounced   = cheques.filter(c => c.status==="Bounced");
    const inColl    = cheques.filter(c => c.status==="In Collection");
    const cleared   = cheques.filter(c => c.status==="Cleared");
    const lines = [
      `📋 *SmartCABuddy — Day End Summary*`,
      `📅 Date: ${new Date().toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}`,
      ``,
      `*Today's Activity (${todayCheques.length} entries)*`,
      todayCheques.length > 0
        ? todayCheques.map(c=>`  • ${c.fromTo} — ${fmt(c.amount)} (${c.type})`).join("\n")
        : "  No entries today",
      ``,
      `*Overall Status*`,
      `✅ Cleared: ${fmt(cleared.reduce((s,c)=>s+c.amount,0))} (${cleared.length} cheques)`,
      `⏳ Pending: ${fmt(pending.reduce((s,c)=>s+c.amount,0))} (${pending.length} cheques)`,
      `🏦 In Collection: ${fmt(inColl.reduce((s,c)=>s+c.amount,0))} (${inColl.length} cheques)`,
      bounced.length > 0 ? `❌ Bounced: ${fmt(bounced.reduce((s,c)=>s+c.amount,0))} (${bounced.length} cheques) ⚠️ ACTION NEEDED` : `❌ Bounced: NIL`,
      ``,
      `_Sent from SmartCABuddy — www.smartcabuddy.com_`,
    ];
    return lines.join("\n");
  };

  const buildPartyMessage = (cheque) => {
    return [
      `📋 *Cheque Status Update*`,
      ``,
      `Dear ${cheque.fromTo},`,
      ``,
      `This is a reminder regarding your cheque:`,
      `• Cheque No: *${cheque.chequeNo}*`,
      `• Amount: *${fmt(cheque.amount)}*`,
      `• Date: ${cheque.chequeDate}`,
      `• Status: *${cheque.status}*`,
      cheque.status==="Bounced"
        ? `\n⚠️ Your cheque has been returned. Please arrange for payment at the earliest.`
        : `\nKindly ensure the cheque is honoured on presentation.`,
      ``,
      `Regards,`,
      `${currentUser?.name || "Management"}`,
      `_SmartCABuddy — www.smartcabuddy.com_`,
    ].join("\n");
  };

  const openWhatsApp = (phone, message) => {
    const clean = phone.replace(/\D/g,"");
    const num = clean.startsWith("91") ? clean : `91${clean}`;
    const url = `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
    addAudit("WhatsApp", `Message sent to ${phone} by ${currentUser?.name||"user"}`);
  };

  // ── Cheque book handlers ──
  const saveChqBook = (firm, data) => {
    const updated = {...chequeBooks, [firm]: data};
    setChequeBooks(updated);
    try { localStorage.setItem("cms_chqbooks", JSON.stringify(updated)); } catch{}
    showToast("Cheque book updated ✓");
  };

  // ── Aging alert: cheques past threshold ──
  const agingAlerts = useMemo(() =>
    cheques.filter(c =>
      ["Pending","In Collection"].includes(c.status) && daysSince(c.date) >= agingDays
    ).sort((a,b) => daysSince(b.date) - daysSince(a.date))
  , [cheques, agingDays]);

  // ── PDF Receipt ──
  const printReceipt = (c) => {
    const w = window.open("","_blank","width=600,height=500");
    w.document.write(`<!DOCTYPE html><html><head><title>Cheque Receipt</title>
    <style>body{font-family:Arial,sans-serif;padding:30px;color:#1e293b}
    .header{text-align:center;margin-bottom:24px;border-bottom:2px solid #0A1628;padding-bottom:16px}
    .logo{font-size:22px;font-weight:900;color:#0A1628}
    .subtitle{font-size:12px;color:#64748B}
    table{width:100%;border-collapse:collapse;margin-top:16px}
    td{padding:8px 10px;font-size:13px;border-bottom:1px solid #F1F5F9}
    td:first-child{font-weight:600;color:#64748B;width:40%}
    .amt{font-size:20px;font-weight:900;color:#059669;text-align:center;padding:16px;background:#ECFDF5;border-radius:8px;margin:16px 0}
    .badge{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;background:${c.status==="Cleared"?"#D1FAE5":c.status==="Bounced"?"#FEE2E2":"#FEF3C7"};color:${c.status==="Cleared"?"#065F46":c.status==="Bounced"?"#991B1B":"#92400E"}}
    .footer{text-align:center;margin-top:24px;font-size:11px;color:#94A3B8;border-top:1px solid #F1F5F9;padding-top:12px}
    @media print{button{display:none}}</style></head><body>
    <div class="header"><div class="logo">SmartCABuddy</div><div class="subtitle">Cheque Acknowledgement Receipt</div></div>
    <div class="amt">${fmt(c.amount)}</div>
    <table>
      <tr><td>Receipt No</td><td>#${c.id}</td></tr>
      <tr><td>Entry Date</td><td>${c.date}</td></tr>
      <tr><td>Type</td><td>${c.type.toUpperCase()}</td></tr>
      <tr><td>Firm</td><td>${c.firm}</td></tr>
      <tr><td>${c.type==="inward"?"Received From":"Issued To"}</td><td>${c.fromTo}</td></tr>
      <tr><td>Cheque No</td><td>${c.chequeNo}</td></tr>
      <tr><td>Cheque Date</td><td>${c.chequeDate}</td></tr>
      <tr><td>Drawer Bank</td><td>${c.drawer||"—"}</td></tr>
      <tr><td>Deposited By</td><td>${c.depositedBy||"—"}</td></tr>
      <tr><td>Status</td><td><span class="badge">${c.status}</span></td></tr>
      ${c.realisationDate?`<tr><td>Realisation Date</td><td>${c.realisationDate}</td></tr>`:""}
      ${c.remarks?`<tr><td>Remarks</td><td>${c.remarks}</td></tr>`:""}
    </table>
    <div class="footer">SmartCABuddy — www.smartcabuddy.com | Printed: ${new Date().toLocaleString("en-IN")}</div>
    <br><button onclick="window.print()" style="padding:8px 20px;background:#0A1628;color:white;border:none;border-radius:6px;cursor:pointer;font-size:13px">Print / Save PDF</button>
    </body></html>`);
    w.document.close();
    addAudit("Receipt", `Receipt printed for Entry #${c.id} (${c.fromTo}) by ${currentUser?.name||"user"}`);
  };

  // ── Bulk Import Helpers ──
  const TEMPLATES = {
    cheques: {
      filename: "CMS_Cheque_Import_Template.csv",
      headers:  ["type","firm","date","depositDate","fromTo","chequeNo","chequeDate","amount","drawer","drawee","depositedBy","status","realisationDate","remarks"],
      sample:   ["inward","Kyra Financial Services","2026-03-14","2026-03-14","ABC Traders","123456","2026-03-14","15000","HDFC Bank","Kotak Mahindra Bank","Kyra Financial Services","Pending","","Sample entry"],
      notes:    "type: inward/outward | status: Pending/In Collection/Cleared/Bounced | dates: YYYY-MM-DD",
    },
    parties: {
      filename: "CMS_Party_Master_Template.csv",
      headers:  ["partyName","mobile","email","address","city","state","pincode"],
      sample:   ["ABC Traders Pvt Ltd","9876543210","abc@example.com","123 MG Road","Ludhiana","Punjab","141001"],
      notes:    "One party per row. Only partyName is required.",
    },
    firms: {
      filename: "CMS_Firm_Account_Template.csv",
      headers:  ["firmName","bankName","accountNo","ifscCode","accountType"],
      sample:   ["New Firm Ltd","HDFC Bank","50200012345678","HDFC0001234","Current"],
      notes:    "Same firmName on multiple rows = multiple accounts | accountType: Savings/Current/CC/OD/NRO/NRE/Term Loan/Others",
    },
  };

  const downloadTemplate = (type) => {
    const t = TEMPLATES[type];
    const BOM = "\uFEFF";
    const rows = [t.headers, t.sample, [`# Notes: ${t.notes}`]];
    const csv = BOM + rows.map(r=>r.join(",")).join("\n");
    const a = document.createElement("a");
    a.href = "data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
    a.download = t.filename;
    a.click();
    showToast(`Template downloaded: ${t.filename}`);
  };

  const parseCSV = (text) => {
    const lines = text.trim().split("\n").filter(l=>l&&!l.startsWith("#"));
    if (lines.length < 2) return { headers:[], rows:[] };
    const headers = lines[0].split(",").map(h=>h.trim().replace(/^"|"$/g,"").toLowerCase());
    const rows = lines.slice(1).map(line => {
      const vals = []; let cur="", inQ=false;
      for (const ch of line) {
        if (ch==='"') inQ=!inQ;
        else if (ch===","&&!inQ) { vals.push(cur.trim()); cur=""; }
        else cur+=ch;
      }
      vals.push(cur.trim());
      return Object.fromEntries(headers.map((h,i)=>[h, (vals[i]||"").replace(/^"|"$/g,"").trim()]));
    });
    return { headers, rows };
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImportErrors([]); setImportPreview([]); setImportStatus("reading");
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const { headers, rows } = parseCSV(ev.target.result);
        const errs = [];
        const valid = [];
        if (importType==="cheques") {
          rows.forEach((r,i) => {
            const row = i+2;
            if (!r.type||!["inward","outward"].includes(r.type.toLowerCase())) errs.push(`Row ${row}: type must be inward or outward`);
            else if (!r.firm) errs.push(`Row ${row}: firm is required`);
            else if (!r.date||isNaN(new Date(r.date))) errs.push(`Row ${row}: invalid date`);
            else if (!r.chequeno&&!r.chequeNo) errs.push(`Row ${row}: chequeNo is required`);
            else if (!r.amount||isNaN(parseFloat(r.amount))||parseFloat(r.amount)<=0) errs.push(`Row ${row}: invalid amount`);
            else valid.push({
              id: nextId + valid.length,
              type: r.type.toLowerCase(),
              firm: r.firm, date: r.date,
              depositDate: r.depositdate||r.depositDate||r.date,
              fromTo: r.fromto||r.fromTo||"",
              chequeNo: r.chequeno||r.chequeNo||"",
              chequeDate: r.chequedate||r.chequeDate||r.date,
              amount: parseFloat(r.amount),
              drawer: r.drawer||"", drawee: r.drawee||"",
              depositedBy: r.depositedBy||"",
              status: r.status&&STATUSES.includes(r.status)?r.status:"Pending",
              realisationDate: r.realisationdate||r.realisationDate||"",
              remarks: r.remarks||"",
            });
          });
        } else if (importType==="parties") {
          rows.forEach((r,i) => {
            const name = r.partyname||r.partyName||Object.values(r)[0]||"";
            if (name&&!parties.includes(name)) valid.push({
            name,
            mobile:  r.mobile||r.Mobile||"",
            email:   r.email||r.Email||"",
            address: r.address||r.Address||"",
            city:    r.city||r.City||"",
            state:   r.state||r.State||"",
            pincode: r.pincode||r.Pincode||""
          });
          });
        } else if (importType==="firms") {
          const firmMap = {};
          rows.forEach((r,i) => {
            const row = i+2;
            const name = r.firmname||r.firmName||"";
            const bank = r.bankname||r.bankName||"";
            const acNo = r.accountno||r.accountNo||"";
            const acType = r.accounttype||r.accountType||"Current";
            if (!name) { errs.push(`Row ${row}: firmName required`); return; }
            if (!firmMap[name]) {
              if (firms.includes(name)) { errs.push(`Row ${row}: "${name}" already exists — skipping all rows for this firm`); return; }
              firmMap[name] = { name, accounts: [] };
            }
            if (bank) firmMap[name].accounts.push({ bank, acNo, acType, ...(r.ifsccode||r.ifscCode?{ifsc:r.ifsccode||r.ifscCode}:{}) });
          });
          Object.values(firmMap).forEach(f => valid.push(f));
        }
        setImportPreview(valid); setImportErrors(errs);
        setImportStatus(errs.length>0?"errors":"ready");
      } catch(err) { setImportErrors(["Failed to parse file. Make sure it is a valid CSV."]); setImportStatus("errors"); }
    };
    reader.readAsText(file);
    e.target.value = "";
  };

  const applyImport = async () => {
    if (!importPreview.length) return;
    if (importType==="cheques") {
      try {
        const saved = [];
        for (const c of importPreview) { const r = await api.post("/api/cheques", c); saved.push({...c, id:r.id}); }
        setCheques(prev => [...saved.reverse(), ...prev]);
        const newParties = [...new Set([...parties, ...importPreview.map(c=>c.fromTo).filter(Boolean)])].sort();
        if (newParties.length > parties.length) { setParties(newParties); await api.post("/api/parties", { names: newParties.filter(p=>!parties.includes(p)) }); }
        showToast(`${importPreview.length} cheques imported ✓`);
      } catch(e) { showToast(e.message,"error"); }
    } else if (importType==="parties") {
      const newOnes = importPreview.filter(p=>!parties.includes(p));
      if (newOnes.length) {
          const names = newOnes.map(p=>typeof p==="object"?p.name:p);
          const extras = newOnes.filter(p=>typeof p==="object");
          await api.post("/api/parties",{names, extras}).catch(()=>{});
        }
      setParties(prev => [...new Set([...prev,...importPreview])].sort());
      showToast(`${importPreview.length} parties added ✓`);
    } else if (importType==="firms") {
      try {
        for (const f of importPreview) {
          await api.post("/api/firms", { name: f.name, accounts: f.accounts||[] });
        }
        const firmsData = await api.get("/api/firms");
        const firmNames = firmsData.map(x=>x.name);
        const firmAccMap = {};
        firmsData.forEach(x => { firmAccMap[x.name] = (x.accounts||[]).map(a=>({bank:a.bank_name,acNo:a.ac_no,ifsc:a.ifsc||"",acType:a.ac_type||"Current"})); });
        setFirms(firmNames); setFirmAccounts(firmAccMap);
        showToast(`${importPreview.length} firms imported ✓`);
      } catch(e) { showToast(e.message,"error"); }
    }
    setImportPreview([]); setImportErrors([]); setImportStatus(""); setShowImport(false);
  };
  const openAdd = () => {
    if (!canEdit(currentUser?.role)) { showToast("Viewer role cannot add entries","error"); return; }
    const f = makeEmptyForm(firms);
    if (page==="firmview" && firmView) f.firm = firmView;
    setForm(f); setEditing(null); setShowForm(true);
  };
  const sf = (k,v) => setForm(p=>({...p,[k]:v}));

  const dupeWarning = useMemo(() => {
    if (!form?.chequeNo||!form?.firm||!showForm) return null;
    const exSameFirm = cheques.find(c=>c.firm===form.firm&&c.chequeNo===form.chequeNo&&(!editing||c.id!==editing.id));
    const exOtherFirm = !exSameFirm ? cheques.find(c=>c.firm!==form.firm&&c.chequeNo===form.chequeNo&&(!editing||c.id!==editing.id)) : null;
    const exSameParty = !exSameFirm&&!exOtherFirm&&form.fromTo ? cheques.find(c=>c.fromTo===form.fromTo&&c.chequeNo===form.chequeNo&&(!editing||c.id!==editing.id)) : null;
    if (exSameFirm) return `⚠️ Cheque ${form.chequeNo} already exists for ${form.firm} (Entry #${exSameFirm.id})`;
    if (exSameParty) return `⚠️ Cheque ${form.chequeNo} already exists from ${form.fromTo} in ${exSameParty.firm} (Entry #${exSameParty.id}) — same party, different firm`;
    if (exOtherFirm) return `⚠️ Cheque ${form.chequeNo} also exists in ${exOtherFirm.firm} (Entry #${exOtherFirm.id}) — please verify`;
    return null;
  }, [form?.chequeNo, form?.firm, showForm, cheques, editing]);

  // ── Firm management ──
  const handleAddFirm = async () => {
    if (!canAdmin(currentUser?.role)) { showToast("Admin/Manager only","error"); return; }
    const name = newFirmName.trim();
    if (!name) { showToast("Firm name is required","error"); return; }
    if (firms.includes(name)) { showToast("Firm already exists","error"); return; }
    const accounts = newFirmBank && newFirmAcNo ? [{ bank:newFirmBank, acNo:newFirmAcNo, acType:newFirmAcType, ifsc:newFirmIFSC||null }] : [];
    try {
      await api.post("/api/firms", { name, accounts });
      setFirms(prev => [...prev, name]);
      setFirmAccounts(prev => ({...prev, [name]: accounts.map(a=>({bank:a.bank,acNo:a.acNo,acType:a.acType,ifsc:a.ifsc||""}))}));
      setNewFirmName(""); setNewFirmBank(""); setNewFirmAcNo(""); setNewFirmIFSC(""); setNewFirmAcType("Current");
      showToast(`Firm "${name}" added ✓`);
    } catch(e) { showToast(e.message,"error"); }
  };
  const handleDeleteFirm = async (name) => {
    if (!canAdmin(currentUser?.role)) return;
    if (cheques.some(c=>c.firm===name)) { showToast("Cannot delete firm with existing cheque entries","error"); return; }
    if (!window.confirm(`Delete firm "${name}"? This cannot be undone.`)) return;
    try {
      const firmData = await api.get("/api/firms");
      const firm = firmData.find(f=>f.name===name);
      if (firm) await api.del(`/api/firms/${firm.id}`);
      setFirms(prev => prev.filter(f=>f!==name));
      setFirmAccounts(prev => { const n={...prev}; delete n[name]; return n; });
      showToast(`Firm "${name}" removed`,"error");
    } catch(e) { showToast(e.message,"error"); }
  };

  // ── User management ──
  const handleSaveUser = async () => {
    if (!userForm.name||!userForm.username) { showToast("Name and username required","error"); return; }
    if (!userForm.id && !userForm.password) { showToast("Password required for new user","error"); return; }
    try {
      if (userForm.id) {
        await api.put(`/api/users/${userForm.id}`, userForm);
        setUsers(prev => prev.map(u=>u.id===userForm.id?{...u,...userForm}:u));
      } else {
        const saved = await api.post("/api/users", userForm);
        setUsers(prev => [...prev, saved]);
      }
      showToast("User saved ✓"); setShowUserForm(false); setUserForm(null);
    } catch(e) { showToast(e.message,"error"); }
  };
  const handleDeleteUser = async (id) => {
    if (id===currentUser?.id) { showToast("Cannot delete your own account","error"); return; }
    if (!window.confirm("Delete this user?")) return;
    try {
      await api.put(`/api/users/${id}`, { ...users.find(u=>u.id===id), active: false });
      setUsers(prev => prev.filter(u=>u.id!==id));
      showToast("User deleted","error");
    } catch(e) { showToast(e.message,"error"); }
  };
  const handleToggleUser = async (id) => {
    if (id===currentUser?.id) { showToast("Cannot deactivate your own account","error"); return; }
    const user = users.find(u=>u.id===id);
    try {
      await api.put(`/api/users/${id}`, {...user, active: !user.active});
      setUsers(prev => prev.map(u=>u.id===id?{...u,active:!u.active}:u));
      showToast("Status updated ✓");
    } catch(e) { showToast(e.message,"error"); }
  };

  // ── CSV Export ──
  const exportCSV = () => {
    exportExcel(filtered, `CMS_Register_${nowISO()}.csv`);
    showToast("Exported ✓");
  };
  const exportReport = () => {
    exportExcel(reportData, `CMS_Report_${reportPeriod}_${nowISO()}.csv`);
    showToast("Report exported ✓");
  };

  const StatusSelect = ({status, id}) => {
    const cfg=scfg(status);
    return (
      <select value={status} onChange={e=>handleStatusChange(id,e.target.value)}
        disabled={!canEdit(currentUser?.role)}
        style={{background:cfg.bg,color:cfg.color,border:`1px solid ${cfg.border}`,borderRadius:20,padding:"3px 8px",fontSize:11,fontWeight:800,cursor:canEdit(currentUser?.role)?"pointer":"default"}}>
        {STATUSES.map(s=><option key={s}>{s}</option>)}
      </select>
    );
  };

  // ── Show login if not authenticated ──
  if (!currentUser) return <LoginScreen users={users} onLogin={setCurrentUser} />;
  if (currentUser && trialInfo) { const d = Math.ceil((new Date(trialInfo.expires_at)-new Date())/86400000); if(d<=0) return <TrialBanner expires_at={trialInfo.expires_at} status={trialInfo.status} />; }

  // ─────────────────────────────────────────────────────────────────────────────
  // MAIN LAYOUT
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{display:"flex",minHeight:"100vh",fontFamily:"'DM Sans','Segoe UI',sans-serif",background:"#EEF2F7"}}>

      {/* ── SIDEBAR ── */}
      <div style={{width:220,background:"#0A1628",color:"white",display:"flex",flexDirection:"column",flexShrink:0,position:"sticky",top:0,height:"100vh",overflowY:"auto"}}>
        <div style={{padding:"20px 18px 14px"}}>
          <div style={{fontSize:11,fontWeight:800,letterSpacing:"0.12em",color:"#60A5FA",textTransform:"uppercase"}}>◈ CMS v10</div>
          <div style={{fontSize:13,fontWeight:700,color:"white",marginTop:4,lineHeight:1.3}}>Cheque Management<br/>System</div>
        </div>
        <div style={{height:1,background:"#1E293B",margin:"0 18px 8px"}}></div>

        {[
          ["dashboard","📊","Dashboard"],
          ["register", "📋","Full Register"],
          ["firmview", "🏢","Firm View"],
          ["pending",  "⚠️","Action Required"],
          ["reports",  "📈","Reports"],
          ["accounts", "🏦","Bank Accounts"],
          ["chqbook",  "📒","Cheque Books"],
        ].map(([v,ic,lb])=>(
          <button key={v} onClick={()=>setPage(v)} style={{
            display:"flex",alignItems:"center",gap:10,padding:"9px 18px",
            background:page===v?"#1E3A5F":"transparent",
            color:page===v?"#93C5FD":"#64748B",border:"none",cursor:"pointer",textAlign:"left",
            fontSize:13,fontWeight:page===v?700:500,
            borderLeft:page===v?"3px solid #3B82F6":"3px solid transparent",transition:"all 0.12s"
          }}>
            <span style={{fontSize:15}}>{ic}</span>{lb}
            {v==="pending"&&agingAlerts.length>0&&<span style={{marginLeft:"auto",background:"#EF4444",color:"white",borderRadius:20,fontSize:9,fontWeight:800,padding:"1px 6px",minWidth:16,textAlign:"center"}}>{agingAlerts.length}</span>}
          </button>
        ))}

        {canAdmin(currentUser?.role) && (
          <>
            <div style={{height:1,background:"#1E293B",margin:"8px 18px"}}></div>
            <button onClick={()=>setShowUserMgmt(true)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 18px",background:"transparent",color:"#64748B",border:"none",cursor:"pointer",textAlign:"left",fontSize:13,fontWeight:500,borderLeft:"3px solid transparent"}}>
              <span style={{fontSize:15}}>👥</span>User Management
            </button>
            <button onClick={()=>setShowFirmMgmt(true)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 18px",background:"transparent",color:"#64748B",border:"none",cursor:"pointer",textAlign:"left",fontSize:13,fontWeight:500,borderLeft:"3px solid transparent"}}>
              <span style={{fontSize:15}}>🏛️</span>Firm Management
            </button>
            <button onClick={()=>setShowPartyMgmt(true)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 18px",background:"transparent",color:"#64748B",border:"none",cursor:"pointer",textAlign:"left",fontSize:13,fontWeight:500,borderLeft:"3px solid transparent"}}>
              <span style={{fontSize:15}}>📒</span>Party Master
            </button>
            <button onClick={()=>{setImportPreview([]);setImportErrors([]);setImportStatus("");setShowImport(true);}} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 18px",background:"transparent",color:"#64748B",border:"none",cursor:"pointer",textAlign:"left",fontSize:13,fontWeight:500,borderLeft:"3px solid transparent"}}>
              <span style={{fontSize:15}}>⬆️</span>Bulk Import
            </button>
            <button onClick={()=>setShowWhatsApp(true)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 18px",background:"transparent",color:"#25D366",border:"none",cursor:"pointer",textAlign:"left",fontSize:13,fontWeight:600,borderLeft:"3px solid transparent"}}>
              <span style={{fontSize:15}}>💬</span>WhatsApp Send
            </button>
            <button onClick={()=>setShowAudit(true)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 18px",background:"transparent",color:"#64748B",border:"none",cursor:"pointer",textAlign:"left",fontSize:13,fontWeight:500,borderLeft:"3px solid transparent"}}>
              <span style={{fontSize:15}}>🔍</span>Audit Trail
            </button>
            <button onClick={()=>setShowSettings(true)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 18px",background:"transparent",color:"#64748B",border:"none",cursor:"pointer",textAlign:"left",fontSize:13,fontWeight:500,borderLeft:"3px solid transparent"}}>
              <span style={{fontSize:15}}>⚙️</span>Settings
            </button>
          </>
        )}

        <div style={{marginTop:"auto",padding:"14px 18px",borderTop:"1px solid #1E293B"}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
            <div style={{width:7,height:7,borderRadius:"50%",background:storageOk?"#10B981":"#EF4444"}}></div>
            <span style={{fontSize:10,color:storageOk?"#6EE7B7":"#FCA5A5"}}>{storageOk?"Data saved":"Storage error"}</span>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:6}}>
            <div style={{width:28,height:28,borderRadius:"50%",background:ROLE_CFG[currentUser.role]?.bg||"#F1F5F9",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13}}>
              {currentUser.name[0].toUpperCase()}
            </div>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"white"}}>{currentUser.name}</div>
              <div style={{fontSize:10,color:"#64748B"}}>{currentUser.role}</div>
            </div>
          </div>
          <button onClick={()=>setCurrentUser(null)} style={{width:"100%",background:"#1E293B",border:"none",color:"#94A3B8",borderRadius:6,padding:"5px",fontSize:11,cursor:"pointer",fontWeight:600}}>
            Sign Out
          </button>
        </div>
      </div>

      {/* ── MAIN ── */}
      <div id="main-scroll-area" style={{flex:1,overflow:"auto",display:"flex",flexDirection:"column",minWidth:0}}>

        {/* Topbar */}
        <div style={{background:"white",borderBottom:"1px solid #E2E8F0",padding:"12px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:50,boxShadow:"0 1px 3px rgba(0,0,0,0.05)"}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:"#0F172A",letterSpacing:"-0.3px"}}>
              {{"dashboard":"📊 Dashboard","register":"📋 Full Register","firmview":"🏢 Firm View","pending":"⚠️ Action Required","reports":"📈 Reports","accounts":"🏦 Bank Accounts"}[page]}
            </div>
            <div style={{fontSize:11,color:"#94A3B8",marginTop:1}}>
              {new Date().toLocaleDateString("en-IN",{weekday:"long",day:"numeric",month:"long",year:"numeric"})}
            </div>
          </div>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            {page==="register" && <button onClick={()=>handlePrint("filtered")} style={{background:"white",border:"1px solid #E2E8F0",color:"#475569",borderRadius:8,padding:"8px 14px",fontWeight:600,cursor:"pointer",fontSize:12}}>🖨️ Print</button>}
            {page==="register" && <button onClick={exportCSV} style={{background:"white",border:"1px solid #E2E8F0",color:"#475569",borderRadius:8,padding:"8px 14px",fontWeight:600,cursor:"pointer",fontSize:12}}>⬇ Export CSV</button>}
            {page==="reports"  && <button onClick={exportReport} style={{background:"#059669",color:"white",border:"none",borderRadius:8,padding:"8px 16px",fontWeight:700,cursor:"pointer",fontSize:12}}>⬇ Export Excel</button>}
            {page==="reports"  && <button onClick={()=>{
              const w=window.open("","_blank","width=900,height=700");
              const rows=reportData;
              const partyMap={};
              rows.forEach(c=>{const p=c.fromTo||"Unknown";if(!partyMap[p])partyMap[p]={name:p,inward:0,outward:0,cleared:0,pending:0,bounced:0,count:0};if(c.type==="inward")partyMap[p].inward+=c.amount;else partyMap[p].outward+=c.amount;if(c.status==="Cleared")partyMap[p].cleared+=c.amount;if(c.status==="Pending")partyMap[p].pending+=c.amount;if(c.status==="Bounced")partyMap[p].bounced+=c.amount;partyMap[p].count++;});
              const parties=Object.values(partyMap).sort((a,b)=>(b.inward+b.outward)-(a.inward+a.outward));
              w.document.write(`<!DOCTYPE html><html><head><title>SmartCABuddy Report</title>
              <style>body{font-family:Arial,sans-serif;padding:20px;color:#1e293b;font-size:12px}
              h1{font-size:18px;color:#0A1628;margin-bottom:4px}
              h2{font-size:13px;color:#475569;font-weight:normal;margin-bottom:16px}
              h3{font-size:12px;color:#0A1628;margin:20px 0 8px;padding-bottom:4px;border-bottom:2px solid #0A1628}
              table{width:100%;border-collapse:collapse;margin-bottom:20px}
              th{background:#0A1628;color:white;padding:7px 10px;text-align:left;font-size:10px;text-transform:uppercase}
              td{padding:6px 10px;border-bottom:1px solid #F1F5F9;font-size:11px}
              tr:nth-child(even){background:#F8FAFC}
              .total{background:#0A1628;color:white;font-weight:bold}
              .summary{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-bottom:20px}
              .card{background:#F8FAFC;border:1px solid #E2E8F0;border-radius:6px;padding:10px;text-align:center}
              .card .val{font-size:16px;font-weight:bold;color:#0A1628}
              .card .lbl{font-size:9px;color:#64748B;text-transform:uppercase;margin-top:3px}
              @media print{button{display:none}}</style></head><body>
              <h1>SmartCABuddy — Cheque Management Report</h1>
              <h2>${reportPeriod==="MTD"?monthLabel(thisMonth()):reportPeriod==="YTD"?"Year "+thisYear():reportFrom+" to "+reportTo} | ${reportFirm==="All"?"All Firms":reportFirm} | ${rows.length} entries</h2>
              <div class="summary">
                <div class="card"><div class="val">${fmt(reportTotals.total)}</div><div class="lbl">Total</div></div>
                <div class="card"><div class="val" style="color:#059669">${fmt(reportTotals.cleared)}</div><div class="lbl">Cleared</div></div>
                <div class="card"><div class="val" style="color:#D97706">${fmt(reportTotals.pending)}</div><div class="lbl">Pending</div></div>
                <div class="card"><div class="val" style="color:#DC2626">${fmt(reportTotals.bounced)}</div><div class="lbl">Bounced</div></div>
              </div>
              <h3>Party-wise Summary</h3>
              <table><thead><tr><th>Party</th><th>Inward</th><th>Outward</th><th>Cleared</th><th>Pending</th><th>Bounced</th><th>Entries</th></tr></thead><tbody>
              ${parties.map(p=>`<tr><td>${p.name}</td><td>${fmt(p.inward)}</td><td>${fmt(p.outward)}</td><td>${p.cleared>0?fmt(p.cleared):"—"}</td><td>${p.pending>0?fmt(p.pending):"—"}</td><td style="color:${p.bounced>0?"#DC2626":"inherit"}">${p.bounced>0?fmt(p.bounced):"—"}</td><td>${p.count}</td></tr>`).join("")}
              </tbody></table>
              <h3>Detailed Entries (${rows.length})</h3>
              <table><thead><tr><th>Date</th><th>Type</th><th>Firm</th><th>Party</th><th>Cheque No</th><th>Amount</th><th>Status</th><th>Realisation</th></tr></thead><tbody>
              ${rows.map(c=>`<tr><td>${c.date}</td><td>${c.type.toUpperCase()}</td><td>${c.firm}</td><td>${c.fromTo}</td><td>${c.chequeNo}</td><td>${fmt(c.amount)}</td><td>${c.status}</td><td>${c.realisationDate||"—"}</td></tr>`).join("")}
              </tbody></table>
              <div style="text-align:center;font-size:10px;color:#94A3B8;margin-top:20px;border-top:1px solid #F1F5F9;padding-top:10px">SmartCABuddy — www.smartcabuddy.com | Printed: ${new Date().toLocaleString("en-IN")}</div>
              <br><button onclick="window.print()" style="padding:8px 20px;background:#0A1628;color:white;border:none;border-radius:6px;cursor:pointer">Print / Save as PDF</button>
              </body></html>`);
              w.document.close();
            }} style={{background:"#7C3AED",color:"white",border:"none",borderRadius:8,padding:"8px 16px",fontWeight:700,cursor:"pointer",fontSize:12}}>📄 Export PDF</button>}
            {page==="reports"  && <button onClick={()=>handlePrint("filtered")} style={{background:"white",border:"1px solid #E2E8F0",color:"#475569",borderRadius:8,padding:"8px 14px",fontWeight:600,cursor:"pointer",fontSize:12}}>🖨️ Print</button>}
            {canEdit(currentUser?.role) && (
              <button onClick={openAdd} style={{background:"#0A1628",color:"white",border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",gap:6}}>
                <span style={{fontSize:17,lineHeight:1}}>+</span>Add Cheque
              </button>
            )}
          </div>
        </div>

        <div style={{flex:1,padding:"20px 24px",overflow:"auto"}}>

          {/* ══ DASHBOARD ══ */}
          {page==="dashboard" && (
            <div>
              <div style={{display:"flex",justifyContent:"flex-end",marginBottom:18}}>
                <select value={dashMonth} onChange={e=>setDashMonth(e.target.value)} style={{border:"1px solid #E2E8F0",borderRadius:8,padding:"7px 12px",fontSize:13,fontWeight:600,background:"white"}}>
                  <option value="All">All Time</option>
                  {months.map(m=><option key={m} value={m}>{monthLabel(m)}</option>)}
                </select>
              </div>

              {/* Inward Cheques Block */}
              <div style={{marginBottom:20}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                  <div style={{background:"#042C53",color:"#85B7EB",fontSize:11,fontWeight:700,letterSpacing:"0.07em",textTransform:"uppercase",padding:"6px 14px",borderRadius:6,border:"1px solid #0C447C"}}>Inward Cheques (Received)</div>
                  <button onClick={()=>{setFFirm("All");setFType("inward");setFStatus("All");setPage("register");}} style={{fontSize:11,color:"#185FA5",background:"none",border:"none",cursor:"pointer",textDecoration:"underline"}}>View all inward →</button>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:10}}>
                  {[
                    {l:"Total Inward",  v:fmt(dashCheques.filter(c=>c.type==="inward").reduce((s,c)=>s+c.amount,0)),  sub:dashCheques.filter(c=>c.type==="inward").length+(dashCheques.filter(c=>c.type==="inward").length===1?" cheque":" cheques"),  bg:"#042C53",tc:"white",border:"1px solid #0C447C",  stc:"#85B7EB",fn:()=>{setFFirm("All");setFType("inward");setFStatus("All");setPage("register");}},
                    {l:"Cleared",       v:fmt(dashCheques.filter(c=>c.type==="inward"&&c.status==="Cleared").reduce((s,c)=>s+c.amount,0)),      sub:dashCheques.filter(c=>c.type==="inward"&&c.status==="Cleared").length+(dashCheques.filter(c=>c.type==="inward"&&c.status==="Cleared").length===1?" cheque":" cheques"),      bg:"#173404",tc:"white",border:"1px solid #3B6D11",stc:"#97C459",fn:()=>{setFFirm("All");setFType("inward");setFStatus("Cleared");setPage("register");}},
                    {l:"Pending",       v:fmt(dashCheques.filter(c=>c.type==="inward"&&c.status==="Pending").reduce((s,c)=>s+c.amount,0)),      sub:dashCheques.filter(c=>c.type==="inward"&&c.status==="Pending").length+(dashCheques.filter(c=>c.type==="inward"&&c.status==="Pending").length===1?" cheque":" cheques"),       bg:"#412402",tc:"white",border:"1px solid #854F0B",stc:"#EF9F27",fn:()=>{setFFirm("All");setFType("inward");setFStatus("Pending");setPage("register");}},
                    {l:"In Collection", v:fmt(dashCheques.filter(c=>c.type==="inward"&&c.status==="In Collection").reduce((s,c)=>s+c.amount,0)),sub:dashCheques.filter(c=>c.type==="inward"&&c.status==="In Collection").length+(dashCheques.filter(c=>c.type==="inward"&&c.status==="In Collection").length===1?" cheque":" cheques"),  bg:"#26215C",tc:"white",border:"1px solid #534AB7",stc:"#AFA9EC",fn:()=>{setFFirm("All");setFType("inward");setFStatus("In Collection");setPage("register");}},
                    {l:"Bounced",       v:fmt(dashCheques.filter(c=>c.type==="inward"&&c.status==="Bounced").reduce((s,c)=>s+c.amount,0)),      sub:dashCheques.filter(c=>c.type==="inward"&&c.status==="Bounced").length+(dashCheques.filter(c=>c.type==="inward"&&c.status==="Bounced").length===1?" cheque":" cheques"),       bg:"#501313",tc:"white",border:"1px solid #A32D2D",stc:"#F09595",fn:()=>{setFFirm("All");setFType("inward");setFStatus("Bounced");setPage("register");}},
                  ].map(k=>(
                    <div key={k.l} onClick={k.fn} style={{background:k.bg,borderRadius:12,padding:"14px 16px",cursor:"pointer",transition:"transform 0.12s,box-shadow 0.12s",boxShadow:"0 2px 8px rgba(0,0,0,0.2)",border:k.border||"none"}}
                      onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 4px 14px rgba(0,0,0,0.1)";}}
                      onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
                      <div style={{fontSize:9,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.07em",color:k.stc,marginBottom:6}}>{k.l}</div>
                      <div style={{fontSize:16,fontWeight:800,color:k.tc,marginBottom:2}}>{k.v}</div>
                      <div style={{fontSize:10,color:k.stc}}>{k.sub}</div>
                      <div style={{fontSize:10,color:k.stc,marginTop:5,textDecoration:"underline"}}>View →</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Outward Cheques Block */}
              <div style={{marginBottom:20}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                  <div style={{background:"#173404",color:"#97C459",fontSize:11,fontWeight:700,letterSpacing:"0.07em",textTransform:"uppercase",padding:"6px 14px",borderRadius:6,border:"1px solid #3B6D11"}}>Outward Cheques (Issued)</div>
                  <button onClick={()=>{setFFirm("All");setFType("outward");setFStatus("All");setPage("register");}} style={{fontSize:11,color:"#27500A",background:"none",border:"none",cursor:"pointer",textDecoration:"underline"}}>View all outward →</button>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:10}}>
                  {[
                    {l:"Total Outward", v:fmt(dashCheques.filter(c=>c.type==="outward").reduce((s,c)=>s+c.amount,0)), sub:dashCheques.filter(c=>c.type==="outward").length+(dashCheques.filter(c=>c.type==="outward").length===1?" cheque":" cheques"), bg:"#042C53",tc:"white",border:"1px solid #0C447C",  stc:"#85B7EB",fn:()=>{setFFirm("All");setFType("outward");setFStatus("All");setPage("register");}},
                    {l:"Cleared",       v:fmt(dashCheques.filter(c=>c.type==="outward"&&c.status==="Cleared").reduce((s,c)=>s+c.amount,0)),      sub:dashCheques.filter(c=>c.type==="outward"&&c.status==="Cleared").length+(dashCheques.filter(c=>c.type==="outward"&&c.status==="Cleared").length===1?" cheque":" cheques"),      bg:"#173404",tc:"white",border:"1px solid #3B6D11",stc:"#97C459",fn:()=>{setFFirm("All");setFType("outward");setFStatus("Cleared");setPage("register");}},
                    {l:"Pending",       v:fmt(dashCheques.filter(c=>c.type==="outward"&&c.status==="Pending").reduce((s,c)=>s+c.amount,0)),      sub:dashCheques.filter(c=>c.type==="outward"&&c.status==="Pending").length+(dashCheques.filter(c=>c.type==="outward"&&c.status==="Pending").length===1?" cheque":" cheques"),       bg:"#412402",tc:"white",border:"1px solid #854F0B",stc:"#EF9F27",fn:()=>{setFFirm("All");setFType("outward");setFStatus("Pending");setPage("register");}},
                    {l:"In Collection", v:fmt(dashCheques.filter(c=>c.type==="outward"&&c.status==="In Collection").reduce((s,c)=>s+c.amount,0)),sub:dashCheques.filter(c=>c.type==="outward"&&c.status==="In Collection").length+(dashCheques.filter(c=>c.type==="outward"&&c.status==="In Collection").length===1?" cheque":" cheques"),  bg:"#26215C",tc:"white",border:"1px solid #534AB7",stc:"#AFA9EC",fn:()=>{setFFirm("All");setFType("outward");setFStatus("In Collection");setPage("register");}},
                    {l:"Bounced",       v:fmt(dashCheques.filter(c=>c.type==="outward"&&c.status==="Bounced").reduce((s,c)=>s+c.amount,0)),      sub:dashCheques.filter(c=>c.type==="outward"&&c.status==="Bounced").length+(dashCheques.filter(c=>c.type==="outward"&&c.status==="Bounced").length===1?" cheque":" cheques"),       bg:"#501313",tc:"white",border:"1px solid #A32D2D",stc:"#F09595",fn:()=>{setFFirm("All");setFType("outward");setFStatus("Bounced");setPage("register");}},
                  ].map(k=>(
                    <div key={k.l} onClick={k.fn} style={{background:k.bg,borderRadius:12,padding:"14px 16px",cursor:"pointer",transition:"transform 0.12s,box-shadow 0.12s",boxShadow:"0 2px 8px rgba(0,0,0,0.12)"}}
                      onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 4px 14px rgba(0,0,0,0.1)";}}
                      onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
                      <div style={{fontSize:9,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.07em",color:k.stc,marginBottom:6}}>{k.l}</div>
                      <div style={{fontSize:16,fontWeight:800,color:k.tc,marginBottom:2}}>{k.v}</div>
                      <div style={{fontSize:10,color:k.stc}}>{k.sub}</div>
                      <div style={{fontSize:10,color:k.stc,marginTop:5,textDecoration:"underline"}}>View →</div>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden",marginBottom:18}}>
                <div style={{padding:"13px 18px",borderBottom:"1px solid #F1F5F9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontWeight:800,fontSize:14,color:"#0F172A"}}>Firm-wise Summary</div>
                  <div style={{fontSize:11,color:"#94A3B8"}}>Click row → Firm View</div>
                </div>
                {/* == DONUT CHARTS == */}
                {dashCheques.length > 0 && (()=>{
                  const _st=["Cleared","Pending","In Collection","Bounced"];
                  const _sc=["#059669","#D97706","#2563EB","#DC2626"];
                  const _sl=["#D1FAE5","#FEF3C7","#DBEAFE","#FEE2E2"];
                  const _fc=["#6366F1","#0EA5E9","#10B981","#F59E0B","#EF4444","#8B5CF6","#EC4899","#14B8A6"];
                  const _firms=[...new Set(dashCheques.map(c=>c.firm))].slice(0,8);
                  const inC=dashCheques.filter(c=>c.type==="inward");
                  const outC=dashCheques.filter(c=>c.type==="outward");
                  const mkS=(data,labels,colors,light)=>{
                    const tot=data.reduce((a,b)=>a+b,0)||1;
                    return data.map((v,i)=>({pct:(v/tot)*100,color:colors[i%colors.length],light:light?light[i%light.length]:"#F1F5F9",label:labels[i],val:v})).filter(s=>s.val>0);
                  };
                  const DC=({slices,title,subtitle,total,onSliceClick})=>{
                    const r=44,cx=56,cy=56,ci=2*Math.PI*r; let off=0;
                    return (
                      <div style={{background:"white",borderRadius:16,padding:"20px 22px",boxShadow:"0 1px 6px rgba(0,0,0,0.07)",flex:1,minWidth:240,border:"1px solid #F1F5F9"}}>
                        <div style={{marginBottom:14}}>
                          <div style={{fontWeight:800,fontSize:14,color:"#0F172A"}}>{title}</div>
                          {subtitle&&<div style={{fontSize:11,color:"#94A3B8",marginTop:2}}>{subtitle}</div>}
                        </div>
                        <div style={{display:"flex",gap:18,alignItems:"center"}}>
                          <svg width={112} height={112} viewBox="0 0 112 112" style={{flexShrink:0}}>
                            <circle cx={cx} cy={cy} r={r} fill="none" stroke="#F1F5F9" strokeWidth={13}/>
                            {slices.map((s,i)=>{const d=(s.pct/100)*ci,g=ci-d,el=<circle key={i} cx={cx} cy={cy} r={r} fill="none" stroke={s.color} strokeWidth={13} strokeDasharray={d+" "+g} strokeDashoffset={ci*0.25-off} style={{cursor:onSliceClick?"pointer":"default"}} onClick={()=>onSliceClick&&onSliceClick(s)}/>;off+=d;return el;})}
                            <text x={cx} y={cy-7} textAnchor="middle" fontSize={20} fontWeight={800} fill="#0F172A">{total}</text>
                            <text x={cx} y={cy+9} textAnchor="middle" fontSize={9} fill="#94A3B8">cheques</text>
                          </svg>
                          <div style={{display:"flex",flexDirection:"column",gap:7,flex:1,minWidth:0}}>
                            {slices.map((s,i)=>(
                              <div key={i} onClick={()=>onSliceClick&&onSliceClick(s)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:4,cursor:onSliceClick?"pointer":"default",borderRadius:4,padding:"1px 3px",transition:"background 0.15s"}} onMouseEnter={e=>{if(onSliceClick)e.currentTarget.style.background="#F1F5F9"}} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                                <div style={{display:"flex",alignItems:"center",gap:6,minWidth:0}}>
                                  <div style={{width:8,height:8,borderRadius:"50%",background:s.color,flexShrink:0}}></div>
                                  <span style={{fontSize:11,color:"#475569",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.label}</span>
                                </div>
                                <div style={{display:"flex",gap:4,flexShrink:0}}>
                                  <span style={{fontSize:12,fontWeight:700,color:s.color}}>{s.val}</span>
                                  <span style={{fontSize:10,color:"#94A3B8",background:s.light,borderRadius:4,padding:"1px 5px",fontWeight:600}}>{Math.round(s.pct)}%</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  };
                  return (
                    <div style={{marginBottom:20}}>
                      <div style={{fontSize:11,fontWeight:700,color:"#94A3B8",letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10}}>Status Breakdown</div>
                      <div style={{display:"flex",gap:14,flexWrap:"wrap",marginBottom:16}}>
                        <DC slices={mkS(_st.map(s=>inC.filter(c=>c.status===s).length),_st,_sc,_sl)} title="Inward Cheques" subtitle={"Received - "+inC.length+" total"} total={inC.length} onSliceClick={(s)=>{setFFirm("All");setFType("inward");setFStatus(s.label);setPage("register");}}/>
                        <DC slices={mkS(_st.map(s=>outC.filter(c=>c.status===s).length),_st,_sc,_sl)} title="Outward Cheques" subtitle={"Issued - "+outC.length+" total"} total={outC.length}/>
                        <DC slices={mkS([inC.length,outC.length],["Inward","Outward"],["#2563EB","#059669"],["#DBEAFE","#D1FAE5"])} title="Inward vs Outward" subtitle={"All - "+dashCheques.length+" total"} total={dashCheques.length}/>
                      </div>
                      {_firms.length>1&&(
                        <div>
                          <div style={{fontSize:11,fontWeight:700,color:"#94A3B8",letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10}}>Firm-wise Volume</div>
                          <div style={{display:"flex",gap:14,flexWrap:"wrap"}}>
                            <DC slices={mkS(_firms.map(f=>dashCheques.filter(c=>c.firm===f).length),_firms,_fc)} title="All Cheques by Firm" subtitle="Combined inward + outward" total={dashCheques.length} onSliceClick={(s)=>{setFFirm(s.label);setFType("All");setFStatus("All");setPage("register");}}/>
                            <DC slices={mkS(_firms.map(f=>inC.filter(c=>c.firm===f).length),_firms,_fc)} title="Inward by Firm" subtitle="Received per firm" total={inC.length} onSliceClick={(s)=>{setFFirm(s.label);setFType("inward");setFStatus("All");setPage("register");}}/>
                            {outC.length>0&&<DC slices={mkS(_firms.map(f=>outC.filter(c=>c.firm===f).length),_firms,_fc)} title="Outward by Firm" subtitle="Issued per firm" total={outC.length} onSliceClick={(s)=>{setFFirm(s.label);setFType("outward");setFStatus("All");setPage("register");}}/>}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()}
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse"}}>
                    <thead><tr style={{background:"#F8FAFC"}}>
                      {["Firm","Inward","Cleared","Pending","Outward","Cleared","⚠ Bounced","🏦 In Coll","⏳ Pending"].map((h,i)=>(
                        <th key={i} style={{padding:"10px 13px",textAlign:"left",fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid #F1F5F9",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {firmStats.length===0&&<tr><td colSpan={9} style={{padding:30,textAlign:"center",color:"#94A3B8"}}>No data for selected period</td></tr>}
                      {firmStats.map((f,i)=>(
                        <tr key={f.firm} onClick={()=>{setFirmView(f.firm);setPage("firmview");}}
                          style={{background:i%2?"#FAFBFC":"white",cursor:"pointer",borderBottom:"1px solid #F8FAFC"}}
                          onMouseEnter={e=>e.currentTarget.style.background="#F0F9FF"}
                          onMouseLeave={e=>e.currentTarget.style.background=i%2?"#FAFBFC":"white"}>
                          <td style={{padding:"10px 13px"}}><div style={{display:"flex",alignItems:"center",gap:7}}>
                            <div style={{width:8,height:8,borderRadius:"50%",background:FIRM_COLORS[f.fi%20],flexShrink:0}}></div>
                            <span style={{fontWeight:700,color:"#0F172A",fontSize:12,whiteSpace:"nowrap"}}>{f.firm}</span>
                          </div></td>
                          <td style={{padding:"10px 13px",fontSize:12}}>{fmt(f.inTotal)}</td>
                          <td style={{padding:"10px 13px",fontSize:12,color:"#059669",fontWeight:700}}>{fmt(f.inCleared)}</td>
                          <td style={{padding:"10px 13px",fontSize:12,color:"#D97706",fontWeight:700}}>{fmt(f.inPending)}</td>
                          <td style={{padding:"10px 13px",fontSize:12}}>{fmt(f.outTotal)}</td>
                          <td style={{padding:"10px 13px",fontSize:12,color:"#059669",fontWeight:700}}>{fmt(f.outCleared)}</td>
                          <td style={{padding:"10px 13px"}}><span style={{background:f.bounced>0?"#FEE2E2":"#F1F5F9",color:f.bounced>0?"#DC2626":"#CBD5E1",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:800}}>{f.bounced}</span></td>
                          <td style={{padding:"10px 13px"}}><span style={{background:f.inColl>0?"#DBEAFE":"#F1F5F9",color:f.inColl>0?"#1D4ED8":"#CBD5E1",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:800}}>{f.inColl}</span></td>
                          <td style={{padding:"10px 13px"}}><span style={{background:f.pending>0?"#FEF3C7":"#F1F5F9",color:f.pending>0?"#92400E":"#CBD5E1",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:800}}>{f.pending}</span></td>
                        </tr>
                      ))}
                    </tbody>
                    {firmStats.length>1&&<tfoot><tr style={{background:"#0A1628",color:"white"}}>
                      <td style={{padding:"11px 13px",fontWeight:800,fontSize:12}}>GRAND TOTAL</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12}}>{fmt(firmStats.reduce((s,f)=>s+f.inTotal,0))}</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12,color:"#6EE7B7"}}>{fmt(firmStats.reduce((s,f)=>s+f.inCleared,0))}</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12,color:"#FCD34D"}}>{fmt(firmStats.reduce((s,f)=>s+f.inPending,0))}</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12}}>{fmt(firmStats.reduce((s,f)=>s+f.outTotal,0))}</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12,color:"#6EE7B7"}}>{fmt(firmStats.reduce((s,f)=>s+f.outCleared,0))}</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12,color:"#FCA5A5"}}>{firmStats.reduce((s,f)=>s+f.bounced,0)}</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12,color:"#93C5FD"}}>{firmStats.reduce((s,f)=>s+f.inColl,0)}</td>
                      <td style={{padding:"11px 13px",fontWeight:700,fontSize:12,color:"#FCD34D"}}>{firmStats.reduce((s,f)=>s+f.pending,0)}</td>
                    </tr></tfoot>}
                  </table>
                </div>
              </div>
              {/* Monthly chart */}
              {false&&(
                <div style={{background:"white",borderRadius:12,padding:"20px 22px",boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
                    <div>
                      <div style={{fontWeight:800,fontSize:15,color:"#0F172A",letterSpacing:"-0.3px"}}>Monthly Volume</div>
                      <div style={{fontSize:11,color:"#94A3B8",marginTop:3}}>Inward vs Outward — last {monthlyData.length} month{monthlyData.length>1?"s":""}</div>
                    </div>
                    <div style={{display:"flex",gap:16,alignItems:"center"}}>
                      {[["#042C53","#185FA5","Inward"],["#173404","#3B6D11","Outward"]].map(([bg,border,l])=>(
                        <div key={l} style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"#64748B",fontWeight:600}}>
                          <div style={{width:14,height:14,background:bg,borderRadius:3,border:`1px solid ${border}`}}></div>
                          {l}
                        </div>
                      ))}
                    </div>
                  </div>
                  {(()=>{
                    const maxV=Math.max(...monthlyData.map(([,d])=>Math.max(d.inward,d.outward)),1);
                    return (
                      <div style={{display:"flex",gap:4,alignItems:"flex-end",height:180}}>
                        {monthlyData.map(([m,d])=>{
                          const inH=Math.max(Math.round((d.inward/maxV)*150),d.inward>0?4:0);
                          const outH=Math.max(Math.round((d.outward/maxV)*150),d.outward>0?4:0);
                          return (
                            <div key={m} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",minWidth:0}}>
                              <div style={{width:"100%",display:"flex",gap:3,justifyContent:"center",alignItems:"flex-end",height:155,paddingBottom:4}}>
                                <div style={{flex:1,background:"#042C53",borderRadius:"4px 4px 0 0",height:inH,border:"1px solid #185FA5",minWidth:6,cursor:"pointer",transition:"opacity 0.15s"}}
                                  onMouseEnter={e=>e.currentTarget.style.opacity="0.8"}
                                  onMouseLeave={e=>e.currentTarget.style.opacity="1"}
                                  title={`Inward: ${fmt(d.inward)}`}/>
                                <div style={{flex:1,background:"#173404",borderRadius:"4px 4px 0 0",height:outH,border:"1px solid #3B6D11",minWidth:6,cursor:"pointer",transition:"opacity 0.15s"}}
                                  onMouseEnter={e=>e.currentTarget.style.opacity="0.8"}
                                  onMouseLeave={e=>e.currentTarget.style.opacity="1"}
                                  title={`Outward: ${fmt(d.outward)}`}/>
                              </div>
                              <div style={{width:"100%",borderTop:"2px solid #E2E8F0"}}></div>
                              <div style={{fontSize:9,color:"#94A3B8",textAlign:"center",fontWeight:600,marginTop:5,whiteSpace:"nowrap"}}>{monthLabel(m).replace(/ \d{4}/,"")}</div>
                              <div style={{fontSize:8,color:"#CBD5E1",textAlign:"center",marginTop:1}}>{m.slice(0,4)}</div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })()}
                  <div style={{borderTop:"1px solid #F1F5F9",marginTop:14,paddingTop:12,display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                    <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
                      <div style={{fontSize:12,color:"#64748B"}}>Total Inward: <span style={{fontWeight:800,color:"#185FA5"}}>{fmt(monthlyData.reduce((s,[,d])=>s+d.inward,0))}</span></div>
                      <div style={{fontSize:12,color:"#64748B"}}>Total Outward: <span style={{fontWeight:800,color:"#3B6D11"}}>{fmt(monthlyData.reduce((s,[,d])=>s+d.outward,0))}</span></div>
                    </div>
                    <div style={{fontSize:11,color:"#CBD5E1"}}>Hover bars for details</div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ══ REGISTER ══ */}
          {page==="register" && (
            <div>
              <div style={{background:"white",borderRadius:12,padding:14,marginBottom:14,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
                <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
                  {[
                    {l:"Today",     fn:()=>{const t=new Date().toISOString().slice(0,10);setFMonth("All");setFDateFrom(t);setFDateTo(t);}},
                    {l:"This Week", fn:()=>{const n=new Date(),d=new Date(n);d.setDate(n.getDate()-n.getDay());setFMonth("All");setFDateFrom(d.toISOString().slice(0,10));setFDateTo(n.toISOString().slice(0,10));}},
                    {l:"This Month",fn:()=>{setFMonth(new Date().toISOString().slice(0,7));setFDateFrom("");setFDateTo("");}},
                    {l:"All",       fn:()=>{setFMonth("All");setFDateFrom("");setFDateTo("");}},
                  ].map(({l,fn})=>(
                    <button key={l} onClick={fn} style={{padding:"5px 14px",borderRadius:20,border:"1px solid #E2E8F0",background:"white",fontSize:11,fontWeight:600,color:"#374151",cursor:"pointer"}}>{l}</button>
                  ))}
                </div>
                <input value={fSearch} onChange={e=>setFSearch(e.target.value)} placeholder="🔍  Search party, cheque no, firm…"
                  style={{border:"1px solid #E2E8F0",borderRadius:8,padding:"7px 12px",fontSize:13,minWidth:200,flex:1}} />
                {[{v:fFirm,s:setFFirm,opts:["All",...firms]},{v:fType,s:setFType,opts:["All","inward","outward"]},{v:fStatus,s:setFStatus,opts:["All",...STATUSES]},{v:fMonth,s:setFMonth,opts:["All",...months]}].map((f,i)=>(
                  <select key={i} value={f.v} onChange={e=>f.s(e.target.value)} style={{border:"1px solid #E2E8F0",borderRadius:8,padding:"7px 10px",fontSize:12,minWidth:120}}>
                    {f.opts.map(o=><option key={o}>{o}</option>)}
                  </select>
                ))}
                <div style={{background:"#F8FAFC",borderRadius:8,padding:"7px 12px",fontSize:12,fontWeight:700,color:"#0F172A",borderLeft:"3px solid #3B82F6",whiteSpace:"nowrap"}}>
                  {filtered.length} entries &nbsp;|&nbsp; {fmt(filtered.reduce((s,c)=>s+c.amount,0))}
                </div>
              </div>

              {/* ── Bulk action bar — always visible when canEdit ── */}
              {canEdit(currentUser?.role) && (
                <div style={{background:"#1E3A5F",borderRadius:10,padding:"10px 16px",marginBottom:12,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
                  <span style={{fontSize:12,fontWeight:700,color:"#93C5FD",whiteSpace:"nowrap"}}>
                    {selectedIds.length>0 ? `✅ ${selectedIds.length} selected` : "Bulk Update:"}
                  </span>
                  <select value={bulkStatus} onChange={e=>setBulkStatus(e.target.value)}
                    style={{border:"1px solid #3B82F6",borderRadius:7,padding:"6px 12px",fontSize:12,fontWeight:700,background:"#0A1628",color:"white",minWidth:150,cursor:"pointer"}}>
                    <option value="">— Pick status —</option>
                    {STATUSES.map(s=><option key={s} value={s}>{s}</option>)}
                  </select>
                  <button onClick={handleBulkUpdate}
                    style={{background:selectedIds.length>0&&bulkStatus?"#3B82F6":"#334155",color:"white",border:"none",borderRadius:7,padding:"7px 18px",fontWeight:700,cursor:"pointer",fontSize:12,opacity:selectedIds.length>0&&bulkStatus?1:0.6}}>
                    Apply to {selectedIds.length>0?`${selectedIds.length} rows`:"selected"}
                  </button>
                  {selectedIds.length>0 && (
                    <button onClick={()=>setSelectedIds([])} style={{background:"transparent",border:"1px solid #475569",color:"#94A3B8",borderRadius:7,padding:"5px 12px",cursor:"pointer",fontSize:11}}>
                      ✕ Clear
                    </button>
                  )}
                  <span style={{marginLeft:"auto",fontSize:11,color:"#64748B"}}>☑ Shift+Click to select • Click row to open</span>
                </div>
              )}

              <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead><tr style={{background:"#0A1628",color:"white"}}>
                      <th style={{padding:"10px 12px",width:40}}>
                        <input type="checkbox"
                          checked={selectedIds.length===filtered.length && filtered.length>0}
                          onChange={toggleSelectAll}
                          style={{cursor:"pointer",width:15,height:15}} />
                      </th>
                      {["#","Date","Dep. Date","Type","Firm","Party","Cheque No","Chq Date","Amount","Drawer","Drawee","Deposited By","Status","Age","Realisation","Actions"].map(h=>(
                        <th key={h} style={{padding:"10px 12px",textAlign:"left",fontWeight:600,fontSize:10,textTransform:"uppercase",letterSpacing:"0.05em",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {filtered.length===0&&<tr><td colSpan={16} style={{padding:48,textAlign:"center",color:"#94A3B8",fontSize:14}}>No entries match filters.</td></tr>}
                      {filtered.map((c,i)=>(
                        <tr key={c.id} style={{background:selectedIds.includes(c.id)?"#DBEAFE":i%2?"#FAFBFC":"white",borderBottom:"1px solid #F1F5F9",cursor:"pointer"}}
                          onClick={e=>{ if(e.target.tagName==="INPUT"||e.target.tagName==="SELECT"||e.target.tagName==="BUTTON") return; if(e.shiftKey||e.ctrlKey||e.metaKey) { toggleSelect(c.id); return; } handleEdit(c); }}
          title="Click to open • Shift+Click to select">
                          <td style={{padding:"8px 12px"}} onClick={e=>e.stopPropagation()}>
                            <input type="checkbox" checked={selectedIds.includes(c.id)} onChange={()=>toggleSelect(c.id)} style={{cursor:"pointer",width:15,height:15}} />
                          </td>
                          <td style={{padding:"8px 12px",color:"#CBD5E1",fontWeight:700,fontSize:10}}>{c.id}</td>
                          <td style={{padding:"8px 12px",fontWeight:600,whiteSpace:"nowrap"}}>{c.date}</td>
                          <td style={{padding:"8px 12px",fontSize:11,color:"#64748B",whiteSpace:"nowrap"}}>{c.depositDate||"—"}</td>
                          <td style={{padding:"8px 12px"}}>
                            <span style={{background:c.type==="inward"?"#DBEAFE":"#FCE7F3",color:c.type==="inward"?"#1D4ED8":"#BE185D",padding:"2px 7px",borderRadius:20,fontSize:10,fontWeight:800,textTransform:"uppercase"}}>{c.type}</span>
                          </td>
                          <td style={{padding:"8px 12px",fontSize:11,maxWidth:110,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"#475569"}}>{c.firm}</td>
                          <td style={{padding:"8px 12px",fontWeight:700,color:"#0F172A",whiteSpace:"nowrap"}}>{c.fromTo}</td>
                          <td style={{padding:"8px 12px",fontFamily:"monospace",fontWeight:700,color:"#1E3A5F"}}>{c.chequeNo}</td>
                          <td style={{padding:"8px 12px",fontSize:11,color:"#64748B",whiteSpace:"nowrap"}}>{c.chequeDate}</td>
                          <td style={{padding:"8px 12px",fontWeight:900,color:"#0F172A",whiteSpace:"nowrap"}}>{fmt(c.amount)}</td>
                          <td style={{padding:"8px 12px",fontSize:11,color:"#64748B",whiteSpace:"nowrap"}}>{displayVal(c.drawer)}</td>
                          <td style={{padding:"8px 12px",fontSize:11,color:"#64748B",whiteSpace:"nowrap"}}>{displayVal(c.drawee)}</td>
                          <td style={{padding:"8px 12px",fontSize:11,maxWidth:100,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"#64748B"}}>{displayVal(c.depositedBy)}</td>
                          <td style={{padding:"8px 12px"}}><StatusSelect status={c.status} id={c.id}/></td>
                          <td style={{padding:"8px 12px"}}>
                            {["Pending","In Collection"].includes(c.status) ? (()=>{
                              const d=daysSince(c.date);
                              return <span style={{background:d>agingDays?"#501313":d>14?"#412402":"#173404",color:d>agingDays?"#F09595":d>14?"#EF9F27":"#97C459",padding:"2px 7px",borderRadius:20,fontSize:10,fontWeight:700,whiteSpace:"nowrap",border:`1px solid ${d>agingDays?"#A32D2D":d>14?"#854F0B":"#3B6D11"}`}}>{d}d</span>;
                            })() : <span style={{color:"#CBD5E1",fontSize:11}}>—</span>}
                          </td>
                          <td style={{padding:"8px 12px",fontSize:11,color:c.realisationDate?"#059669":"#94A3B8",fontWeight:c.realisationDate?700:400,whiteSpace:"nowrap"}}>{c.realisationDate||"—"}</td>
                          <td style={{padding:"8px 12px",whiteSpace:"nowrap"}}>
                            <button onClick={()=>printReceipt(c)} title="Print Receipt" style={{background:"#EFF6FF",border:"none",borderRadius:5,padding:"3px 8px",cursor:"pointer",fontSize:11,marginRight:3}}>🧾</button>
                            {c.chequeImage&&<button onClick={()=>{const w=window.open();w.document.write(`<html><body style="margin:10px;background:#f1f5f9"><img src="${c.chequeImage}" style="max-width:100%;border-radius:8px;box-shadow:0 2px 12px rgba(0,0,0,0.15)"></body></html>`);}} title="View Cheque Image" style={{background:"#F0FDF4",border:"none",borderRadius:5,padding:"3px 8px",cursor:"pointer",fontSize:11,marginRight:3}}>📷</button>}
                            {canEdit(currentUser?.role)&&<button onClick={()=>handleEdit(c)} style={{background:"#F1F5F9",border:"none",borderRadius:5,padding:"3px 8px",cursor:"pointer",fontSize:11,marginRight:3}}>✏️</button>}
                            {canDelete(currentUser?.role)&&<button onClick={()=>handleDelete(c.id)} style={{background:"#FEE2E2",border:"none",borderRadius:5,padding:"3px 8px",cursor:"pointer",fontSize:11,color:"#DC2626"}}>🗑️</button>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ══ FIRM VIEW ══ */}
          {page==="firmview" && (
            <div>
              <div style={{display:"flex",gap:8,marginBottom:18,flexWrap:"wrap"}}>
                {firms.map((f,fi)=>(
                  <button key={f} onClick={()=>setFirmView(f)} style={{
                    padding:"6px 14px",borderRadius:20,border:"2px solid",cursor:"pointer",fontSize:12,fontWeight:700,
                    background:firmView===f?FIRM_COLORS[fi%20]:"white",
                    color:firmView===f?"white":FIRM_COLORS[fi%20],borderColor:FIRM_COLORS[fi%20]
                  }}>{f}</button>
                ))}
              </div>
              {(()=>{
                const fi=firms.indexOf(firmView);
                const fc=cheques.filter(c=>c.firm===firmView).sort((a,b)=>b.date.localeCompare(a.date)||b.id-a.id);
                const inw=fc.filter(c=>c.type==="inward"), out=fc.filter(c=>c.type==="outward");
                const accts=firmAccounts[firmView]||[];
                return (
                  <div>
                    <div style={{background:`linear-gradient(135deg,${FIRM_COLORS[fi%20]},${FIRM_COLORS[(fi+1)%20]})`,borderRadius:12,padding:18,color:"white",marginBottom:16}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
                        <div>
                          <div style={{fontSize:18,fontWeight:900}}>{firmView}</div>
                          <div style={{fontSize:12,opacity:0.8,marginTop:3}}>{fc.length} total entries</div>
                          {accts.length>0&&<div style={{marginTop:8,fontSize:11,opacity:0.75}}>{accts.map(a=>`${a.bank}: ****${a.acNo.slice(-4)}`).join("  •  ")}</div>}
                        </div>
                        <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
                          {[{l:"Inward",v:fmt(inw.reduce((s,c)=>s+c.amount,0))},{l:"Outward",v:fmt(out.reduce((s,c)=>s+c.amount,0))},{l:"Cleared",v:fmt(fc.filter(c=>c.status==="Cleared").reduce((s,c)=>s+c.amount,0))},{l:"Pending",v:fmt(fc.filter(c=>c.status==="Pending").reduce((s,c)=>s+c.amount,0))}].map(s=>(
                            <div key={s.l} style={{textAlign:"center"}}>
                              <div style={{fontSize:9,opacity:0.7,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.07em"}}>{s.l}</div>
                              <div style={{fontSize:16,fontWeight:900,marginTop:2}}>{s.v}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    {fc.length===0?(
                      <div style={{background:"white",borderRadius:12,padding:48,textAlign:"center",color:"#64748B",fontSize:14}}>
                        No entries yet for <strong>{firmView}</strong>.<br/><br/>
                        {canEdit(currentUser?.role)&&<button onClick={openAdd} style={{background:FIRM_COLORS[fi%20],color:"white",border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,cursor:"pointer",fontSize:13}}>+ Add First Entry</button>}
                      </div>
                    ):(
                      <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                        <div style={{overflowX:"auto"}}>
                          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                            <thead><tr style={{background:"#F8FAFC"}}>
                              {["Date","Deposit Date","Type","Party","Cheque No","Chq Date","Amount","Drawer","Status","Realisation","Remarks"].map(h=>(
                                <th key={h} style={{padding:"10px 13px",textAlign:"left",fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid #F1F5F9",whiteSpace:"nowrap"}}>{h}</th>
                              ))}
                            </tr></thead>
                            <tbody>
                              {fc.map((c,i)=>(
                                <tr key={c.id} style={{background:i%2?"#FAFBFC":"white",borderBottom:"1px solid #F1F5F9"}}>
                                  <td style={{padding:"9px 13px",fontWeight:600,whiteSpace:"nowrap"}}>{c.date}</td>
                                  <td style={{padding:"9px 13px",fontSize:11,color:"#64748B",whiteSpace:"nowrap"}}>{c.depositDate||"—"}</td>
                                  <td style={{padding:"9px 13px"}}><span style={{background:c.type==="inward"?"#DBEAFE":"#FCE7F3",color:c.type==="inward"?"#1D4ED8":"#BE185D",padding:"2px 7px",borderRadius:20,fontSize:10,fontWeight:800,textTransform:"uppercase"}}>{c.type}</span></td>
                                  <td style={{padding:"9px 13px",fontWeight:700}}>{c.fromTo}</td>
                                  <td style={{padding:"9px 13px",fontFamily:"monospace",fontWeight:700,color:"#1E3A5F"}}>{c.chequeNo}</td>
                                  <td style={{padding:"9px 13px",fontSize:11,color:"#64748B",whiteSpace:"nowrap"}}>{c.chequeDate}</td>
                                  <td style={{padding:"9px 13px",fontWeight:900,color:"#0F172A",whiteSpace:"nowrap"}}>{fmt(c.amount)}</td>
                                  <td style={{padding:"9px 13px",fontSize:11,color:"#64748B"}}>{displayVal(c.drawer)}</td>
                                  <td style={{padding:"9px 13px"}}><StatusSelect status={c.status} id={c.id}/></td>
                                  <td style={{padding:"9px 13px",fontSize:11,color:c.realisationDate?"#059669":"#94A3B8",fontWeight:c.realisationDate?700:400,whiteSpace:"nowrap"}}>{c.realisationDate||"—"}</td>
                                  <td style={{padding:"9px 13px",fontSize:11,color:"#94A3B8",maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{displayVal(c.remarks)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          )}

          {/* ══ ACTION REQUIRED ══ */}
          {page==="pending" && (
            <div>
              {/* Aging threshold alert */}
              {agingAlerts.length>0&&(
                <div style={{background:"#FFFBEB",border:"1.5px solid #FDE68A",borderRadius:12,padding:"12px 18px",marginBottom:14,display:"flex",gap:10,alignItems:"flex-start"}}>
                  <span style={{fontSize:20,flexShrink:0}}>⏰</span>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:800,color:"#92400E",fontSize:13}}>{agingAlerts.length} cheque(s) pending beyond {agingDays} days — follow-up required</div>
                    <div style={{fontSize:12,color:"#B45309",marginTop:2}}>Total overdue: {fmt(agingAlerts.reduce((s,c)=>s+c.amount,0))}</div>
                  </div>
                  <button onClick={()=>setShowSettings(true)} style={{background:"#F59E0B",color:"white",border:"none",borderRadius:7,padding:"5px 12px",cursor:"pointer",fontSize:11,fontWeight:700,flexShrink:0}}>
                    Change Threshold ({agingDays}d)
                  </button>
                </div>
              )}
              {cheques.filter(c=>c.status==="Bounced").length>0&&(
                <div style={{background:"#FEF2F2",border:"1.5px solid #FECACA",borderRadius:12,padding:"13px 18px",marginBottom:16,display:"flex",gap:10,alignItems:"flex-start"}}>
                  <span style={{fontSize:22,flexShrink:0}}>🚨</span>
                  <div>
                    <div style={{fontWeight:800,color:"#991B1B",fontSize:13}}>{cheques.filter(c=>c.status==="Bounced").length} Bounced Cheque(s) — Immediate Action Required</div>
                    <div style={{fontSize:12,color:"#B91C1C",marginTop:2}}>Total: {fmt(cheques.filter(c=>c.status==="Bounced").reduce((s,c)=>s+c.amount,0))}</div>
                  </div>
                </div>
              )}
              {[{st:"Bounced",title:"❌ Bounced",hd:"#DC2626",bg:"#FEF2F2"},{st:"Pending",title:"⏳ Pending Realisation",hd:"#D97706",bg:"#FFFBEB"},{st:"In Collection",title:"🏦 Sent for Collection",hd:"#2563EB",bg:"#EFF6FF"}].map(({st,title,hd,bg})=>{
                const items=cheques.filter(c=>c.status===st).sort((a,b)=>b.date.localeCompare(a.date)||b.id-a.id);
                if(!items.length) return null;
                return (
                  <div key={st} style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden",marginBottom:14}}>
                    <div style={{background:bg,padding:"12px 18px",borderBottom:"1px solid #F1F5F9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{fontWeight:800,fontSize:13,color:hd}}>{title} ({items.length})</div>
                      <div style={{fontWeight:800,fontSize:13,color:hd}}>{fmt(items.reduce((s,c)=>s+c.amount,0))}</div>
                    </div>
                    <div style={{overflowX:"auto"}}>
                      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                        <thead><tr style={{background:"#F8FAFC"}}>
                          {["Date","Firm","Party","Cheque No","Amount","Drawer Bank","Age","Remarks","Status"].map(h=>(
                            <th key={h} style={{padding:"9px 13px",textAlign:"left",fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid #F1F5F9",whiteSpace:"nowrap"}}>{h}</th>
                          ))}
                        </tr></thead>
                        <tbody>
                          {items.map((c,i)=>{
                            const days=daysSince(c.date);
                            return (
                              <tr key={c.id} onClick={()=>handleEdit(c)} style={{background:i%2?"#FAFBFC":"white",borderBottom:"1px solid #F1F5F9",cursor:"pointer"}}
                              onMouseEnter={e=>e.currentTarget.style.background="#EFF6FF"}
                              onMouseLeave={e=>e.currentTarget.style.background=i%2?"#FAFBFC":"white"}>
                                <td style={{padding:"9px 13px",fontWeight:600,whiteSpace:"nowrap"}}>{c.date}</td>
                                <td style={{padding:"9px 13px",fontSize:11,color:"#475569",maxWidth:110,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.firm}</td>
                                <td style={{padding:"9px 13px",fontWeight:700,color:"#0F172A"}}>{c.fromTo||<span style={{color:"#CBD5E1",fontStyle:"italic"}}>No party</span>}</td>
                                <td style={{padding:"9px 13px",fontFamily:"monospace",fontWeight:700,color:"#1E3A5F"}}>{c.chequeNo||<span style={{color:"#CBD5E1"}}>—</span>}</td>
                                <td style={{padding:"9px 13px",fontWeight:900,color:st==="Bounced"?"#DC2626":"#0F172A",whiteSpace:"nowrap"}}>{fmt(c.amount)}</td>
                                <td style={{padding:"9px 13px",fontSize:11,color:"#64748B"}}>{displayVal(c.drawer)}</td>
                                <td style={{padding:"9px 13px"}}><span style={{background:days>30?"#FEE2E2":days>14?"#FEF3C7":"#F1F5F9",color:days>30?"#DC2626":days>14?"#92400E":"#64748B",padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{days}d old</span></td>
                                <td style={{padding:"9px 13px",fontSize:11,color:"#94A3B8",maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{displayVal(c.remarks)}</td>
                                <td style={{padding:"9px 13px"}}><StatusSelect status={c.status} id={c.id}/></td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
              {!cheques.some(c=>["Bounced","Pending","In Collection"].includes(c.status))&&(
                <div style={{background:"white",borderRadius:12,padding:60,textAlign:"center",color:"#10B981",fontSize:18,fontWeight:800}}>✅ All clear! No pending or bounced cheques.</div>
              )}
            </div>
          )}

          {/* ══ REPORTS ══ */}
          {page==="reports" && (
            <div>
              {/* Filter bar */}
              <div style={{background:"white",borderRadius:12,padding:16,marginBottom:16,boxShadow:"0 1px 3px rgba(0,0,0,0.06)"}}>
                <div style={{display:"flex",gap:12,flexWrap:"wrap",alignItems:"flex-end"}}>
                  <div>
                    <div style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:5}}>Period</div>
                    <div style={{display:"inline-flex",borderRadius:8,overflow:"hidden",border:"1.5px solid #E2E8F0"}}>
                      {[["MTD","Month to Date"],["YTD","Year to Date"],["CUSTOM","Custom Range"]].map(([v,l])=>(
                        <button key={v} onClick={()=>setReportPeriod(v)} style={{padding:"7px 14px",border:"none",cursor:"pointer",fontWeight:700,fontSize:11,background:reportPeriod===v?"#0A1628":"white",color:reportPeriod===v?"white":"#64748B",whiteSpace:"nowrap"}}>{l}</button>
                      ))}
                    </div>
                  </div>
                  {reportPeriod==="CUSTOM" && (
                    <>
                      <div>
                        <div style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:5}}>From</div>
                        <input type="date" value={reportFrom} onChange={e=>setReportFrom(e.target.value)}
                          style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"7px 10px",fontSize:12}} />
                      </div>
                      <div>
                        <div style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:5}}>To</div>
                        <input type="date" value={reportTo} onChange={e=>setReportTo(e.target.value)}
                          style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"7px 10px",fontSize:12}} />
                      </div>
                    </>
                  )}
                  <div>
                    <div style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:5}}>Firm</div>
                    <select value={reportFirm} onChange={e=>setReportFirm(e.target.value)} style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"7px 12px",fontSize:12,minWidth:150}}>
                      <option value="All">All Firms</option>
                      {firms.map(f=><option key={f}>{f}</option>)}
                    </select>
                  </div>
                  <div>
                    <div style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:5}}>Type</div>
                    <div style={{display:"inline-flex",borderRadius:8,overflow:"hidden",border:"1.5px solid #E2E8F0"}}>
                      {[["All","All"],["inward","📥 Inward"],["outward","📤 Outward"]].map(([v,l])=>(
                        <button key={v} onClick={()=>setReportType(v)} style={{padding:"7px 14px",border:"none",cursor:"pointer",fontWeight:700,fontSize:11,background:reportType===v?"#0A1628":"white",color:reportType===v?"white":"#64748B"}}>{l}</button>
                      ))}
                    </div>
                  </div>
                  <div style={{marginLeft:"auto",background:"#F8FAFC",borderRadius:8,padding:"8px 14px",fontSize:11,color:"#64748B",textAlign:"right",borderLeft:"3px solid #3B82F6"}}>
                    <div style={{fontWeight:800,color:"#0F172A",fontSize:13}}>
                      {reportPeriod==="MTD"&&monthLabel(thisMonth())}
                      {reportPeriod==="YTD"&&`FY ${thisYear()}`}
                      {reportPeriod==="CUSTOM"&&(reportFrom||reportTo?`${reportFrom||"…"} → ${reportTo||"…"}`:"All dates")}
                    </div>
                    <div>{reportData.length} entries found</div>
                  </div>
                </div>
              </div>

              {/* Summary cards */}
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
                {[
                  {l:"Total",v:fmt(reportTotals.total),c:"white",bg:"linear-gradient(135deg,#3B82F6,#1D4ED8)"},
                  {l:"Cleared",v:fmt(reportTotals.cleared),c:"white",bg:"linear-gradient(135deg,#10B981,#059669)"},
                  {l:"Pending",v:fmt(reportTotals.pending),c:"white",bg:"linear-gradient(135deg,#F59E0B,#D97706)"},
                  {l:"Bounced",v:fmt(reportTotals.bounced),c:"white",bg:"linear-gradient(135deg,#EF4444,#DC2626)"},
                ].map(k=>(
                  <div key={k.l} style={{background:k.bg,borderRadius:10,padding:"14px 16px",borderLeft:"none"}}>
                    <div style={{fontSize:10,fontWeight:700,color:"rgba(255,255,255,0.8)",textTransform:"uppercase",letterSpacing:"0.06em"}}>{k.l}</div>
                    <div style={{fontSize:20,fontWeight:900,color:"white",marginTop:4,letterSpacing:"-0.5px"}}>{k.v}</div>
                  </div>
                ))}
              </div>

              {/* Firm-wise breakdown */}
              <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden",marginBottom:16}}>
                <div style={{padding:"13px 18px",borderBottom:"1px solid #F1F5F9",fontWeight:800,fontSize:14,color:"#0F172A"}}>
                  Firm-wise Breakdown — {reportPeriod==="MTD"?monthLabel(thisMonth()):`Year ${thisYear()}`}
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead><tr style={{background:"#F8FAFC"}}>
                      {["Firm","Total","Inward","Outward","Cleared","Pending","Bounced","In Collection","Count"].map(h=>(
                        <th key={h} style={{padding:"9px 13px",textAlign:"left",fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid #F1F5F9",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {(()=>{
                        const firmReport = firms.map((firm,fi)=>{
                          const fc=reportData.filter(c=>c.firm===firm);
                          if(!fc.length) return null;
                          return { firm, fi,
                            total:fc.reduce((s,c)=>s+c.amount,0),
                            inward:fc.filter(c=>c.type==="inward").reduce((s,c)=>s+c.amount,0),
                            outward:fc.filter(c=>c.type==="outward").reduce((s,c)=>s+c.amount,0),
                            cleared:fc.filter(c=>c.status==="Cleared").reduce((s,c)=>s+c.amount,0),
                            pending:fc.filter(c=>c.status==="Pending").reduce((s,c)=>s+c.amount,0),
                            bounced:fc.filter(c=>c.status==="Bounced").reduce((s,c)=>s+c.amount,0),
                            inColl:fc.filter(c=>c.status==="In Collection").reduce((s,c)=>s+c.amount,0),
                            count:fc.length,
                          };
                        }).filter(Boolean);
                        if(!firmReport.length) return <tr><td colSpan={9} style={{padding:30,textAlign:"center",color:"#94A3B8"}}>No data for selected period/filters</td></tr>;
                        return firmReport.map((f,i)=>(
                          <tr key={f.firm} style={{background:i%2?"#FAFBFC":"white",borderBottom:"1px solid #F1F5F9"}}>
                            <td style={{padding:"9px 13px"}}><div style={{display:"flex",alignItems:"center",gap:7}}>
                              <div style={{width:7,height:7,borderRadius:"50%",background:FIRM_COLORS[f.fi%20],flexShrink:0}}></div>
                              <span style={{fontWeight:700,fontSize:12}}>{f.firm}</span>
                            </div></td>
                            <td style={{padding:"9px 13px",fontWeight:800}}>{fmt(f.total)}</td>
                            <td style={{padding:"9px 13px",color:"#1D4ED8",fontWeight:700}}>{fmt(f.inward)}</td>
                            <td style={{padding:"9px 13px",color:"#BE185D",fontWeight:700}}>{fmt(f.outward)}</td>
                            <td style={{padding:"9px 13px",color:"#059669",fontWeight:700}}>{fmt(f.cleared)}</td>
                            <td style={{padding:"9px 13px",color:"#D97706",fontWeight:700}}>{fmt(f.pending)}</td>
                            <td style={{padding:"9px 13px",color:"#DC2626",fontWeight:700}}>{f.bounced>0?fmt(f.bounced):"—"}</td>
                            <td style={{padding:"9px 13px",color:"#2563EB",fontWeight:700}}>{f.inColl>0?fmt(f.inColl):"—"}</td>
                            <td style={{padding:"9px 13px",color:"#64748B"}}>{f.count}</td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Party-wise breakdown */}
              <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden",marginBottom:16}}>
                <div style={{padding:"13px 18px",borderBottom:"1px solid #F1F5F9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontWeight:800,fontSize:14,color:"#0F172A"}}>Party-wise Summary</div>
                  <div style={{fontSize:11,color:"#94A3B8"}}>{[...new Set(reportData.map(c=>c.fromTo).filter(Boolean))].length} parties</div>
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead><tr style={{background:"#F8FAFC"}}>
                      {["Party","Inward Total","Outward Total","Cleared","Pending","Bounced","In Collection","Entries"].map(h=>(
                        <th key={h} style={{padding:"9px 13px",textAlign:"left",fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid #F1F5F9",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {(()=>{
                        const partyMap={};
                        reportData.forEach(c=>{
                          const p=c.fromTo||"Unknown";
                          if(!partyMap[p]) partyMap[p]={name:p,inward:0,outward:0,cleared:0,pending:0,bounced:0,inColl:0,count:0};
                          if(c.type==="inward") partyMap[p].inward+=c.amount;
                          else partyMap[p].outward+=c.amount;
                          if(c.status==="Cleared") partyMap[p].cleared+=c.amount;
                          if(c.status==="Pending") partyMap[p].pending+=c.amount;
                          if(c.status==="Bounced") partyMap[p].bounced+=c.amount;
                          if(c.status==="In Collection") partyMap[p].inColl+=c.amount;
                          partyMap[p].count++;
                        });
                        const parties=Object.values(partyMap).sort((a,b)=>(b.inward+b.outward)-(a.inward+a.outward));
                        if(!parties.length) return <tr><td colSpan={8} style={{padding:24,textAlign:"center",color:"#94A3B8"}}>No data for selected filters</td></tr>;
                        return parties.map((p,i)=>(
                          <tr key={p.name} style={{background:i%2?"#FAFBFC":"white",borderBottom:"1px solid #F1F5F9"}}>
                            <td style={{padding:"9px 13px",fontWeight:700,color:"#0F172A"}}>{p.name}</td>
                            <td style={{padding:"9px 13px",color:"#1D4ED8",fontWeight:700}}>{fmt(p.inward)}</td>
                            <td style={{padding:"9px 13px",color:"#BE185D",fontWeight:700}}>{fmt(p.outward)}</td>
                            <td style={{padding:"9px 13px",color:"#059669",fontWeight:700}}>{p.cleared>0?fmt(p.cleared):"—"}</td>
                            <td style={{padding:"9px 13px",color:"#D97706",fontWeight:700}}>{p.pending>0?fmt(p.pending):"—"}</td>
                            <td style={{padding:"9px 13px",color:"#DC2626",fontWeight:700}}>{p.bounced>0?fmt(p.bounced):"—"}</td>
                            <td style={{padding:"9px 13px",color:"#7C3AED",fontWeight:700}}>{p.inColl>0?fmt(p.inColl):"—"}</td>
                            <td style={{padding:"9px 13px",color:"#64748B"}}>{p.count}</td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Detail table */}
              <div style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                <div style={{padding:"13px 18px",borderBottom:"1px solid #F1F5F9",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontWeight:800,fontSize:14,color:"#0F172A"}}>Detailed Entries</div>
                  <div style={{fontSize:11,color:"#94A3B8"}}>Click any row to open entry</div>
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead><tr style={{background:"#0A1628",color:"white"}}>
                      {["Date","Type","Firm","Party","Cheque No","Amount","Status","Realisation"].map(h=>(
                        <th key={h} style={{padding:"9px 13px",textAlign:"left",fontWeight:600,fontSize:10,textTransform:"uppercase",letterSpacing:"0.05em",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {reportData.length===0&&<tr><td colSpan={8} style={{padding:30,textAlign:"center",color:"#94A3B8"}}>No entries found</td></tr>}
                      {reportData.map((c,i)=>(
                        <tr key={c.id} onClick={()=>handleEdit(c)}
                          style={{background:i%2?"#FAFBFC":"white",borderBottom:"1px solid #F1F5F9",cursor:"pointer"}}
                          onMouseEnter={e=>e.currentTarget.style.background="#EFF6FF"}
                          onMouseLeave={e=>e.currentTarget.style.background=i%2?"#FAFBFC":"white"}
                          title="Click to open entry">
                          <td style={{padding:"8px 13px",fontWeight:600,whiteSpace:"nowrap"}}>{c.date}</td>
                          <td style={{padding:"8px 13px"}}><span style={{background:c.type==="inward"?"#DBEAFE":"#FCE7F3",color:c.type==="inward"?"#1D4ED8":"#BE185D",padding:"2px 7px",borderRadius:20,fontSize:10,fontWeight:800,textTransform:"uppercase"}}>{c.type}</span></td>
                          <td style={{padding:"8px 13px",fontSize:11,color:"#475569",whiteSpace:"nowrap"}}>{c.firm}</td>
                          <td style={{padding:"8px 13px",fontWeight:700}}>{c.fromTo}</td>
                          <td style={{padding:"8px 13px",fontFamily:"monospace",fontWeight:700,color:"#1E3A5F"}}>{c.chequeNo}</td>
                          <td style={{padding:"8px 13px",fontWeight:900,whiteSpace:"nowrap"}}>{fmt(c.amount)}</td>
                          <td style={{padding:"8px 13px"}}><span style={{background:scfg(c.status).bg,color:scfg(c.status).color,padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:800}}>{c.status}</span></td>
                          <td style={{padding:"8px 13px",fontSize:11,color:c.realisationDate?"#059669":"#94A3B8",fontWeight:c.realisationDate?700:400}}>{c.realisationDate||"—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* ══ BANK ACCOUNTS ══ */}
          {page==="accounts" && (
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:14}}>
              {firms.map((firm,fi)=>{
                const accts=firmAccounts[firm]||[];
                const fc=cheques.filter(c=>c.firm===firm);
                return (
                  <div key={firm} style={{background:"white",borderRadius:12,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                    <div style={{background:FIRM_COLORS[fi%20],padding:"13px 16px",color:"white"}}>
                      <div style={{fontWeight:800,fontSize:13}}>{firm}</div>
                      <div style={{fontSize:11,opacity:0.8,marginTop:2}}>{fc.length} entries • {fmt(fc.reduce((s,c)=>s+c.amount,0))} total</div>
                    </div>
                    <div style={{padding:14}}>
                      {accts.length===0?<div style={{color:"#94A3B8",fontSize:12,fontStyle:"italic"}}>No bank accounts on record</div>
                        :accts.map((a,ai)=>(
                          <div key={ai} style={{background:"#F8FAFC",borderRadius:8,padding:12,marginBottom:8,borderLeft:`3px solid ${FIRM_COLORS[fi%20]}`}}>
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                              <div style={{fontWeight:700,fontSize:13,color:"#0F172A"}}>{a.bank}</div>
                              {a.acType&&<span style={{fontSize:10,fontWeight:700,background:"#EFF6FF",color:"#1D4ED8",borderRadius:20,padding:"2px 8px"}}>{a.acType}</span>}
                            </div>
                            <div style={{fontFamily:"monospace",fontSize:12,color:"#475569",marginTop:3}}>{a.acNo}</div>
                            {a.ifsc&&<div style={{fontSize:11,color:"#94A3B8",marginTop:2}}>IFSC: {a.ifsc}</div>}
                          </div>
                        ))
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* ══ CHEQUE BOOK REGISTER ══ */}
          {page==="chqbook" && (
            <div>
              <div style={{background:"white",borderRadius:12,padding:18,marginBottom:16,boxShadow:"0 1px 3px rgba(0,0,0,0.06)"}}>
                <div style={{fontWeight:800,fontSize:14,color:"#0F172A",marginBottom:14}}>📒 Cheque Book Register</div>
                <div style={{fontSize:12,color:"#64748B",marginBottom:16}}>Track cheque leaf numbers assigned, used and available for each firm&#39;s bank account.</div>
                <div style={{display:"flex",gap:10,marginBottom:16}}>                  <select value={chqBookFirm} onChange={e=>setChqBookFirm(e.target.value)}
                    style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 12px",fontSize:13,minWidth:220}}>
                    <option value="">— Select Firm —</option>
                    {firms.map(f=><option key={f}>{f}</option>)}
                  </select>
                </div>
                {chqBookFirm && (()=>{
                  const accts = firmAccounts[chqBookFirm]||[];
                  const bookData = chequeBooks[chqBookFirm] || {};
                  return (
                    <div>
                      {accts.length===0&&<div style={{color:"#94A3B8",fontSize:13,padding:"16px 0"}}>No bank accounts configured for this firm.</div>}
                      {accts.map((a,ai)=>{
                        const key = `${a.bank}_${a.acNo}`;
                        const bk = bookData[key] || {from:"",to:"",issued:0};
                        const total = bk.to&&bk.from ? (parseInt(bk.to)-parseInt(bk.from)+1) : 0;
                        const avail = Math.max(0, total - (bk.issued||0));
                        return (
                          <div key={ai} style={{background:"#F8FAFC",borderRadius:10,padding:16,marginBottom:12,border:"1px solid #F1F5F9"}}>
                            <div style={{fontWeight:700,fontSize:13,color:"#0F172A",marginBottom:10}}>{a.bank} — ****{a.acNo.slice(-4)}</div>
                            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:12,marginBottom:12}}>
                              {[["From Leaf No","from"],["To Leaf No","to"],["Issued So Far","issued"]].map(([l,k])=>(
                                <div key={k}>
                                  <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:5}}>{l}</label>
                                  <input type="number" value={bk[k]||""} min="0"
                                    onChange={e=>{
                                      const updated = {...chequeBooks, [chqBookFirm]:{...bookData, [key]:{...bk, [k]:parseInt(e.target.value)||0}}};
                                      setChequeBooks(updated);
                                    }}
                                    onBlur={()=>saveChqBook(chqBookFirm, {...bookData, [key]:{...bk}})}
                                    style={{width:"100%",border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 10px",fontSize:13,boxSizing:"border-box"}} />
                                </div>
                              ))}
                              <div>
                                <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:5}}>Available</label>
                                <div style={{padding:"8px 10px",background:avail<5?"#FEF2F2":avail<20?"#FFFBEB":"#ECFDF5",borderRadius:8,fontSize:16,fontWeight:900,color:avail<5?"#DC2626":avail<20?"#D97706":"#059669",border:`1.5px solid ${avail<5?"#FECACA":avail<20?"#FDE68A":"#A7F3D0"}`}}>
                                  {total > 0 ? avail : "—"}
                                </div>
                              </div>
                            </div>
                            {total>0&&(
                              <div style={{background:"white",borderRadius:8,padding:"8px 12px",fontSize:11,color:"#64748B",display:"flex",gap:16}}>
                                <span>Total leaves: <strong>{total}</strong></span>
                                <span>Used: <strong>{bk.issued||0}</strong></span>
                                <span>Available: <strong style={{color:avail<5?"#DC2626":avail<20?"#D97706":"#059669"}}>{avail}</strong></span>
                                {avail<5&&<span style={{color:"#DC2626",fontWeight:700}}>⚠️ Running low!</span>}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>
            </div>
          )}
      </div>
      </div>

      {/* ══════════════════════════════════════════════════════════
          CHEQUE ENTRY FORM MODAL
      ══════════════════════════════════════════════════════════ */}
      {showForm && form && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:860,maxHeight:"92vh",overflow:"auto",boxShadow:"0 25px 60px rgba(0,0,0,0.35)"}}>
            <div style={{background:"#0A1628",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:10}}>
              <div style={{fontWeight:800,fontSize:15}}>{editing?"✏️ Edit Entry":"+ New Cheque Entry"}</div>
              <button onClick={()=>{setShowForm(false);setEditing(null);setForm(null);}} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer",fontSize:14}}>✕</button>
            </div>
            <div style={{padding:22}}>
              {/* Type toggle */}
              <div style={{marginBottom:18}}>
                <div style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:7}}>Cheque Type *</div>
                <div style={{display:"inline-flex",borderRadius:9,overflow:"hidden",border:"1.5px solid #E2E8F0"}}>
                  {[["inward","📥 Inward (Received)"],["outward","📤 Outward (Issued)"]].map(([t,l])=>(
                    <button key={t} onClick={()=>sf("type",t)} style={{padding:"9px 22px",border:"none",cursor:"pointer",fontWeight:700,fontSize:12,background:form.type===t?"#0A1628":"white",color:form.type===t?"white":"#64748B"}}>{l}</button>
                  ))}
                </div>
              </div>

              {/* Firm selector */}
              <div style={{marginBottom:16}}>
                <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Firm *</label>
                <select value={form.firm} onChange={e=>sf("firm",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13}}>
                  {firms.map(f=><option key={f}>{f}</option>)}
                </select>
              </div>

              {/* Firm's bank accounts shown for reference */}
              {(firmAccounts[form.firm]||[]).length>0&&(
                <div style={{background:"#F0F9FF",border:"1px solid #BFDBFE",borderRadius:8,padding:"8px 14px",marginBottom:16,fontSize:11,color:"#1E40AF"}}>
                  <span style={{fontWeight:700}}>Accounts for {form.firm}: </span>
                  {(firmAccounts[form.firm]||[]).map(a=>`${a.bank} ****${a.acNo.slice(-4)}`).join("  •  ")}
                </div>
              )}

              {/* ── Form fields grid ── */}
              {(()=>{
                // Firm's own accounts → used for drawee (inward) or drawer (outward)
                const firmAcctOpts = ["", ...(firmAccounts[form.firm]||[]).map(a=>`${a.bank} — A/c ****${a.acNo.slice(-4)}`)];
                const firmAcctFull = (firmAccounts[form.firm]||[]).map(a=>({label:`${a.bank} — A/c ****${a.acNo.slice(-4)}`, value:`${a.bank} — ${a.acNo}`}));
                // For inward: drawer = party's bank (free BANKS list), drawee = OUR firm's account
                // For outward: drawer = OUR firm's account, drawee = party's bank (free BANKS list)
                return (
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
                  {/* Entry Date */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Entry Date *</label>
                    <input type="date" value={form.date} onChange={e=>sf("date",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>
                  {/* Deposit Date / Issue Date */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>{form.type==="outward"?"Issue Date *":"Deposit Date *"}</label>
                    <input type="date" value={form.depositDate} onChange={e=>sf("depositDate",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>
                  {/* From/To with party autocomplete */}
                  <div style={{position:"relative"}}>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>{form.type==="inward"?"Received From *":"Issued To *"}</label>
                    <input type="text" value={form.fromTo}
                      onChange={e=>handlePartyInput(e.target.value)}
                      onBlur={()=>setTimeout(()=>setShowSugg(false),150)}
                      onFocus={()=>form.fromTo&&handlePartyInput(form.fromTo)}
                      placeholder="Type to search parties…"
                      style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} />
                    {showSugg&&partySugg.length>0&&(
                      <div style={{position:"absolute",top:"100%",left:0,right:0,background:"white",border:"1.5px solid #BFDBFE",borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,0.12)",zIndex:100,overflow:"hidden",marginTop:2}}>
                        {partySugg.map(p=>(
                          <div key={p} onMouseDown={()=>selectParty(p)}
                            style={{padding:"9px 14px",cursor:"pointer",fontSize:13,borderBottom:"1px solid #F1F5F9",fontWeight:500}}
                            onMouseEnter={e=>e.currentTarget.style.background="#EFF6FF"}
                            onMouseLeave={e=>e.currentTarget.style.background="white"}>
                            📋 {p}
                          </div>
                        ))}
                        {!parties.includes(form.fromTo.trim())&&form.fromTo.trim()&&(
                          <div onMouseDown={()=>{addPartyToMaster(form.fromTo);setShowSugg(false);}}
                            style={{padding:"9px 14px",cursor:"pointer",fontSize:12,color:"#059669",fontWeight:700,background:"#F0FDF4",borderTop:"1px solid #D1FAE5"}}>
                            + Add "{form.fromTo.trim()}" to Party Master
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {/* Cheque Number */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Cheque Number *</label>
                    <input type="text" value={form.chequeNo} onChange={e=>sf("chequeNo",e.target.value)} style={{width:"100%",marginTop:5,border:`1.5px solid ${dupeWarning?"#F59E0B":"#E2E8F0"}`,borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>
                  {/* Cheque Date */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Cheque Date *</label>
                    <input type="date" value={form.chequeDate} onChange={e=>sf("chequeDate",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>
                  {/* Amount */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Amount (₹) *</label>
                    <input type="number" value={form.amount} onChange={e=>sf("amount",e.target.value)} min="0.01" step="0.01" style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>

                  {/* DRAWER BANK — inward: party's bank (BANKS list) | outward: OUR firm's account */}
                  <div>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>
                      {form.type==="inward"?"Drawer Bank (Party's Bank)":"Drawer Bank (Our Account)"}
                    </label>
                    {form.type==="inward"
                      ? <div>
                          <select value={form.drawer} onChange={e=>sf("drawer",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13}}>
                            {form.type!=="outward"&&BANKS.map(b=><option key={b}>{b}</option>)}
                          </select>
                          {form.drawer==="Other"&&(
                            <input type="text" value={form.drawerManual||""} onChange={e=>sf("drawerManual",e.target.value)}
                              placeholder="Enter bank name manually"
                              style={{width:"100%",marginTop:6,border:"1.5px solid #3B82F6",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} />
                          )}
                        </div>
                      : <div>
                          <select value={(firmAccounts[form.firm]||[]).some(a=>`${a.bank} — ${a.acNo}`===form.drawer) ? form.drawer : (form.drawer?"other":"")}
                            onChange={e=>{ if(e.target.value==="other") sf("drawer",""); else sf("drawer",e.target.value); }}
                            style={{width:"100%",marginTop:5,border:"1.5px solid #1D4ED8",borderRadius:8,padding:"8px 11px",fontSize:13,background:"#EFF6FF"}}>
                            <option value="">— Select account —</option>
                            {(firmAccounts[form.firm]||[]).map((a,i)=>(
                              <option key={i} value={`${a.bank} — ${a.acNo}`}>{a.bank} — ****{a.acNo.slice(-4)}{a.acType?` (${a.acType})`:""}</option>
                            ))}
                            <option value="other">Other (type manually)</option>
                          </select>
                          {(!(firmAccounts[form.firm]||[]).some(a=>`${a.bank} — ${a.acNo}`===form.drawer))&&(
                            <input type="text" value={form.drawer} onChange={e=>sf("drawer",e.target.value)}
                              placeholder="Enter bank name / account manually"
                              style={{width:"100%",marginTop:6,border:"1.5px solid #1D4ED8",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box",background:"#EFF6FF"}} />
                          )}
                        </div>
                    }
                  </div>

                  {/* DRAWEE BANK — inward: OUR firm's account | outward: party's bank (BANKS list) */}
                  <div>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>
                      {form.type==="inward"?"Drawee Bank (Our Account)":"Payment Mode"}
                    </label>
                    {form.type==="inward"
                      ? <div>
                          <select value={(firmAccounts[form.firm]||[]).some(a=>`${a.bank} — ${a.acNo}`===form.drawee) ? form.drawee : (form.drawee?"other":"")}
                            onChange={e=>{ if(e.target.value==="other") sf("drawee",""); else sf("drawee",e.target.value); }}
                            style={{width:"100%",marginTop:5,border:"1.5px solid #1D4ED8",borderRadius:8,padding:"8px 11px",fontSize:13,background:"#EFF6FF"}}>
                            <option value="">— Select account —</option>
                            {(firmAccounts[form.firm]||[]).map((a,i)=>(
                              <option key={i} value={`${a.bank} — ${a.acNo}`}>{a.bank} — ****{a.acNo.slice(-4)}{a.acType?` (${a.acType})`:""}</option>
                            ))}
                            <option value="other">Other (type manually)</option>
                          </select>
                          {(!(firmAccounts[form.firm]||[]).some(a=>`${a.bank} — ${a.acNo}`===form.drawee))&&(
                            <input type="text" value={form.drawee} onChange={e=>sf("drawee",e.target.value)}
                              placeholder="Enter bank name / account manually"
                              style={{width:"100%",marginTop:6,border:"1.5px solid #1D4ED8",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box",background:"#EFF6FF"}} />
                          )}
                        </div>
                      : <div>
                          <select value={form.drawee} onChange={e=>sf("drawee",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13}}>
                            {form.type==="outward"?(<>
                              <option value="">— Select Payment Mode —</option>
                              <option value="RTGS">RTGS</option>
                              <option value="NEFT">NEFT</option>
                              <option value="Transfer">Transfer</option>
                              <option value="Self">Self</option>
                              <option value="Others">Others</option>
                            </>):null}
                          </select>
                          {form.drawee==="Others"&&(
                            <input type="text" placeholder="Enter payment details manually" value={form.draweeManual||""} onChange={e=>sf("draweeManual",e.target.value)}
                              placeholder="Enter bank name manually"
                              style={{width:"100%",marginTop:6,border:"1.5px solid #3B82F6",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} />
                          )}
                        </div>
                    }
                  </div>

                  {/* Deposited By / UTR */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>{form.type==="outward"?"UTR Number / Transaction ID":"Deposited By"}</label>
                    <input type="text" placeholder={form.type==="outward"?"Enter UTR / Transaction ID":""} value={form.depositedBy} onChange={e=>sf("depositedBy",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>
                  {/* Status */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Status</label>
                    <select value={form.status} onChange={e=>sf("status",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13}}>
                      {STATUSES.map(s=><option key={s}>{s}</option>)}
                    </select></div>
                  {/* Realisation Date */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Realisation Date</label>
                    <input type="date" value={form.realisationDate} onChange={e=>sf("realisationDate",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>
                  {/* Remarks */}
                  <div><label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Remarks</label>
                    <input type="text" value={form.remarks} onChange={e=>sf("remarks",e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} /></div>
                </div>
                );
              })()}

              {/* Cheque Image Upload */}
              <div style={{marginTop:14,padding:"12px 14px",background:"#F8FAFC",borderRadius:10,border:"1.5px dashed #CBD5E1"}}>
                <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:8}}>📷 Cheque Image (optional)</label>
                {form.chequeImage
                  ? <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <img src={form.chequeImage} alt="Cheque" style={{maxWidth:220,maxHeight:80,borderRadius:6,border:"1px solid #E2E8F0",objectFit:"cover"}} />
                      <div style={{display:"flex",flexDirection:"column",gap:6}}>
                        <button type="button" onClick={()=>{ const w=window.open(); w.document.write(`<img src="${form.chequeImage}" style="max-width:100%">`); }}
                          style={{padding:"5px 12px",background:"#0A1628",color:"white",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>🔍 View Full</button>
                        <button type="button" onClick={()=>sf("chequeImage","")}
                          style={{padding:"5px 12px",background:"white",color:"#EF4444",border:"1.5px solid #FECACA",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>✕ Remove</button>
                      </div>
                    </div>
                  : <div>
                      <input type="file" accept="image/*" id="cheque-img-upload" style={{display:"none"}}
                        onChange={e=>{
                          const file=e.target.files[0];
                          if(!file) return;
                          if(file.size>2*1024*1024){ alert("Image must be under 2MB. Please compress or use a smaller image."); return; }
                          const reader=new FileReader();
                          reader.onload=ev=>sf("chequeImage",ev.target.result);
                          reader.readAsDataURL(file);
                          e.target.value="";
                        }} />
                      <label htmlFor="cheque-img-upload" style={{display:"inline-flex",alignItems:"center",gap:7,padding:"8px 16px",background:"white",border:"1.5px solid #CBD5E1",borderRadius:8,cursor:"pointer",fontSize:12,fontWeight:600,color:"#475569"}}>
                        📎 Attach Cheque Image
                      </label>
                      <span style={{fontSize:11,color:"#94A3B8",marginLeft:10}}>JPG/PNG, max 2MB</span>
                    </div>
                }
              </div>

              {dupeWarning&&<div style={{background:"#FEF3C7",border:"1px solid #FDE68A",borderRadius:8,padding:"9px 14px",marginTop:12,fontSize:12,color:"#92400E",fontWeight:600}}>{dupeWarning}</div>}

              <div style={{display:"flex",gap:10,marginTop:18,justifyContent:"flex-end",paddingTop:14,borderTop:"1px solid #F1F5F9"}}>
                <button onClick={()=>{setShowForm(false);setEditing(null);setForm(null);}} style={{padding:"9px 22px",border:"1.5px solid #E2E8F0",borderRadius:8,background:"white",cursor:"pointer",fontWeight:700,fontSize:12,color:"#64748B"}}>Cancel</button>
                <button onClick={handleSave} style={{padding:"9px 28px",border:"none",borderRadius:8,background:"#0A1628",color:"white",cursor:"pointer",fontWeight:800,fontSize:13}}>{editing?"Update Entry":"Save Cheque ✓"}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
          USER MANAGEMENT MODAL
      ══════════════════════════════════════════════════════════ */}
      {showUserMgmt && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:700,maxHeight:"90vh",overflow:"auto",boxShadow:"0 25px 60px rgba(0,0,0,0.35)"}}>
            <div style={{background:"#0A1628",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0}}>
              <div style={{fontWeight:800,fontSize:15}}>👥 User Management</div>
              <button onClick={()=>setShowUserMgmt(false)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer"}}>✕</button>
            </div>
            <div style={{padding:22}}>
              <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
                <button onClick={()=>{setUserForm({id:null,name:"",username:"",password:"",role:"Staff",active:true});setShowUserForm(true);}}
                  style={{background:"#0A1628",color:"white",border:"none",borderRadius:8,padding:"8px 16px",fontWeight:700,cursor:"pointer",fontSize:12}}>+ Add User</button>
              </div>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead><tr style={{background:"#F8FAFC"}}>
                  {["Name","Username","Role","Status","Actions"].map(h=>(
                    <th key={h} style={{padding:"10px 13px",textAlign:"left",fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid #F1F5F9"}}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {users.map((u,i)=>(
                    <tr key={u.id} style={{background:i%2?"#FAFBFC":"white",borderBottom:"1px solid #F1F5F9"}}>
                      <td style={{padding:"11px 13px",fontWeight:700}}>{u.name} {u.id===currentUser?.id&&<span style={{fontSize:10,background:"#DBEAFE",color:"#1D4ED8",padding:"1px 6px",borderRadius:20,marginLeft:5}}>You</span>}</td>
                      <td style={{padding:"11px 13px",fontFamily:"monospace",color:"#475569"}}>{u.username}</td>
                      <td style={{padding:"11px 13px"}}><span style={{background:ROLE_CFG[u.role]?.bg||"#F1F5F9",color:ROLE_CFG[u.role]?.color||"#475569",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:800}}>{u.role}</span></td>
                      <td style={{padding:"11px 13px"}}><span style={{background:u.active?"#D1FAE5":"#FEE2E2",color:u.active?"#065F46":"#991B1B",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:700}}>{u.active?"Active":"Inactive"}</span></td>
                      <td style={{padding:"11px 13px",whiteSpace:"nowrap"}}>
                        <button onClick={()=>{setUserForm({...u});setShowUserForm(true);}} style={{background:"#F1F5F9",border:"none",borderRadius:5,padding:"4px 10px",cursor:"pointer",fontSize:11,marginRight:4}}>✏️ Edit</button>
                        <button onClick={()=>handleToggleUser(u.id)} disabled={u.id===currentUser?.id} style={{background:u.active?"#FEF3C7":"#D1FAE5",border:"none",borderRadius:5,padding:"4px 10px",cursor:"pointer",fontSize:11,marginRight:4,color:u.active?"#92400E":"#065F46",opacity:u.id===currentUser?.id?0.4:1}}>
                          {u.active?"Deactivate":"Activate"}
                        </button>
                        <button onClick={()=>handleDeleteUser(u.id)} disabled={u.id===currentUser?.id} style={{background:"#FEE2E2",border:"none",borderRadius:5,padding:"4px 10px",cursor:"pointer",fontSize:11,color:"#DC2626",opacity:u.id===currentUser?.id?0.4:1}}>🗑️</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{marginTop:16,background:"#F8FAFC",borderRadius:8,padding:12,fontSize:11,color:"#64748B"}}>
                <div style={{fontWeight:700,color:"#475569",marginBottom:6}}>Role Permissions:</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:4}}>
                  <div>👑 <strong>Admin</strong> — Full access, user management, firm management</div>
                  <div>🔧 <strong>Manager</strong> — Add/edit/delete cheques, reports, firm management</div>
                  <div>📝 <strong>Staff</strong> — Add and edit cheques, view reports</div>
                  <div>👁 <strong>Viewer</strong> — View only, no edits or deletions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* User form sub-modal */}
      {showUserForm && userForm && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300,padding:16}}>
          <div style={{background:"white",borderRadius:14,width:"100%",maxWidth:420,padding:28,boxShadow:"0 20px 50px rgba(0,0,0,0.4)"}}>
            <div style={{fontWeight:800,fontSize:15,color:"#0F172A",marginBottom:20}}>{userForm.id?"Edit User":"Add New User"}</div>
            {[{l:"Full Name",k:"name",t:"text"},{l:"Username",k:"username",t:"text"},{l:"Password",k:"password",t:"password"}].map(f=>(
              <div key={f.k} style={{marginBottom:14}}>
                <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>{f.l}</label>
                <input type={f.t} value={userForm[f.k]} onChange={e=>setUserForm(p=>({...p,[f.k]:e.target.value}))}
                  style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 11px",fontSize:13,boxSizing:"border-box"}} />
              </div>
            ))}
            <div style={{marginBottom:16}}>
              <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Role</label>
              <select value={userForm.role} onChange={e=>setUserForm(p=>({...p,role:e.target.value}))} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 11px",fontSize:13}}>
                {ROLES.map(r=><option key={r}>{r}</option>)}
              </select>
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",paddingTop:14,borderTop:"1px solid #F1F5F9"}}>
              <button onClick={()=>{setShowUserForm(false);setUserForm(null);}} style={{padding:"9px 18px",border:"1.5px solid #E2E8F0",borderRadius:8,background:"white",cursor:"pointer",fontWeight:700,fontSize:12,color:"#64748B"}}>Cancel</button>
              <button onClick={handleSaveUser} style={{padding:"9px 22px",border:"none",borderRadius:8,background:"#0A1628",color:"white",cursor:"pointer",fontWeight:800,fontSize:13}}>Save User ✓</button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
          FIRM MANAGEMENT MODAL
      ══════════════════════════════════════════════════════════ */}
      {showFirmMgmt && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:680,maxHeight:"90vh",overflow:"auto",boxShadow:"0 25px 60px rgba(0,0,0,0.35)"}}>
            <div style={{background:"#0A1628",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0}}>
              <div style={{fontWeight:800,fontSize:15}}>🏛️ Firm Management</div>
              <button onClick={()=>setShowFirmMgmt(false)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer"}}>✕</button>
            </div>
            <div style={{padding:22}}>
              {/* Add new firm */}
              <div style={{background:"#F8FAFC",border:"1.5px solid #E2E8F0",borderRadius:10,padding:16,marginBottom:20}}>
                <div style={{fontWeight:700,fontSize:13,color:"#0F172A",marginBottom:12}}>+ Add New Firm</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
                  <div style={{gridColumn:"span 2"}}>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Firm Name *</label>
                    <input value={newFirmName} onChange={e=>setNewFirmName(e.target.value)} placeholder="e.g. XYZ Consultants"
                      style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} />
                  </div>
                  <div>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Bank Name</label>
                    <select value={newFirmBank} onChange={e=>setNewFirmBank(e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13}}>
                      {BANKS.map(b=><option key={b}>{b}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Account No</label>
                    <input value={newFirmAcNo} onChange={e=>setNewFirmAcNo(e.target.value)} placeholder="Account number"
                      style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} />
                  </div>
                  <div>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>IFSC Code</label>
                    <input value={newFirmIFSC} onChange={e=>setNewFirmIFSC(e.target.value)} placeholder="e.g. HDFC0001234"
                      style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13,boxSizing:"border-box"}} />
                  </div>
                  <div>
                    <label style={{fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em"}}>Account Type</label>
                    <select value={newFirmAcType} onChange={e=>setNewFirmAcType(e.target.value)} style={{width:"100%",marginTop:5,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 11px",fontSize:13}}>
                      {["Savings","Current","CC","OD","NRO","NRE","Term Loan","Others"].map(t=><option key={t}>{t}</option>)}
                    </select>
                  </div>
                </div>
                <button onClick={handleAddFirm} style={{background:"#0A1628",color:"white",border:"none",borderRadius:8,padding:"9px 20px",fontWeight:700,cursor:"pointer",fontSize:12}}>+ Add Firm</button>
              </div>

              {/* Existing firms list */}
              <div style={{fontWeight:700,fontSize:13,color:"#0F172A",marginBottom:10}}>{firms.length} Active Firms</div>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {firms.map((f,fi)=>{
                  const fc=cheques.filter(c=>c.firm===f);
                  const accts=firmAccounts[f]||[];
                  return (
                    <div key={f} style={{display:"flex",alignItems:"center",gap:12,background:"#F8FAFC",borderRadius:8,padding:"10px 14px",borderLeft:`3px solid ${FIRM_COLORS[fi%20]}`}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:700,fontSize:12,color:"#0F172A"}}>{f}</div>
                        <div style={{fontSize:11,color:"#94A3B8",marginTop:2}}>
                          {accts.length} account(s) • {fc.length} cheque entries
                          {accts.length>0&&<span> • {accts.map(a=>a.bank).join(", ")}</span>}
                        </div>
                      </div>
                      <button onClick={()=>handleDeleteFirm(f)} disabled={fc.length>0}
                        style={{background:"#FEE2E2",border:"none",borderRadius:6,padding:"4px 10px",cursor:fc.length>0?"not-allowed":"pointer",fontSize:11,color:"#DC2626",opacity:fc.length>0?0.4:1,fontWeight:600}}>
                        {fc.length>0?`${fc.length} entries`:"Delete"}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ BULK CONFIRM ══ */}
      {confirmBulk && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300,padding:16}}>
          <div style={{background:"white",borderRadius:14,width:"100%",maxWidth:400,padding:28,boxShadow:"0 20px 50px rgba(0,0,0,0.3)"}}>
            <div style={{fontSize:30,textAlign:"center",marginBottom:12}}>⚡</div>
            <div style={{fontWeight:800,fontSize:15,color:"#0F172A",textAlign:"center",marginBottom:8}}>Bulk Status Update</div>
            <div style={{fontSize:13,color:"#64748B",textAlign:"center",marginBottom:22,lineHeight:1.6}}>
              Update <strong>{selectedIds.length} cheque{selectedIds.length>1?"s":""}</strong> to{" "}
              <strong style={{color:scfg(bulkStatus).color}}>{bulkStatus}</strong>?<br/>
              {bulkStatus==="Cleared"&&<span style={{fontSize:12,color:"#059669"}}>Realisation date set to today where blank.</span>}
              {bulkStatus==="Bounced"&&<span style={{fontSize:12,color:"#DC2626"}}>Realisation date will be cleared for all selected.</span>}
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setConfirmBulk(false)} style={{flex:1,padding:"10px",border:"1.5px solid #E2E8F0",borderRadius:8,background:"white",cursor:"pointer",fontWeight:700,fontSize:13,color:"#475569"}}>Cancel</button>
              <button onClick={applyBulkUpdate} style={{flex:1,padding:"10px",border:"none",borderRadius:8,background:"#0A1628",color:"white",cursor:"pointer",fontWeight:800,fontSize:13}}>Confirm Update</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ PARTY MASTER MODAL ══ */}
      {showPartyMgmt && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:560,maxHeight:"88vh",overflow:"auto",boxShadow:"0 25px 60px rgba(0,0,0,0.35)"}}>
            <div style={{background:"#0A1628",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0}}>
              <div style={{fontWeight:800,fontSize:15}}>📒 Party Master ({parties.length})</div>
              <button onClick={()=>setShowPartyMgmt(false)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer"}}>✕</button>
            </div>
            <div style={{padding:20}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:18}}>
              <div style={{gridColumn:"1/-1",display:"flex",gap:8}}>
                <input value={newPartyName} onChange={e=>setNewPartyName(e.target.value)}
                  onKeyDown={e=>{if(e.key==="Enter"&&newPartyName.trim()){addPartyToMaster(newPartyName.trim());setNewPartyName("");}}}
                  placeholder="Party / Company Name *"
                  style={{flex:1,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13}} />
                <button onClick={()=>{addPartyToMaster(newPartyName.trim());setNewPartyName("");}} style={{background:"#0A1628",color:"white",border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,cursor:"pointer",fontSize:13,whiteSpace:"nowrap"}}>+ Add</button>
              </div>
              <input id="pm_mobile" placeholder="Mobile (Optional)" style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,width:"100%"}} />
              <input id="pm_email" placeholder="Email (Optional)" style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,width:"100%"}} />
              <input id="pm_address" placeholder="Address (Optional)" style={{gridColumn:"1/-1",border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,width:"100%"}} />
              <input id="pm_city" placeholder="City" style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,width:"100%"}} />
              <input id="pm_state" placeholder="State" style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,width:"100%"}} />
              <input id="pm_pincode" placeholder="Pincode" style={{border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,width:"100%"}} />
            </div>
              <div style={{fontSize:11,color:"#94A3B8",marginBottom:10}}>Parties auto-added when you save a new cheque entry.</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                {[...parties].sort().map(p=>(
                  <div key={p} style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:"#F8FAFC",borderRadius:7,padding:"8px 12px",border:"1px solid #F1F5F9"}}>
                    <span style={{fontSize:12,fontWeight:600,color:"#374151"}}>📋 {p}</span>
                    <button onClick={()=>handleDeleteParty(p)} style={{background:"#FEE2E2",border:"none",borderRadius:5,padding:"2px 8px",cursor:"pointer",fontSize:11,color:"#DC2626",fontWeight:700}}>✕</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ PRINT STYLES (injected) ══ */}
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #print-area, #print-area * { visibility: visible !important; }
          #print-area { position: fixed; top: 0; left: 0; width: 100%; padding: 20px; background: white; z-index: 9999; }
          @page { margin: 15mm; size: A4 landscape; }
        }
      `}</style>

      {/* ══ PRINT AREA (hidden, shown on print) ══ */}
      <div id="print-area" style={{display:"none"}}>
        <div style={{marginBottom:16,borderBottom:"2px solid #0A1628",paddingBottom:12}}>
          <div style={{fontSize:20,fontWeight:900,color:"#0A1628"}}>SmartCABuddy — Cheque Management System</div>
          <div style={{fontSize:12,color:"#64748B",marginTop:4}}>
            Printed: {new Date().toLocaleDateString("en-IN",{day:"numeric",month:"long",year:"numeric"})} &nbsp;|&nbsp;
            Entries: {filtered.length} &nbsp;|&nbsp;
            Total: {fmt(filtered.reduce((s,c)=>s+c.amount,0))}
            {fFirm!=="All"&&` | Firm: ${fFirm}`}
            {fStatus!=="All"&&` | Status: ${fStatus}`}
            {fMonth!=="All"&&` | Month: ${monthLabel(fMonth)}`}
          </div>
        </div>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:10}}>
          <thead><tr style={{background:"#0A1628",color:"white"}}>
            {["#","Date","Dep. Date","Type","Firm","Party","Cheque No","Chq Date","Amount","Drawer Bank","Drawee Bank","Status","Realisation"].map(h=>(
              <th key={h} style={{padding:"6px 8px",textAlign:"left",fontWeight:700,fontSize:9,textTransform:"uppercase"}}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {filtered.map((c,i)=>(
              <tr key={c.id} style={{background:i%2?"#F8FAFC":"white",borderBottom:"1px solid #E2E8F0"}}>
                <td style={{padding:"5px 8px",color:"#94A3B8",fontSize:9}}>{c.id}</td>
                <td style={{padding:"5px 8px",fontWeight:600}}>{c.date}</td>
                <td style={{padding:"5px 8px",color:"#64748B"}}>{c.depositDate||"—"}</td>
                <td style={{padding:"5px 8px",textTransform:"uppercase",fontWeight:700,fontSize:9}}>{c.type}</td>
                <td style={{padding:"5px 8px",fontSize:9}}>{c.firm}</td>
                <td style={{padding:"5px 8px",fontWeight:700}}>{c.fromTo}</td>
                <td style={{padding:"5px 8px",fontFamily:"monospace",fontWeight:700}}>{c.chequeNo}</td>
                <td style={{padding:"5px 8px"}}>{c.chequeDate}</td>
                <td style={{padding:"5px 8px",fontWeight:900}}>{fmt(c.amount)}</td>
                <td style={{padding:"5px 8px",fontSize:9}}>{c.drawer||"—"}</td>
                <td style={{padding:"5px 8px",fontSize:9}}>{c.drawee||"—"}</td>
                <td style={{padding:"5px 8px",fontWeight:700}}>{c.status}</td>
                <td style={{padding:"5px 8px",color:c.realisationDate?"#059669":"#94A3B8"}}>{c.realisationDate||"—"}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr style={{background:"#0A1628",color:"white"}}>
            <td colSpan={8} style={{padding:"7px 8px",fontWeight:800,fontSize:11}}>TOTAL ({filtered.length} entries)</td>
            <td style={{padding:"7px 8px",fontWeight:900,fontSize:11}}>{fmt(filtered.reduce((s,c)=>s+c.amount,0))}</td>
            <td colSpan={4} style={{padding:"7px 8px",fontSize:10,color:"#93C5FD"}}>
              Cleared: {fmt(filtered.filter(c=>c.status==="Cleared").reduce((s,c)=>s+c.amount,0))} &nbsp;|&nbsp;
              Pending: {fmt(filtered.filter(c=>c.status==="Pending").reduce((s,c)=>s+c.amount,0))}
            </td>
          </tr></tfoot>
        </table>
        <div style={{marginTop:20,fontSize:10,color:"#94A3B8",textAlign:"center"}}>SmartCABuddy — www.smartcabuddy.com | Confidential</div>
      </div>

      {/* ══ BULK IMPORT MODAL ══ */}
      {showImport && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:720,maxHeight:"92vh",overflow:"auto",boxShadow:"0 25px 60px rgba(0,0,0,0.4)"}}>
            <div style={{background:"#0A1628",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:10}}>
              <div style={{fontWeight:800,fontSize:15}}>⬆️ Bulk Import</div>
              <button onClick={()=>setShowImport(false)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer"}}>✕</button>
            </div>
            <div style={{padding:22}}>

              {/* Import type selector */}
              <div style={{marginBottom:20}}>
                <div style={{fontSize:11,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:10}}>What do you want to import?</div>
                <div style={{display:"flex",gap:10}}>
                  {[["cheques","📋","Cheque Entries","Import inward/outward cheques in bulk"],["parties","📒","Party Master","Add multiple parties at once"],["firms","🏛️","Firms & Accounts","Add new firms with bank accounts"]].map(([v,ic,lb,desc])=>(
                    <button key={v} onClick={()=>{setImportType(v);setImportPreview([]);setImportErrors([]);setImportStatus("");}}
                      style={{flex:1,padding:"14px 12px",borderRadius:10,border:`2px solid ${importType===v?"#3B82F6":"#E2E8F0"}`,background:importType===v?"#EFF6FF":"white",cursor:"pointer",textAlign:"left",transition:"all 0.15s"}}>
                      <div style={{fontSize:20,marginBottom:6}}>{ic}</div>
                      <div style={{fontSize:12,fontWeight:700,color:importType===v?"#1D4ED8":"#0F172A"}}>{lb}</div>
                      <div style={{fontSize:11,color:"#94A3B8",marginTop:3,lineHeight:1.4}}>{desc}</div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Step 1: Download template */}
              <div style={{background:"#F8FAFC",borderRadius:10,padding:16,marginBottom:16,border:"1px solid #F1F5F9"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13,color:"#0F172A",marginBottom:3}}>Step 1 — Download Template</div>
                    <div style={{fontSize:12,color:"#64748B"}}>Fill this Excel/CSV template with your data, then upload below.</div>
                    <div style={{fontSize:11,color:"#94A3B8",marginTop:4,fontFamily:"monospace"}}>{TEMPLATES[importType]?.notes}</div>
                  </div>
                  <button onClick={()=>downloadTemplate(importType)}
                    style={{background:"#0A1628",color:"white",border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,cursor:"pointer",fontSize:12,whiteSpace:"nowrap",flexShrink:0,marginLeft:16}}>
                    ⬇ Download Template
                  </button>
                </div>
                {/* Column headers preview */}
                <div style={{marginTop:12,display:"flex",gap:6,flexWrap:"wrap"}}>
                  {TEMPLATES[importType]?.headers.map(h=>(
                    <span key={h} style={{background:"#E2E8F0",color:"#475569",padding:"2px 8px",borderRadius:5,fontSize:10,fontFamily:"monospace",fontWeight:600}}>{h}</span>
                  ))}
                </div>
              </div>

              {/* Step 2: Upload */}
              <div style={{border:"2px dashed #E2E8F0",borderRadius:10,padding:24,textAlign:"center",marginBottom:16,background:"#FAFBFC",position:"relative"}}
                onDragOver={e=>{e.preventDefault();e.currentTarget.style.borderColor="#3B82F6";e.currentTarget.style.background="#EFF6FF";}}
                onDragLeave={e=>{e.currentTarget.style.borderColor="#E2E8F0";e.currentTarget.style.background="#FAFBFC";}}
                onDrop={e=>{e.preventDefault();e.currentTarget.style.borderColor="#E2E8F0";e.currentTarget.style.background="#FAFBFC";const f=e.dataTransfer.files[0];if(f){const inp=document.createElement("input");inp.type="file";const ev={target:{files:[f],value:""},preventDefault:()=>{}};handleFileUpload(ev);}}}>
                <div style={{fontSize:32,marginBottom:8}}>📂</div>
                <div style={{fontWeight:700,color:"#0F172A",marginBottom:4}}>Step 2 — Upload your filled CSV</div>
                <div style={{fontSize:12,color:"#64748B",marginBottom:14}}>Drag &amp; drop or click to browse</div>
                <label style={{background:"#3B82F6",color:"white",border:"none",borderRadius:8,padding:"9px 20px",fontWeight:700,cursor:"pointer",fontSize:12,display:"inline-block"}}>
                  📁 Browse File
                  <input type="file" accept=".csv,.xlsx" onChange={handleFileUpload} style={{display:"none"}} />
                </label>
                <div style={{fontSize:11,color:"#94A3B8",marginTop:8}}>Supports .csv files</div>
              </div>

              {/* Errors */}
              {importErrors.length>0 && (
                <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:8,padding:14,marginBottom:14}}>
                  <div style={{fontWeight:700,color:"#991B1B",fontSize:12,marginBottom:8}}>⚠️ {importErrors.length} issue(s) found — fix and re-upload:</div>
                  {importErrors.slice(0,8).map((e,i)=><div key={i} style={{fontSize:11,color:"#B91C1C",marginBottom:3}}>• {e}</div>)}
                  {importErrors.length>8&&<div style={{fontSize:11,color:"#94A3B8"}}>...and {importErrors.length-8} more</div>}
                </div>
              )}

              {/* Preview */}
              {importPreview.length>0 && (
                <div>
                  <div style={{background:"#ECFDF5",border:"1px solid #A7F3D0",borderRadius:8,padding:"10px 14px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div style={{fontWeight:700,color:"#065F46",fontSize:13}}>✅ {importPreview.length} record(s) ready to import</div>
                    {importErrors.length>0&&<div style={{fontSize:11,color:"#D97706"}}>⚠️ {importErrors.length} rows skipped</div>}
                  </div>
                  <div style={{overflowX:"auto",maxHeight:200,overflowY:"auto",border:"1px solid #F1F5F9",borderRadius:8}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
                      <thead><tr style={{background:"#F8FAFC",position:"sticky",top:0}}>
                        {importType==="cheques"&&["Type","Firm","Party","Cheque No","Date","Amount","Status"].map(h=><th key={h} style={{padding:"7px 10px",textAlign:"left",fontWeight:700,color:"#64748B",fontSize:10,textTransform:"uppercase"}}>{h}</th>)}
                        {importType==="parties"&&["Party Name"].map(h=><th key={h} style={{padding:"7px 10px",textAlign:"left",fontWeight:700,color:"#64748B",fontSize:10,textTransform:"uppercase"}}>{h}</th>)}
                        {importType==="firms"&&["Firm Name","Bank","Account No","IFSC"].map(h=><th key={h} style={{padding:"7px 10px",textAlign:"left",fontWeight:700,color:"#64748B",fontSize:10,textTransform:"uppercase"}}>{h}</th>)}
                      </tr></thead>
                      <tbody>
                        {importPreview.slice(0,10).map((r,i)=>(
                          <tr key={i} style={{borderBottom:"1px solid #F8FAFC",background:i%2?"#FAFBFC":"white"}}>
                            {importType==="cheques"&&[<span style={{background:r.type==="inward"?"#DBEAFE":"#FCE7F3",color:r.type==="inward"?"#1D4ED8":"#BE185D",padding:"1px 6px",borderRadius:20,fontSize:9,fontWeight:800,textTransform:"uppercase"}}>{r.type}</span>,r.firm,r.fromTo,r.chequeNo,r.date,`₹${r.amount}`,r.status].map((v,j)=><td key={j} style={{padding:"6px 10px"}}>{v}</td>)}
                            {importType==="parties"&&[r].map((v,j)=><td key={j} style={{padding:"6px 10px",fontWeight:600}}>{v}</td>)}
                            {importType==="firms"&&[r.name,r.bank,r.acNo,r.ifsc||"—"].map((v,j)=><td key={j} style={{padding:"6px 10px"}}>{v}</td>)}
                          </tr>
                        ))}
                        {importPreview.length>10&&<tr><td colSpan={7} style={{padding:"8px 10px",textAlign:"center",color:"#94A3B8",fontSize:11}}>...and {importPreview.length-10} more records</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div style={{display:"flex",gap:10,marginTop:18,justifyContent:"flex-end",paddingTop:14,borderTop:"1px solid #F1F5F9"}}>
                <button onClick={()=>setShowImport(false)} style={{padding:"9px 22px",border:"1.5px solid #E2E8F0",borderRadius:8,background:"white",cursor:"pointer",fontWeight:700,fontSize:12,color:"#64748B"}}>Cancel</button>
                <button onClick={applyImport} disabled={importPreview.length===0}
                  style={{padding:"9px 28px",border:"none",borderRadius:8,background:importPreview.length>0?"#059669":"#94A3B8",color:"white",cursor:importPreview.length>0?"pointer":"default",fontWeight:800,fontSize:13}}>
                  Import {importPreview.length>0?`${importPreview.length} Records`:""} ✓
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ WHATSAPP MODAL ══ */}
      {showWhatsApp && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:580,maxHeight:"90vh",overflow:"auto",boxShadow:"0 25px 60px rgba(0,0,0,0.4)"}}>
            <div style={{background:"#075E54",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0}}>
              <div style={{fontWeight:800,fontSize:15}}>💬 WhatsApp Send</div>
              <button onClick={()=>setShowWhatsApp(false)} style={{background:"rgba(255,255,255,0.15)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer"}}>✕</button>
            </div>
            <div style={{padding:22}}>
              {/* Mode selector */}
              <div style={{display:"flex",gap:8,marginBottom:20}}>
                {[["dayend","📊","Day-End Summary"],["party","👤","Party Reminder"],["mgmt","👔","Management Report"]].map(([v,ic,lb])=>(
                  <button key={v} onClick={()=>setWaMode(v)} style={{flex:1,padding:"10px 8px",borderRadius:10,border:`2px solid ${waMode===v?"#25D366":"#E2E8F0"}`,background:waMode===v?"#F0FDF4":"white",cursor:"pointer",textAlign:"center"}}>
                    <div style={{fontSize:18,marginBottom:3}}>{ic}</div>
                    <div style={{fontSize:11,fontWeight:700,color:waMode===v?"#065F46":"#475569"}}>{lb}</div>
                  </button>
                ))}
              </div>

              {/* Phone number */}
              <div style={{marginBottom:16}}>
                <label style={{fontSize:11,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>
                  {waMode==="party"?"Party WhatsApp Number":"Recipient WhatsApp Number"}
                </label>
                <input value={waPhone} onChange={e=>setWaPhone(e.target.value)}
                  placeholder="Enter 10-digit mobile number (e.g. 9876543210)"
                  style={{width:"100%",border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,boxSizing:"border-box"}} />
                <div style={{fontSize:11,color:"#94A3B8",marginTop:4}}>Country code +91 added automatically</div>
              </div>

              {/* Day-end mode */}
              {waMode==="dayend" && (
                <div>
                  <div style={{background:"#F0FDF4",border:"1px solid #A7F3D0",borderRadius:8,padding:14,marginBottom:16}}>
                    <div style={{fontWeight:700,fontSize:12,color:"#065F46",marginBottom:8}}>Preview — Day End Summary</div>
                    <pre style={{fontSize:11,color:"#374151",whiteSpace:"pre-wrap",fontFamily:"monospace",margin:0,lineHeight:1.6}}>{buildDayEndMessage()}</pre>
                  </div>
                  <button onClick={()=>openWhatsApp(waPhone,buildDayEndMessage())} disabled={!waPhone}
                    style={{width:"100%",background:waPhone?"#25D366":"#94A3B8",color:"white",border:"none",borderRadius:10,padding:"12px",fontWeight:800,fontSize:14,cursor:waPhone?"pointer":"default"}}>
                    💬 Open WhatsApp &amp; Send Summary
                  </button>
                </div>
              )}

              {/* Party mode */}
              {waMode==="party" && (
                <div>
                  <div style={{marginBottom:14}}>
                    <label style={{fontSize:11,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>Select Cheque to Remind</label>
                    <select style={{width:"100%",border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13}}
                      onChange={e=>{
                        const c = cheques.find(x=>x.id===parseInt(e.target.value));
                        if(c&&waPhone) openWhatsApp(waPhone, buildPartyMessage(c));
                      }}>
                      <option value="">— Select pending/bounced cheque —</option>
                      {cheques.filter(c=>["Pending","In Collection","Bounced"].includes(c.status)).map(c=>(
                        <option key={c.id} value={c.id}>{c.fromTo} — {fmt(c.amount)} ({c.status}) — #{c.chequeNo}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{fontSize:11,color:"#64748B",background:"#F8FAFC",borderRadius:8,padding:10}}>Selecting a cheque will immediately open WhatsApp with a pre-filled reminder message.</div>
                </div>
              )}

              {/* Management mode */}
              {waMode==="mgmt" && (
                <div>
                  {[
                    {label:"Pending Cheques Report", data:cheques.filter(c=>c.status==="Pending")},
                    {label:"Bounced Cheques Alert",  data:cheques.filter(c=>c.status==="Bounced")},
                    {label:"Today's Entries",        data:cheques.filter(c=>c.date===nowISO())},
                  ].map(({label,data})=>(
                    <div key={label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:"#F8FAFC",borderRadius:8,marginBottom:8,border:"1px solid #F1F5F9"}}>
                      <div>
                        <div style={{fontWeight:700,fontSize:13,color:"#0F172A"}}>{label}</div>
                        <div style={{fontSize:11,color:"#64748B"}}>{data.length} entries • {fmt(data.reduce((s,c)=>s+c.amount,0))}</div>
                      </div>
                      <button onClick={()=>{
                        const msg = `📋 *${label}*\n📅 ${new Date().toLocaleDateString("en-IN")}\n\n`
                          + (data.length===0?"No entries.\n":data.map(c=>`• ${c.fromTo} — ${fmt(c.amount)} (${c.firm})`).join("\n"))
                          + `\n\n_SmartCABuddy — www.smartcabuddy.com_`;
                        openWhatsApp(waPhone, msg);
                      }} disabled={!waPhone}
                        style={{background:waPhone?"#25D366":"#94A3B8",color:"white",border:"none",borderRadius:7,padding:"7px 14px",fontWeight:700,cursor:waPhone?"pointer":"default",fontSize:12,flexShrink:0}}>
                        💬 Send
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ══ AUDIT TRAIL MODAL ══ */}
      {showAudit && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:680,maxHeight:"88vh",overflow:"auto",boxShadow:"0 25px 60px rgba(0,0,0,0.4)"}}>
            <div style={{background:"#0A1628",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0}}>
              <div style={{fontWeight:800,fontSize:15}}>🔍 Audit Trail ({auditLog.length})</div>
              <div style={{display:"flex",gap:8}}>
                {auditLog.length>0&&<button onClick={()=>{
                if(!window.confirm("Clear all audit log entries? This cannot be undone.")) return;
                api.delete("/api/audit").then(()=>{setAuditLog([]);showToast("Audit log cleared");}).catch(()=>showToast("Failed to clear log"));
              }} style={{background:"rgba(239,68,68,0.2)",border:"none",color:"#FCA5A5",borderRadius:7,padding:"5px 11px",cursor:"pointer",fontSize:11}}>Clear Log</button>}
                <button onClick={()=>setShowAudit(false)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer"}}>✕</button>
              </div>
            </div>
            <div style={{padding:16}}>
              {auditLog.length===0?(
                <div style={{padding:40,textAlign:"center",color:"#94A3B8",fontSize:14}}>No activity recorded yet.<br/>Status changes, edits and other actions will appear here.</div>
              ):(
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                  <thead><tr style={{background:"#F8FAFC"}}>
                    {["Time","User","Action","Details"].map(h=><th key={h} style={{padding:"9px 12px",textAlign:"left",fontSize:10,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid #F1F5F9"}}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {auditLog.map((e,i)=>(
                      <tr key={e.id} style={{background:i%2?"#FAFBFC":"white",borderBottom:"1px solid #F8FAFC"}}>
                        <td style={{padding:"8px 12px",whiteSpace:"nowrap",color:"#64748B",fontSize:11}}>{new Date(e.ts).toLocaleString("en-IN",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</td><td style={{padding:"8px 12px",whiteSpace:"nowrap",color:"#374151",fontSize:11,fontWeight:500}}>{e.user||"System"}</td>
                        <td style={{padding:"8px 12px",whiteSpace:"nowrap"}}>
                          <span style={{background:e.action==="Status Change"?"#DBEAFE":e.action==="New Entry"?"#D1FAE5":e.action==="Edit"?"#FEF3C7":e.action==="WhatsApp"?"#DCFCE7":"#F1F5F9",color:e.action==="Status Change"?"#1D4ED8":e.action==="New Entry"?"#065F46":e.action==="Edit"?"#92400E":e.action==="WhatsApp"?"#166534":"#475569",padding:"2px 8px",borderRadius:20,fontSize:10,fontWeight:700}}>
                            {e.action}
                          </span>
                        </td>
                        <td style={{padding:"8px 12px",color:"#374151",fontSize:12}}>{e.details}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ══ SETTINGS MODAL ══ */}
      {showSettings && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16}}>
          <div style={{background:"white",borderRadius:16,width:"100%",maxWidth:480,boxShadow:"0 25px 60px rgba(0,0,0,0.4)"}}>
            <div style={{background:"#0A1628",color:"white",padding:"16px 22px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontWeight:800,fontSize:15}}>⚙️ Settings</div>
              <button onClick={()=>setShowSettings(false)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",borderRadius:7,padding:"5px 11px",cursor:"pointer"}}>✕</button>
            </div>
            <div style={{padding:22}}>
              {/* Aging threshold */}
              <div style={{marginBottom:22}}>
                <div style={{fontWeight:700,fontSize:13,color:"#0F172A",marginBottom:4}}>⏰ Cheque Aging Alert Threshold</div>
                <div style={{fontSize:12,color:"#64748B",marginBottom:10}}>Show alert in Action Required when a cheque is pending for more than this many days.</div>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <input type="number" value={agingDays} min={1} max={365}
                    onChange={e=>setAgingDays(parseInt(e.target.value)||30)}
                    style={{width:80,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"8px 12px",fontSize:16,fontWeight:700,textAlign:"center"}} />
                  <span style={{fontSize:13,color:"#475569"}}>days</span>
                  <button onClick={()=>{api.post("/api/settings",{key:"agingDays",value:String(agingDays)}).catch(()=>{});showToast("Aging threshold saved ✓");setShowSettings(false);}}
                    style={{background:"#0A1628",color:"white",border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,cursor:"pointer",fontSize:12,marginLeft:"auto"}}>
                    Save
                  </button>
                </div>
              </div>
              <div style={{height:1,background:"#F1F5F9",marginBottom:18}}></div>
              {/* WhatsApp default number */}
              <div style={{marginBottom:22}}>
                <div style={{fontWeight:700,fontSize:13,color:"#0F172A",marginBottom:4}}>💬 Default WhatsApp Number</div>
                <div style={{fontSize:12,color:"#64748B",marginBottom:10}}>This number is pre-filled in WhatsApp Send.</div>
                <div style={{display:"flex",gap:10}}>
                  <input value={waPhone} onChange={e=>setWaPhone(e.target.value)}
                    placeholder="10-digit mobile number"
                    style={{flex:1,border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13}} />
                  <button onClick={()=>{api.post("/api/settings",{key:"waPhone",value:waPhone}).catch(()=>{});showToast("Number saved ✓");}}
                    style={{background:"#25D366",color:"white",border:"none",borderRadius:8,padding:"9px 16px",fontWeight:700,cursor:"pointer",fontSize:12}}>Save</button>
                </div>
              </div>
              <div style={{height:1,background:"#F1F5F9",marginBottom:18}}></div>
              {/* App info */}
              <div style={{background:"#F8FAFC",borderRadius:8,padding:12}}>
                <div style={{fontSize:11,color:"#64748B",marginBottom:4}}>Application Info</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12}}>
                  <div style={{color:"#94A3B8"}}>Version</div><div style={{fontWeight:700}}>CMS v10</div>
                  <div style={{color:"#94A3B8"}}>Total Entries</div><div style={{fontWeight:700}}>{cheques.length}</div>
                  <div style={{color:"#94A3B8"}}>Active Firms</div><div style={{fontWeight:700}}>{firms.length}</div>
                  <div style={{color:"#94A3B8"}}>Audit Events</div><div style={{fontWeight:700}}>{auditLog.length}</div>
                  <div style={{color:"#94A3B8"}}>Storage</div><div style={{fontWeight:700,color:storageOk?"#059669":"#DC2626"}}>{storageOk?"Healthy":"Error"}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ ONBOARDING WIZARD ══ */}
      {showOnboard && (
        <div style={{position:"fixed",inset:0,background:"rgba(6,13,31,0.85)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:16}}>
          <div style={{background:"white",borderRadius:20,width:"100%",maxWidth:520,boxShadow:"0 30px 80px rgba(0,0,0,0.5)"}}>
            {/* Progress bar */}
            <div style={{height:4,background:"#F1F5F9",borderRadius:"20px 20px 0 0",overflow:"hidden"}}>
              <div style={{height:"100%",background:"linear-gradient(90deg,#3B82F6,#8B5CF6)",borderRadius:4,transition:"width 0.4s",width:`${((onboardStep+1)/5)*100}%`}}></div>
            </div>
            <div style={{padding:30}}>
              {/* Step indicator */}
              <div style={{display:"flex",gap:6,marginBottom:20,justifyContent:"center"}}>
                {[0,1,2,3,4].map(i=>(
                  <div key={i} style={{width:i===onboardStep?24:8,height:8,borderRadius:4,background:i===onboardStep?"#3B82F6":i<onboardStep?"#A7F3D0":"#F1F5F9",transition:"all 0.3s"}}></div>
                ))}
              </div>

              {onboardStep===0&&(
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:48,marginBottom:16}}>👋</div>
                  <div style={{fontSize:22,fontWeight:900,color:"#0F172A",marginBottom:8,letterSpacing:"-0.5px"}}>Welcome to SmartCABuddy!</div>
                  <div style={{fontSize:14,color:"#64748B",lineHeight:1.7,marginBottom:24}}>Let&#39;s set up your Cheque Management System in just a few steps. This will take about 2 minutes.</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:24,textAlign:"left"}}>
                    {[["📋","Cheque register"],["🏢","Multi-firm management"],["📊","Live dashboard"],["💬","WhatsApp alerts"]].map(([ic,lb])=>(
                      <div key={lb} style={{background:"#F8FAFC",borderRadius:8,padding:"10px 12px",display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:16}}>{ic}</span><span style={{fontSize:12,fontWeight:600,color:"#374151"}}>{lb}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {onboardStep===1&&(
                <div>
                  <div style={{fontSize:32,marginBottom:12,textAlign:"center"}}>🏢</div>
                  <div style={{fontSize:18,fontWeight:800,color:"#0F172A",marginBottom:6,textAlign:"center"}}>Your Firms</div>
                  <div style={{fontSize:13,color:"#64748B",marginBottom:16,textAlign:"center"}}>We&#39;ve pre-loaded your 15 firms from the official account list. You can add, remove or rename them from Firm Management in the sidebar at any time.</div>
                  <div style={{maxHeight:200,overflow:"auto",background:"#F8FAFC",borderRadius:10,padding:12}}>
                    {firms.map((f,i)=>(
                      <div key={f} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 0",borderBottom:i<firms.length-1?"1px solid #F1F5F9":"none"}}>
                        <div style={{width:8,height:8,borderRadius:"50%",background:FIRM_COLORS[i%20],flexShrink:0}}></div>
                        <span style={{fontSize:12,color:"#374151"}}>{f}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {onboardStep===2&&(
                <div>
                  <div style={{fontSize:32,marginBottom:12,textAlign:"center"}}>👤</div>
                  <div style={{fontSize:18,fontWeight:800,color:"#0F172A",marginBottom:6,textAlign:"center"}}>Set Admin Password</div>
                  <div style={{fontSize:13,color:"#64748B",marginBottom:16,textAlign:"center"}}>For security, update the default admin password before going live.</div>
                  {[{l:"Admin Password",k:"admin"},{l:"Manager Password",k:"manager"}].map(({l,k})=>(
                    <div key={k} style={{marginBottom:12}}>
                      <label style={{fontSize:11,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:5}}>{l}</label>
                      <input type="password" placeholder={`New password for ${k}`} id={`ob_pwd_${k}`}
                        style={{width:"100%",border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:13,boxSizing:"border-box"}} />
                    </div>
                  ))}
                  <button onClick={()=>{
                    const ap=document.getElementById("ob_pwd_admin")?.value;
                    const mp=document.getElementById("ob_pwd_manager")?.value;
                    if(ap||mp){
                      const updated=users.map(u=>{
                        if(u.username==="admin"&&ap) return {...u,password:ap};
                        if(u.username==="manager"&&mp) return {...u,password:mp};
                        return u;
                      });
                      setUsers(updated);
                      // Update passwords via API
                      updated.forEach(u => {
                        if ((u.username==="admin"&&ap)||(u.username==="manager"&&mp)) {
                          api.put(`/api/users/${u.id}`, {...u}).catch(()=>{});
                        }
                      });
                      showToast("Passwords updated ✓");
                    }
                  }} style={{background:"#0A1628",color:"white",border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,cursor:"pointer",fontSize:12,width:"100%",marginTop:4}}>
                    Update Passwords
                  </button>
                  <div style={{fontSize:11,color:"#94A3B8",marginTop:8,textAlign:"center"}}>You can skip this and update later in User Management.</div>
                </div>
              )}
              {onboardStep===3&&(
                <div>
                  <div style={{fontSize:32,marginBottom:12,textAlign:"center"}}>💬</div>
                  <div style={{fontSize:18,fontWeight:800,color:"#0F172A",marginBottom:6,textAlign:"center"}}>WhatsApp Notifications</div>
                  <div style={{fontSize:13,color:"#64748B",marginBottom:16,textAlign:"center"}}>Set a default number for day-end summaries and management reports.</div>
                  <label style={{fontSize:11,fontWeight:700,color:"#64748B",textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>Default WhatsApp Number</label>
                  <input value={waPhone} onChange={e=>setWaPhone(e.target.value)}
                    placeholder="10-digit mobile (e.g. 9876543210)"
                    style={{width:"100%",border:"1.5px solid #E2E8F0",borderRadius:8,padding:"9px 12px",fontSize:14,boxSizing:"border-box",marginBottom:8}} />
                  <div style={{fontSize:11,color:"#94A3B8",textAlign:"center"}}>Country code +91 is added automatically. You can change this anytime in Settings.</div>
                </div>
              )}
              {onboardStep===4&&(
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:56,marginBottom:16}}>🎉</div>
                  <div style={{fontSize:22,fontWeight:900,color:"#0F172A",marginBottom:8,letterSpacing:"-0.5px"}}>You&#39;re all set!</div>
                  <div style={{fontSize:14,color:"#64748B",lineHeight:1.7,marginBottom:20}}>SmartCABuddy is ready to use. Start by adding your first cheque entry or import existing data via Bulk Import.</div>
                  <div style={{background:"#F0F9FF",borderRadius:10,padding:14,marginBottom:20,textAlign:"left"}}>
                    <div style={{fontWeight:700,fontSize:12,color:"#0369A1",marginBottom:8}}>Quick Tips:</div>
                    <div style={{fontSize:12,color:"#64748B",lineHeight:1.8}}>
                      • Use <strong>+ Add Cheque</strong> to enter cheques one by one<br/>
                      • Use <strong>Bulk Import</strong> to upload existing data via Excel<br/>
                      • <strong>Action Required</strong> shows all pending and bounced items<br/>
                      • <strong>💬 WhatsApp Send</strong> sends day-end summary to your number
                    </div>
                  </div>
                </div>
              )}

              <div style={{display:"flex",gap:10,marginTop:4}}>
                {onboardStep>0&&<button onClick={()=>setOnboardStep(s=>s-1)} style={{flex:1,padding:"11px",border:"1.5px solid #E2E8F0",borderRadius:10,background:"white",cursor:"pointer",fontWeight:700,fontSize:13,color:"#475569"}}>← Back</button>}
                <button onClick={()=>{ if(onboardStep<4) setOnboardStep(s=>s+1); else setShowOnboard(false); }}
                  style={{flex:2,padding:"11px",border:"none",borderRadius:10,background:"linear-gradient(135deg,#3B82F6,#8B5CF6)",color:"white",cursor:"pointer",fontWeight:800,fontSize:13}}>
                  {onboardStep<4?"Continue →":"Start Using CMS 🚀"}
                </button>
              </div>
              {onboardStep<4&&<button onClick={()=>setShowOnboard(false)} style={{width:"100%",marginTop:8,background:"none",border:"none",color:"#94A3B8",fontSize:11,cursor:"pointer"}}>Skip setup</button>}
            </div>
          </div>
        </div>
      )}

      {/* ══ BOUNCE CONFIRM ══ */}
      {confirmBounce && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300,padding:16}}>
          <div style={{background:"white",borderRadius:14,width:"100%",maxWidth:400,padding:28,boxShadow:"0 20px 50px rgba(0,0,0,0.3)"}}>
            <div style={{fontSize:32,textAlign:"center",marginBottom:12}}>❌</div>
            <div style={{fontWeight:800,fontSize:15,color:"#0F172A",textAlign:"center",marginBottom:8}}>Mark as Bounced?</div>
            <div style={{fontSize:13,color:"#64748B",textAlign:"center",marginBottom:22,lineHeight:1.6}}>This marks the cheque as <strong>Bounced</strong> and clears the realisation date.<br/>Note the return reason before confirming.</div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setConfirmBounce(null)} style={{flex:1,padding:"10px",border:"1.5px solid #E2E8F0",borderRadius:8,background:"white",cursor:"pointer",fontWeight:700,fontSize:13,color:"#475569"}}>Cancel</button>
              <button onClick={()=>{applyStatus(confirmBounce.id,"Bounced");setConfirmBounce(null);}} style={{flex:1,padding:"10px",border:"none",borderRadius:8,background:"#DC2626",color:"white",cursor:"pointer",fontWeight:800,fontSize:13}}>Confirm Bounced</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ TOAST ══ */}
      {toast && (
        <div style={{position:"fixed",bottom:22,right:22,background:toast.type==="error"?"#DC2626":"#059669",color:"white",padding:"11px 18px",borderRadius:10,fontWeight:700,fontSize:13,boxShadow:"0 4px 20px rgba(0,0,0,0.25)",zIndex:999,display:"flex",alignItems:"center",gap:7}}>
          <span style={{fontSize:16}}>{toast.type==="error"?"✕":"✓"}</span>{toast.msg}
        </div>
      )}

    </div>
  );
}
